import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useClient } from "../../../../Context/ClientContext";
import {
  Avatar,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Dropdown,
  Empty,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  Skeleton,
  Space,
  Spin,
  Tag,
  Tooltip,
  Typography,
  Upload,
} from "antd";
import noteContext from "../../../../Context/StyleContext";
import { notificationContext } from "../../../../Common/Routing/PageRoute";
import {
  handleDecimalValues,
  handleInputFocus,
  updateListWithNewValue,
  Utils,
} from "../../../../../Utilities/Utils";
import { percentCal, percentToRs } from "../../../../Common/CAPComponents";
import {
  BarcodeOutlined,
  DownOutlined,
  EditOutlined,
  EyeOutlined,
  LoadingOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import VoucherServices, {
  AddressEnum,
  convertToDays,
  FreightTypeOptions,
  ITCEligibility_Type,
  Party_Tax,
  Voucher_Nature,
  Voucher_Type,
  voucherNatureOptions,
} from "../../../../Services/VoucherServices";
import { dayjs } from "../../../../../Utilities/dayjs";
import LedgerService, {
  ILedgerSearchByGroupNameResponse,
  LedgerStatus,
  PartyType,
  SearchLedgerByGroupsTypes,
  TypeOfAddress,
} from "../../../../Services/LedgerService";
import TextArea from "antd/es/input/TextArea";
import { getIndianStates } from "../../../../Services/ClientService";
import { ConfirmationModal } from "../../../../Common/ConfirmationModal";
import deleteImg from "../../../../../images/deletebutton.svg";
import AddItems from "../../../Items/AddItems";
import { AddLedger } from "../../../Master/Ledger/AddLedger";
import QuotationServices from "../../../../Services/QuotationServices";
// import { CompanyGSTTypes } from "../../../Types";
import { CompanyGSTTypes } from "../../../../../Types/CommonConstants";
import {
  SalesDropdownItems,
  PurchaseDropdownItems,
} from "../../InvoiceAndPurchaseBill/Add/SalesPurchaseAndExpensesDropdownList";
import EntryLevelKeys from "../../../../Common/EntryLevelKeys";
import { returnNetAmount } from "../../InvoiceAndPurchaseBill/Add/AddSalesInvoiceAndPurchaseBill";
import {
  Discount_Policy,
  RoundOff_Type,
  SettingsSections,
  TimeUnits,
  vouchersSettings,
} from "../../../../Services/SettingService";
import DraftService from "../../../../Services/DraftService";
import TermsAndConditionModal from "../../../Settings/TermsAndCondition/VouchersTermsAndConditionModal";
import DocumentPreview from "../../../../Common/DocumentPreview";
import { useUser } from "../../../../../Context/UserContext";
import { useTheme } from "../../../../Context/ThemeContext";
import Layout, { Content, Footer, Header } from "antd/es/layout/layout";
import TdsTcsServices, {
  ITDSDetail,
  Transaction_Type,
} from "../../../../Services/TdsTcsServices";
import ItemsService, {
  CAPItemTypes,
  DiscountSalesType,
  Item_Nature,
} from "../../../../Services/ItemsService";
import { allCountriesStates } from "../../../../../Types/CommonAllCountriesStates";
import { PanCardType } from "../../../../Services/PurchaseService";
import CurrencyServices from "../../../../Services/CurrencyServices";
import { findUserOnlyOnePremission } from "../../../Users/Roles/UserSecurityFind";
import { ShowPriceHistoryDataView } from "../../ItemPriceHistory/ShowPriceHistoryDataView";
import { handleRoundoff } from "../../../../Common/Calculation/HandleRoundoff";
import { partyIsGstType } from "../../../../Common/Party/PartyIsGstType";
import { findVoucharCustomizationTemplete } from "../../../../Common/Vouchar/FindVoucharCustomizationTemplete";
import { useHotkey } from "../../../../Context/HotKeyContext";

const AddOrderEstimateProformaInvoice = () => {
  const { showKeys } = useHotkey();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const themeData: any = useTheme();
  const location = useLocation();
  const inputRef: any = useRef(null);
  const { getAllIndStates, clientSpecificRole } = useUser();
  const stateOptions: any = getAllIndStates();
  const { windowWidth } = useContext(noteContext);
  const { currentClient, companySettings } = useClient();

  const {
    // updateId,
    // purchaseOrderId,
    id,
    // salesOrderId,
    quotationId,
    draftId,
    // proformaId,
  } = useParams();
  const { openNotification } = useContext(notificationContext);

  let splitPathInVchType: Voucher_Type =
    location.pathname.split("/")[5] === "addProformaInvoice" ||
    location.pathname.split("/")[5] === "editProformaInvoice" ||
    location.pathname.split("/")[5] === "editProformaInvoiceDraft"
      ? Voucher_Type.PInvoice
      : location.pathname.split("/")[5] === "addEstimate" ||
        location.pathname.split("/")[5] === "editEstimate" ||
        location.pathname.split("/")[5] === "editEstimateDraft"
      ? Voucher_Type.Quotation
      : location.pathname.split("/")[4] === "sales"
      ? Voucher_Type.SalesOrder
      : Voucher_Type.PurchaseOrder;

  const [dueOn, setDueOn] = useState<number>(0);
  const [balance, setBalance] = useState<number>(0);
  const [totalTcs, setTotalTcs] = useState<number>(0);
  const [totalTds, setTotalTds] = useState<number>(0);
  const [tdsOrTcs, setTdsOrTcs] = useState<number>(0);
  // const [totalgst, setTotalgst] = useState<number>(0);
  // const [totalQty, setTotalQty] = useState<number>(0);
  const [itemId, setItemId] = useState<any>();
  const [batchData, setBatchData] = useState<any[]>([]);
  const [batchItmName, setBatchItmName] = useState<any>("");
  const [serialNoData, setSerialNoData] = useState<any[]>([]);
  const [checkedType, setCheckedType] = useState<any>();
  const [itmData, setItmData] = useState<any[]>([]);
  const [isOpenDueDate, setIsDueDate] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [itemLength, setItemLength] = useState<number>(0);
  const [isPartyCompany, setIsPartyCompany] = useState<PartyType>(
    PartyType.IndividualPerson
  );
  const [estimateNo, setEstimateNo] = useState<string>("");
  const [searchItem, setSearchItem] = useState<string>("");
  const [isInCash, setIsInCash] = useState<boolean>(false);
  const [itemsOption, setItemsOption] = useState<any[]>([]);
  const [account, setAccount] = useState<any[]>([]);
  const [deleteItemList, setDeleteItemList] = useState<any>();
  const [currencyList, setCurrencyList] = useState<any[]>([]);
  const [showPriceHistoryLoading, setShowPriceHistoryLoading] =
    useState<boolean>(false);
  const [showPriceHistory, setShowPriceHistory] = useState<boolean[]>([]);
  const [showPriceHistoryData, setShowPriceHistoryData] = useState<any>();
  const [purchaseOrderRef, setPurchaseOrderRef] = useState<string | null>(null);
  const [purchaseOrderRefTrigger, setPurchaseOrderRefTrigger] =
    useState<number>(0);
  // const [invoiceTotal, setInvoiceTotal] = useState<number>(0.0);
  // const [salesOrderNo, setSalesOrderNo] = useState<string>("");
  // const [salesInvoiceNo, setSalesInvoiceNo] = useState<any>("");
  const [editParty, setEditParty] = useState<{ id: string }>({ id: "" });
  const [selectedParty, setSelectedParty] = useState<string>("");
  const [purchaseOrderDate, setPurchaseOrderDate] = useState<string>("");
  const [isGSTEnabled, setGstEnabled] = useState<boolean>(true);
  const [confirmation, setConfirmation] = useState<boolean>(false);
  const [ledgerconfirmation, setLedgerConfirmation] = useState<boolean>(false);
  const [tcsModelOpen, setTcsModelOpen] = useState<boolean>(false);
  const [tdsModelOpen, setTdsModelOpen] = useState<boolean>(false);
  const [customerOptions, setCustomerOptions] = useState<any[]>([]);
  const [updateInPartyId, setUpdateInPartyId] = useState<string>("");
  const [onlyEditTimeCustomerOptions, setOnlyEditTimeCustomerOptions] =
    useState<boolean>(false);
  // const [addressList, setAddressList] = useState<any[]>([]);
  const [effectiveLedger, setEffectiveLedger] = useState<
    ILedgerSearchByGroupNameResponse[]
  >([]);
  const [currentCustomerState, setCurrentCustomerState] = useState<number>(
    currentClient?.state!
  );
  const [purchasePartyState, setPurchasePartyState] = useState<number>(
    currentClient?.state!
  );
  const [orderListOptions, setOrderListOptions] = useState<
    { voucherId: string; voucherNumber: string }[]
  >([]);
  const [orderDropDownLoading, setOrderDropDownLoading] =
    useState<boolean>(false);
  const [voucherNumberLoader, setVoucherNumberLoader] = useState(false);
  const [saveButtonLoading, setSaveButtonLoading] = useState<boolean>(false);
  const [saveNewLoading, setSaveNewLoading] = useState<boolean>(false);
  const [updateTimeShowFreightIns, setUpdateTimeShowFreightIns] =
    useState<boolean>(false);
  const [selectedBatchData, setSelectedBatchData] = useState<any>();
  const [triggerSerialData, setTriggerSerialData] = useState<boolean>(false);
  const [batchItmId, setBatchItmId] = useState<any>();
  const [triggerBatchData, setTriggerBatchData] = useState<boolean>(false);
  const [forAddBatchData, setForAddBatchData] = useState<any[]>([]);
  const [forAddSerialData, setForAddSerialData] = useState<any[]>([]);
  const [serial, setSerial] = useState<any[]>([]);
  const [refreshDeleteBatch, setRefreshDeleteBatch] = useState<boolean>(false);
  const [batchQty, setBatchQty] = useState<any[]>([]);
  const [addBatches, setAddBatches] = useState<any>([]);
  const [clickedIndex, setClickedIndex] = useState<number | null>(null);
  const [index, setIndex] = useState<number | null>(null);
  const [alReadySelectedData, setAlReadySelectedData] = useState<any[]>([]);
  const [customerAddress, setCustomerAddress] = useState<any>(
    splitPathInVchType === Voucher_Type.SalesOrder ||
      splitPathInVchType === Voucher_Type.PInvoice ||
      splitPathInVchType === Voucher_Type.Quotation
      ? []
      : currentClient?.addresses
  );
  const [
    partyIsGstRegisteredSalesInvoice,
    setPartyIsGstRegisteredSalesInvoice,
  ] = useState<CompanyGSTTypes>(CompanyGSTTypes.Regular);
  const [
    partyIsGstRegisteredSalesInvoiceTrigger,
    setPartyIsGstRegisteredSalesInvoiceTrigger,
  ] = useState<number>(0);

  const [openModel, setOpenModel] = useState<{ type: string; param: any }>({
    type: "",
    param: {},
  });
  const [apiCallField, setApiCallField] = useState("");
  const [newItem, setNewItem] = useState<{
    data: any;
    isSaved: boolean;
    isEdited: boolean;
  }>({
    data: {},
    isSaved: false,
    isEdited: false,
  });
  const [itemFields, setItemFields] = useState<any>({
    field: 0,
    index: 0,
    add: null,
  });
  const [ledgerItemFields, setLedgerItemFields] = useState<{
    field: number;
    index: number;
  }>({
    field: 0,
    index: 0,
  });
  const [searchCustomer, setSearchCustomer] = useState<{
    search: string;
    length: number;
  }>({
    search: " ",
    length: 15,
  });

  const [footerTotal, setFooterTotal] = useState<{
    qty: number;
    unitPrice: number;
    taxableAmount: number;
    discount: number;
    gst: number;
    amount: number;
  }>({
    qty: 0,
    unitPrice: 0,
    taxableAmount: 0,
    discount: 0,
    gst: 0,
    amount: 0,
  });

  const [footerLedger, setFooterLedger] = useState<{
    ledgerAmount: number;
    ledgerGstAmount: number;
    ledgerTotalAmount: number;
  }>({
    ledgerAmount: 0,
    ledgerGstAmount: 0,
    ledgerTotalAmount: 0,
  });

  // const [directExpenses, setDirectExpenses] = useState<boolean>(false);
  const [ledgerLength, setLedgerLength] = useState<number>(0);
  const [freightAndInsuranceOptions, setFreightAndInsuranceOptions] = useState<
    ILedgerSearchByGroupNameResponse[]
  >([]);
  const [deleteLedgerList, setDeleteLedgerList] = useState<any>();
  const [ledgerAmount, setLedgerAmount] = useState<any>();
  const [showFreightInsurance, setShowFreightInsurance] =
    useState<boolean>(false);
  const [currentInvoiceDetails, setCurrentInvoiceDetails] = useState<any>();

  const [transactionId, setTransactionId] = useState<{
    partyId: string;
    effectiveId: string;
  }>({ partyId: "", effectiveId: "" });
  const [selectedOtherExpenses, setSelectedOtherExpenses] = useState<any[]>([]);
  const [dateFiled, setDateFiled] = useState<any>();
  const [editDate, setEditDate] = useState<any>();
  const [roundOffAmount, setRoundoffAmount] = useState<number>(0.0);
  const [underLUT, setUnderLUT] = useState<boolean>(false);
  const [updateTimeData, setUpdateTimeData] = useState<{
    contactDetails: boolean;
    shippingAddress: boolean;
    friInsuranceOtherCharge: boolean;
    receipt: boolean;
    cashDiscount: boolean;
    tradeDiscount: boolean;
    isGSTVoucher: boolean;
    showItemDescription: boolean;
    roundOff: boolean;
    showFreightType: boolean;
    showRCM: boolean;
    manualNumbering: boolean;
    voucherNature: Voucher_Nature;
  }>({
    contactDetails: false,
    shippingAddress: false,
    friInsuranceOtherCharge: false,
    receipt: false,
    cashDiscount: false,
    tradeDiscount: false,
    isGSTVoucher: false,
    showItemDescription: false,
    roundOff: false,
    showFreightType: false,
    showRCM: false,
    manualNumbering: false,
    voucherNature: Voucher_Nature.Regular,
  });
  const [isSameBillingAddress, setIsSameBillingAddress] =
    useState<boolean>(false);
  const [deleteUploadId, setDeleteUploadId] = useState<string[]>([]);
  const [voucherNature, setVoucherNature] = useState<Voucher_Nature>(
    Voucher_Nature.Regular
  );
  const [tdsList, setTdsList] = useState<ITDSDetail[]>([]);
  const [tcsList, setTcsList] = useState<any[]>([]);
  const [tdsPostDetail, setTdsPostDetail] = useState<{
    id: string;
    formNo: string;
    transactionType: Transaction_Type;
  }>({ id: "", formNo: "", transactionType: Transaction_Type.Domestic });

  const [tcsTdsPercentage, setTcsTdsPercentage] = useState<number>(0.0);
  const [isPartTDSOrTDS, setIsPartTDSOrTDS] = useState<{
    tds: Boolean;
    tcs: Boolean;
  }>({ tds: false, tcs: false });
  const [partyIsGstRegistered, setPartyIsGstRegistered] =
    useState<CompanyGSTTypes>(CompanyGSTTypes.Regular);
  const [partyIsGstRegisteredTrigger, setPartyIsGstRegisteredTrigger] =
    useState<number>(0);
  const [partyIsGstRegisteredSales, setPartyIsGstRegisteredSales] =
    useState<CompanyGSTTypes>(CompanyGSTTypes.Regular);
  const [
    partyIsGstRegisteredSalesTrigger,
    setPartyIsGstRegisteredSalesTrigger,
  ] = useState<number>(0);
  const [partyPanCard, setPartyPanCard] = useState<PanCardType>(
    PanCardType.notAvailable
  );
  const [trigger, setTrigger] = useState(false);
  const [loadItemAPI, setloadItemAPI] = useState<boolean>(false);

  const getVoucherTitle =
    splitPathInVchType === Voucher_Type.PInvoice
      ? companySettings?.setting?.vouchersSettings.find(
          (x: any) => x?.settingType === SettingsSections.PInvoice
        )
      : splitPathInVchType === Voucher_Type.SalesOrder
      ? companySettings?.setting?.vouchersSettings.find(
          (x: any) => x?.settingType === SettingsSections.SOrder
        )
      : splitPathInVchType === Voucher_Type.Quotation
      ? companySettings?.setting?.vouchersSettings.find(
          (x: any) => x?.settingType === SettingsSections.Quotation
        )
      : companySettings?.setting?.vouchersSettings.find(
          (x: any) => x?.settingType === SettingsSections.POrder
        );

  const [selectCustomizationTemplete, setSelectCustomizationTemplete] =
    useState<{
      templateId: number;
      title: string;
    }>({
      templateId: getVoucherTitle?.id!,
      title: getVoucherTitle?.settings?.orderSettings?.titleToBePrint,
    });

  const [termsAndConditionField, setTermsAndConditionField] = useState<any>({
    tnCTemplateId: getVoucherTitle?.settings?.orderSettings?.tnCTemplateId,
    termsnConditions: getVoucherTitle?.settings?.orderSettings?.tnCTemplateId,
  });
  const [previewImage, setPreviewImage] = useState<{
    isBaseConvert: boolean;
    path: any;
  }>({ isBaseConvert: false, path: "" });
  const [settingControl, setSettingControl] = useState<{
    title?: string;
    templateId: number;
    titleToBePrint?: string;
    // showContactDetail: boolean;
    discountPolicy: Discount_Policy;
    showOtherCharges: boolean;
    showShippingAddress: boolean;
    showItemDescription: boolean;
    autoRoundOff: boolean;
    showPriceHistory: boolean;
    roundOffType: RoundOff_Type;
    showFreightType: boolean;
    showRCM: boolean;
    manualNumbering: boolean;
    showTcs: boolean;
    showTds: boolean;
    defaultNature: Voucher_Nature;
    // showReceipt: boolean;
    // showDispatchDetail: boolean;
  }>({
    title: getVoucherTitle?.title!,
    templateId: getVoucherTitle?.id!,
    titleToBePrint:
      splitPathInVchType === Voucher_Type.PurchaseOrder
        ? getVoucherTitle?.settings?.billSettings?.titleToBePrint
        : getVoucherTitle?.settings?.invoiceSettings?.titleToBePrint,
    discountPolicy: getVoucherTitle?.settings?.orderSettings?.discountPolicy,
    showOtherCharges:
      getVoucherTitle?.settings?.orderSettings?.showOtherCharges,
    showShippingAddress:
      getVoucherTitle?.settings?.orderSettings?.showShippingAddress,
    showItemDescription:
      getVoucherTitle?.settings?.orderSettings?.showItemDescription,
    autoRoundOff: getVoucherTitle?.settings?.orderSettings?.autoRoundOff,
    showPriceHistory:
      getVoucherTitle?.settings?.orderSettings?.showPriceHistory,
    roundOffType: getVoucherTitle?.settings?.orderSettings?.roundOffType,
    showFreightType: getVoucherTitle?.settings?.orderSettings?.showFreightType,
    showRCM: getVoucherTitle?.settings?.orderSettings?.showRCM!,
    manualNumbering: getVoucherTitle?.settings?.orderSettings?.manualNumbering!,
    showTcs: currentClient?.tcsApplicability!,
    showTds: currentClient?.tdsDeductible!,
    defaultNature: getVoucherTitle?.settings?.orderSettings?.defaultNature,
  });
  // const gstOption = companySettings?.setting?.gstDetails?.gst;
  const gstOption = companySettings?.gsts;
  const itemSetting = companySettings?.setting?.item;
  const [isStateSame, setIsStateSame] = useState<boolean>(
    splitPathInVchType === Voucher_Type.SalesOrder ||
      splitPathInVchType === Voucher_Type.PInvoice ||
      splitPathInVchType === Voucher_Type.Quotation
      ? currentCustomerState === currentClient?.state!
      : (currentCustomerState ?? currentClient?.state!) === purchasePartyState
  );

  const [partyDropDownLoading, setPartyDropDownLoading] = useState(false);
  const [salesLedDropDownLoading, setSalesLedDropDownLoading] = useState(false);
  const [itmLedDropDownLoading, setItmLedDropDownLoading] = useState(false);
  const [itemSearch, setItemSearch] = useState<string>("");
  const [barCodeSearch, setBarCodeSearch] = useState<string>("");
  const [isBarCodeSearch, SetIsBarCodeSearch] = useState<boolean>(false);

  const amountInNumber = (val: any, key: any) => {
    return Utils.getNumber(val?.amount?.[key]);
  };

  const price = (curr: any) => amountInNumber(curr, "price");
  const qty = (curr: any) => amountInNumber(curr, "qty");
  const discount = (curr: any) => amountInNumber(curr, "discount");
  const taxRate = (curr: any) => Utils.getNumber(curr?.amount?.tax?.title);
  const netAmount = (curr: any) => price(curr) * qty(curr);

  const discountRupee = (curr: any, percentDiscountAll?: number) => {
    if (percentDiscountAll || percentDiscountAll === 0) {
      return percentCal(netAmount(curr), percentDiscountAll);
    } else return percentCal(netAmount(curr), discount(curr));
  };

  const amountWithoutTax = (curr: any, percentDiscountAll?: number) =>
    netAmount(curr) - discountRupee(curr, percentDiscountAll);

  const itemTaxAmt = (curr: any, percentDiscountAll?: number) =>
    percentCal(amountWithoutTax(curr, percentDiscountAll), taxRate(curr));

  const amountWithTax = (curr: any, percentDiscountAll?: number) =>
    amountWithoutTax(curr, percentDiscountAll) +
    itemTaxAmt(curr, percentDiscountAll);

  // const amountWithOutTax = (curr: any) => amountWithoutTax(curr);
  const amount = (curr: any) => amountInNumber(curr, "amount");
  const gstrate = (curr: any) => Utils.getNumber(curr?.gstRate?.title);
  const gstamount = (curr: any) => percentCal(curr?.amount, gstrate(curr));
  const ledgertotalamout = (curr: any) =>
    Utils.getNumber(curr?.amount) + gstamount(curr);
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  // Date Api
  useEffect(() => {
    const getDate = async () => {
      if (currentClient?.id && !quotationId) {
        await VoucherServices.getMaxVoucherDate(
          currentClient?.id!,
          Voucher_Type.Quotation
        ).then((res) => {
          const givenDate = new Date(res?.result);
          const currentTime = new Date();

          // Set the time part of givenDate to match currentTime
          givenDate?.setHours(
            currentTime.getHours(),
            currentTime.getMinutes(),
            currentTime.getSeconds(),
            currentTime.getMilliseconds()
          );
          form.setFieldValue("date", dayjs(givenDate));

          setDateFiled(res.result);
        });
      }
    };
    getDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id]);

  // update the IsStateSame
  useEffect(() => {
    setIsStateSame(purchasePartyState === currentCustomerState);
  }, [currentCustomerState, purchasePartyState]);

  //getVoucherMaxNo initital value
  useEffect(() => {
    if (
      (currentClient?.id &&
        dateFiled &&
        // !salesOrderId &&
        !id) ||
      quotationId
    ) {
      if (!settingControl.manualNumbering) {
        setLoading(true);
        setVoucherNumberLoader(true);
        VoucherServices.getVoucherMaxNo(
          currentClient?.id!,
          splitPathInVchType,
          dayjs(dateFiled).endOf("day").toISOString(),
          getVoucherTitle?.id!
        )
          .then((res) => {
            form.setFieldValue("number", res?.result);
            setVoucherNumberLoader(false);
            if (!id) {
              setLoading(false);
            }
          })
          .catch((err: any) => {
            openNotification("error", err.message);
            setVoucherNumberLoader(false);
            setLoading(false);
            console.error(err.message);
          });
      } else {
        form.setFieldValue("number", "");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id, dateFiled, splitPathInVchType, settingControl]);

  // ----- Serch customer Api ------
  useEffect(() => {
    // setDropDownLoading({ ...dropDownLoading, party: true });
    setLoading(true);
    setPartyDropDownLoading(true);
    LedgerService.getLedgersByGroupName(
      currentClient?.id!,
      SearchLedgerByGroupsTypes.PartiesOnly
    )
      .then((res: any) => {
        if (res) {
          setCustomerOptions(res);
          setOnlyEditTimeCustomerOptions(true);
          setPartyDropDownLoading(false);
          console.log(customerOptions, "getledger");
          if (!quotationId) {
            setLoading(false);
          }
        } else {
          setPartyDropDownLoading(false);
          setLoading(false);
        }
      })
      .catch((ex: any) => {
        console.error(ex);
        setLoading(false);

        setPartyDropDownLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id]);

  // ----- Serch effectiveLedger Api ------
  useEffect(() => {
    setSalesLedDropDownLoading(true);
    LedgerService.getLedgersByGroupName(
      currentClient?.id!,
      splitPathInVchType === Voucher_Type.PurchaseOrder
        ? SearchLedgerByGroupsTypes.Purchase
        : SearchLedgerByGroupsTypes.Sales
    )
      .then((res: any) => {
        if (res) {
          setEffectiveLedger(res);
          setSalesLedDropDownLoading(false);
        } else {
          setSalesLedDropDownLoading(false);
        }
      })
      .catch((ex: any) => {
        console.error(ex);
        setSalesLedDropDownLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id, splitPathInVchType]);

  // Edit get api
  useEffect(() => {
    if ((id || quotationId || draftId) && customerOptions?.length > 0) {
      const editData = async (id: any, type: Voucher_Type) => {
        setLoading(true);
        try {
          const res = draftId
            ? await DraftService.getByDraftId(currentClient?.id!, draftId)
            : await QuotationServices.getQuotationId(
                currentClient?.id!,
                id,
                type
              );

          if (res?.result) {
            // console.log("true............", res.result?.partyLedger[0]?.ref);
            res.result?.purchaseOrderRef?.date &&
              setPurchaseOrderDate(res.result?.purchaseOrderRef?.date);
            setSelectCustomizationTemplete({
              templateId: res?.result?.voucherTitle?.id,
              title: res?.result?.voucherTitle?.name,
            });
            // setIsCustomNumber(res?.result?.isCustomNumber);
            setVoucherNature(res.result?.nature);
            setTermsAndConditionField(res?.result?.termsNConditions);
            setIsSameBillingAddress(res?.result?.isShippingAddressSame);
            const partyDetail = customerOptions.find(
              (x) => x.id === res.result?.partyLedger[0]?.id
            );
            setIsPartyCompany(partyDetail?.partyType);
            setFooterTotal({
              qty: res.result?.amountSummary?.totalQty,
              unitPrice: res.result?.amountSummary?.totalPrice,
              taxableAmount:
                res.result?.amountSummary?.taxableAmount +
                res.result?.amountSummary?.totalDis,
              discount: res.result?.amountSummary?.totalDis,
              gst: res.result?.amountSummary?.totalItemGSTAmt,
              amount:
                Math.abs(res.result?.effectiveLedger[0]?.amount) +
                (partyDetail?.gstType === CompanyGSTTypes.Overseas ||
                partyDetail?.gstType === CompanyGSTTypes.SEZ
                  ? 0
                  : res.result?.amountSummary?.totalItemGSTAmt),
            });
            setFooterLedger({
              ledgerAmount: res.result?.amountSummary?.cifExpenses,
              ledgerGstAmount: res.result?.amountSummary?.totalCIFGSTAmt,
              ledgerTotalAmount:
                res.result?.amountSummary?.cifExpenses +
                res.result?.amountSummary?.totalCIFGSTAmt,
            });
            setRoundoffAmount(
              res.result?.amountSummary?.roundOff?.roundOffAmount ?? 0
            );
            setTotalTds(res.result?.amountSummary?.tdsAmt);
            setTotalTcs(res.result?.amountSummary?.tcsAmt);
            setTdsOrTcs(res.result?.tcsApplicable ? 1 : 0);
            setTcsTdsPercentage(
              res.result?.tcsApplicable
                ? res.result?.tcsDetail?.rate
                : res.result?.tdsDetail?.rate
            );
            res.result?.tdsApplicable &&
              setTdsPostDetail({
                id: res.result?.tdsDetail?.id,
                formNo: res.result?.tdsDetail?.form,
                transactionType: res.result?.tdsDetail?.transactionType,
              });
            if (splitPathInVchType === Voucher_Type.PurchaseOrder) {
              setCurrentCustomerState(res.result?.billState);
              setPurchasePartyState(res.result?.supplyState);
              setPartyIsGstRegistered(partyDetail?.gstType);
            } else {
              setPurchasePartyState(res.result?.supplyState);
              setPartyIsGstRegisteredSales(partyDetail?.gstType);
              setPartyIsGstRegisteredSalesInvoiceTrigger((x) => x + 1);
            }
            splitPathInVchType === Voucher_Type.PurchaseOrder &&
              setTransactionId({
                partyId: res.result?.partyLedger[0]?.transactionId,
                effectiveId: res.result?.effectiveLedger[0]?.transactionId,
              });
            setUnderLUT(res.result.underLUT ?? false);

            const Items = res.result?.items?.map((itm: any) => {
              return {
                ...itm,
                trackingType: itm?.trackingType,
                amount: {
                  ...itm?.amount,
                  itemTaxAmt:
                    partyDetail?.gstType === CompanyGSTTypes.Overseas ||
                    partyDetail?.gstType === CompanyGSTTypes.SEZ
                      ? 0
                      : itm?.amount?.itemTaxAmt,
                  totalAmount:
                    partyDetail?.gstType === CompanyGSTTypes.Overseas ||
                    partyDetail?.gstType === CompanyGSTTypes.SEZ
                      ? itm?.amount?.grossAmount
                      : itm?.amount?.totalAmount,
                  unit: {
                    label: itm?.amount?.unit?.name,
                    value: itm?.amount?.unit?.id,
                    unitType: itm?.amount?.unit?.unitType,
                  },
                  tax: {
                    title: itm?.amount?.tax?.rate,
                    label: itm?.amount?.tax?.name,
                    value: itm?.amount?.tax?.id,
                  },
                  hideTax: {
                    title: itm?.amount?.tax?.rate,
                    label: itm?.amount?.tax?.name,
                    value: itm?.amount?.tax?.id,
                  },
                },
              };
            });
            setItemLength(res.result.items.length);
            const filterFreightInsLedger =
              res.result?.freightInsLedgers?.filter(
                (x: any) => x?.partyOrTax !== 7 && x?.partyOrTax !== 6
              );
            setShowFreightInsurance(filterFreightInsLedger?.length > 0);
            // setUpdateTimeShowFreightIns(filterFreightInsLedger?.length > 0);
            const freightInsLedgers: any[] = filterFreightInsLedger?.map(
              (exp: any) => {
                setSelectedOtherExpenses((select) => [...select, exp?.id]);
                return {
                  ...exp,
                  id: {
                    value: exp?.id,
                    label: exp?.ledgerName,
                  },
                  amount: Math.abs(exp?.amount),
                  transactionId: exp?.transactionId,
                  gstRate: {
                    value: exp?.gstRate?.id,
                    title: exp?.gstRate?.rate,
                    label: exp?.gstRate?.name,
                  },
                };
              }
            );
            setLedgerLength(freightInsLedgers?.length ?? 1);
            setSelectedParty(res.result?.partyLedger[0]?.id);

            setEditDate(res.result?.date);

            setUpdateTimeData({
              contactDetails:
                res.result?.contactName || res.result?.contactNo ? true : false,
              shippingAddress:
                res.result?.shippingAddress?.address ||
                res.result?.shippingAddress?.type
                  ? true
                  : false,
              friInsuranceOtherCharge: freightInsLedgers?.length > 0,
              // receipt: bankDtsGet?.length > 0,
              receipt: false,
              cashDiscount: false,
              tradeDiscount: res.result?.amountSummary?.totalDis > 0,
              isGSTVoucher: res.result?.isGSTVoucher,
              showItemDescription: res.result?.showItemDescription,
              roundOff:
                res.result?.amountSummary?.roundOff?.roundOffApplicable ||
                res.result?.amountSummary?.roundOff?.roundOffAmount !== 0,
              showFreightType: res.result?.freightType ? true : false,
              showRCM: res.result?.nature,
              manualNumbering: res.result?.isCustomNumber,
              voucherNature: res.result?.nature,
            });

            const baseFormValues = {
              ...res?.result,
              supplierInvoiceDate: res.result?.supplierInvoiceDate
                ? dayjs(res.result?.supplierInvoiceDate)
                : undefined,
              currency: {
                value: res.result?.currency?.id,
                label: res.result?.currency?.name,
              },
              billingAddress: {
                ...res.result?.billingAddress,
                type: {
                  value: res.result?.billingAddress?.addressName,
                  lable: res.result?.billingAddress?.addressName,
                  title: res.result?.billingAddress?.type,
                },
              },
              shippingAddress: {
                ...res.result?.shippingAddress,
                type: {
                  value: res.result?.shippingAddress?.addressName,
                  lable: res.result?.shippingAddress?.addressName,
                  title: res.result?.shippingAddress?.type,
                },
              },
              tdsDetail: {
                value: res.result?.tdsDetail?.id,
                label: res.result?.tdsDetail?.name,
                title: res.result?.tdsDetail?.rate,
              },
              tcsDetail: {
                value: res.result?.tcsDetail?.id,
                label: res.result?.tcsDetail?.name,
                title: res.result?.tcsDetail?.rate,
              },
              freightType: res.result?.freightType
                ? res.result?.freightType
                : null,
              roundOff:
                res.result?.amountSummary?.roundOff?.roundOffAmount ?? 0,
              roundoffCheckbox:
                res.result?.amountSummary?.roundOff?.roundOffApplicable,
              showFreightInsLedgers: freightInsLedgers?.length > 0,
              items: [
                ...Items,
                { amount: { price: 0.0, qty: 0, grossAmount: 0 } },
              ],
              purchaseOrderRef: res.result?.purchaseOrderRef?.id && {
                value: res.result?.purchaseOrderRef?.id,
                label: res.result?.purchaseOrderRef?.name,
              },
              freightInsLedgers:
                freightInsLedgers?.length > 0
                  ? [
                      ...freightInsLedgers,
                      {
                        id: null,
                        // gstRate: 0,
                        gstAmount: 0,
                        totalAmount: 0,
                        amount: 0,
                      },
                    ]
                  : [
                      {
                        id: null,
                        // gstRate: 0,
                        gstAmount: 0,
                        totalAmount: 0,
                        amount: 0,
                      },
                    ],
              effectiveLedger: {
                value: res.result?.effectiveLedger[0]?.id,
                label: res.result?.effectiveLedger[0]?.ledgerName,
              },
              partyLedger: {
                value: res.result?.partyLedger[0]?.id,
                label: res.result?.partyLedger[0]?.ledgerName,
              },
              date: dayjs(res.result.date),
              dueDate: dayjs(
                dayjs(res.result.dueDate).format("DD/MM/YYYY"),
                "DD/MM/YYYY"
              ),
              // roundoffCheckbox: res.result?.amountSummary?.roundOff?.roundOffAmount !== 0,
              // cashDiscount:
              //   res.result?.amountSummary?.cashDiscount?.discountRate,
              // cashDiscountDrop:
              //   Number(res.result?.amountSummary?.cashDiscount?.discountRate) >
              //   0
              //     ? DiscountType.PercentageDiscount
              //     : DiscountType.RupeeDiscount,
              // narration: res?.result?.narration,
              // supplyState: res.result.supplyState,
              // receivedAmount: res.result.amountSummary?.receivedAmount,
              // paymentType: res.result.paymentType === 1 ? true : false,
            };

            if (quotationId) {
              form.setFieldsValue({
                ...baseFormValues,
              });
            } else {
              form.setFieldsValue({
                ...baseFormValues,
                number: res.result.number,
              });
            }
            setLoading(false);
          } else setLoading(false);
          setLoading(false);
        } catch (ex: any) {
          setLoading(false);
          console.error("Error..", ex);
          openNotification("error", ex);
        }
      };
      if (quotationId) {
        editData(quotationId, Voucher_Type.Quotation);
      } else if (id) {
        editData(id, splitPathInVchType);
        // } else if (proformaId) {
        //   editData(proformaId, Voucher_Type.PInvoice);
      } else {
        editData(draftId, splitPathInVchType);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, draftId, quotationId, customerOptions]);

  // Get Sales quotation get api to save order
  useEffect(() => {
    const getQuotationDetails = async (
      orderId: string | undefined,
      type: Voucher_Type,
      setOrderRef: boolean
    ) => {
      if (orderId) {
        // setLoading(true);
        await QuotationServices.getQuotationId(
          currentClient?.id!,
          orderId,
          type
        )
          .then((res: any) => {
            if (res?.result) {
              setPurchaseOrderDate(res?.result?.date);
              setTermsAndConditionField(res?.result?.termsNConditions);
              setVoucherNature(res.result?.nature);
              setIsSameBillingAddress(res?.result?.isShippingAddressSame);
              const party = customerOptions.find(
                (x) => x?.id === res.result?.partyLedger[0]?.id
              );
              setIsPartyCompany(party?.partyType);
              setSelectedParty(res.result?.partyLedger[0]?.id);
              setUpdateInPartyId(res.result?.partyLedger[0]?.id);
              // Tcs & Tds Party condition show & hinde
              setIsPartTDSOrTDS({
                tds: party?.deductTDSinSameVoucher,
                tcs: party?.ledgerTCSApplicability,
              });
              setFooterLedger({
                ledgerAmount: Utils.getNumber(
                  res.result?.amountSummary?.cifExpenses
                ),
                ledgerGstAmount: Utils.getNumber(
                  res.result?.amountSummary?.totalCIFGSTAmt
                ),
                ledgerTotalAmount: Utils.getNumber(
                  res.result?.amountSummary?.cifExpenses +
                    res.result?.amountSummary?.totalCIFGSTAmt
                ),
              });
              setRoundoffAmount(
                res.result?.amountSummary?.roundOff?.roundOffAmount ?? 0
              );
              setTotalTds(res.result?.amountSummary?.tdsAmt);
              setTotalTcs(res.result?.amountSummary?.tcsAmt);
              setTdsOrTcs(res.result?.tcsApplicable ? 1 : 0);
              setTcsTdsPercentage(
                res.result?.tcsApplicable
                  ? res.result?.tcsDetail?.rate
                  : res.result?.tdsDetail?.rate
              );
              res.result?.tdsApplicable &&
                setTdsPostDetail({
                  id: res.result?.tdsDetail?.id,
                  formNo: res.result?.tdsDetail?.form,
                  transactionType: res.result?.tdsDetail?.transactionType,
                });
              setPurchasePartyState(res.result?.supplyState);
              setPartyIsGstRegisteredSalesInvoice(party?.gstType);
              setPartyIsGstRegisteredSalesInvoiceTrigger((x) => x + 1);
              setUnderLUT(res.result.underLUT ?? false);

              const Items = res.result?.items?.map((itm: any) => {
                return {
                  ...itm,
                  trackingType: itm?.trackingType,
                  amount: {
                    ...itm?.amount,
                    qty: itm?.amount?.qty - itm?.amount?.suppliedQty,
                    itemTaxAmt:
                      party?.gstType === CompanyGSTTypes.Overseas ||
                      party?.gstType === CompanyGSTTypes.SEZ
                        ? 0
                        : itm?.amount?.itemTaxAmt,
                    totalAmount:
                      party?.gstType === CompanyGSTTypes.Overseas ||
                      party?.gstType === CompanyGSTTypes.SEZ
                        ? itm?.amount?.grossAmount
                        : itm?.amount?.totalAmount,
                    unit: {
                      label: itm?.amount?.unit?.name,
                      value: itm?.amount?.unit?.id,
                      unitType: itm?.amount?.unit?.unitType,
                    },
                    tax:
                      currentClient?.gstType === CompanyGSTTypes.Regular
                        ? {
                            title: itm?.amount?.tax?.rate,
                            label: itm?.amount?.tax?.name,
                            value: itm?.amount?.tax?.id,
                          }
                        : null,
                    hideTax: {
                      title: itm?.amount?.tax?.rate,
                      label: itm?.amount?.tax?.name,
                      value: itm?.amount?.tax?.id,
                    },
                  },
                };
              });
              setItemLength(Items?.length);
              const filterFreightInsLedger =
                res.result?.freightInsLedgers?.filter(
                  (x: any) => x?.partyOrTax !== 7 && x?.partyOrTax !== 6
                );
              setShowFreightInsurance(filterFreightInsLedger?.length > 0);
              setUpdateTimeShowFreightIns(filterFreightInsLedger?.length > 0);
              const freightInsLedgers: any[] = filterFreightInsLedger?.map(
                (exp: any) => {
                  setSelectedOtherExpenses((select) => [...select, exp?.id]);
                  return {
                    ...exp,
                    id: {
                      value: exp?.id,
                      label: exp?.ledgerName,
                    },
                    amount: Math.abs(exp?.amount),
                    transactionId: exp?.transactionId,
                    totalAmount:
                      party?.gstType === CompanyGSTTypes.Regular
                        ? Math.abs(exp?.totalAmount)
                        : exp?.amount,
                    gstAmount:
                      party?.gstType === CompanyGSTTypes.Regular
                        ? exp?.gstAmount
                        : 0,
                    gstRate:
                      currentClient?.gstType === CompanyGSTTypes.Regular &&
                      exp?.gstRate?.name
                        ? {
                            value: exp?.gstRate?.id,
                            title: exp?.gstRate?.rate,
                            label: exp?.gstRate?.name,
                          }
                        : null,
                    hideTax: exp?.gstRate?.name && {
                      value: exp?.gstRate?.id,
                      label: exp?.gstRate?.name,
                      title: exp?.gstRate?.rate,
                    },
                  };
                }
              );
              setLedgerLength(freightInsLedgers?.length ?? 1);
              setUpdateTimeData({
                contactDetails:
                  res.result?.contactName || res.result?.contactNo
                    ? true
                    : false,
                shippingAddress:
                  res.result?.shippingAddress?.address ||
                  res.result?.shippingAddress?.type
                    ? true
                    : false,
                friInsuranceOtherCharge: freightInsLedgers?.length > 0,
                receipt: false,
                cashDiscount: false,
                tradeDiscount: res.result?.amountSummary?.totalDis > 0,
                isGSTVoucher:
                  currentClient?.gstType === CompanyGSTTypes.Regular,
                showItemDescription: res.result?.showItemDescription,
                roundOff:
                  res.result?.amountSummary?.roundOff?.roundOffApplicable ||
                  res.result?.amountSummary?.roundOff?.roundOffAmount !== 0,
                showFreightType: res.result?.freightType ? true : false,
                manualNumbering: res.result?.isCustomNumber,
                showRCM:
                  res.result?.nature === Voucher_Nature.RCM ? true : false,
                voucherNature: res.result?.nature,
              });

              // console.log("e1", res.result);
              const { number, ...remainingFields } = res.result;
              form.setFieldsValue({
                remainingFields,
                supplierInvoiceDate: res.result?.supplierInvoiceDate
                  ? dayjs(res.result?.supplierInvoiceDate)
                  : undefined,
                currency: {
                  value: res.result?.currency?.id,
                  label: res.result?.currency?.name,
                },
                billingAddress: {
                  ...res.result?.billingAddress,
                  type: {
                    value: res.result?.billingAddress?.addressName,
                    lable: res.result?.billingAddress?.addressName,
                    title: res.result?.billingAddress?.type,
                  },
                },
                shippingAddress: {
                  ...res.result?.shippingAddress,
                  type: {
                    value: res.result?.shippingAddress?.addressName,
                    lable: res.result?.shippingAddress?.addressName,
                    title: res.result?.shippingAddress?.type,
                  },
                },
                supplyState: res.result?.supplyState,
                tdsDetail: {
                  value: res.result?.tdsDetail?.id,
                  label: res.result?.tdsDetail?.name,
                  title: res.result?.tdsDetail?.rate,
                },
                tcsDetail: {
                  value: res.result?.tcsDetail?.id,
                  label: res.result?.tcsDetail?.name,
                  title: res.result?.tcsDetail?.rate,
                },
                freightType: res.result?.freightType
                  ? res.result?.freightType
                  : null,
                showFreightInsLedgers: freightInsLedgers?.length > 0,
                roundOff:
                  res.result?.amountSummary?.roundOff?.roundOffAmount ?? 0,
                roundoffCheckbox:
                  res.result?.amountSummary?.roundOff?.roundOffApplicable,
                items: [
                  ...Items,
                  { amount: { price: 0.0, qty: 0, grossAmount: 0 } },
                ],
                freightInsLedgers:
                  freightInsLedgers?.length > 0
                    ? [
                        ...freightInsLedgers,
                        {
                          id: null,
                          // gstRate: 0,
                          gstAmount: 0,
                          totalAmount: 0,
                          amount: 0,
                        },
                      ]
                    : [
                        {
                          id: null,
                          // gstRate: 0,
                          gstAmount: 0,
                          totalAmount: 0,
                          amount: 0,
                        },
                      ],
                effectiveLedger: {
                  value: res.result?.effectiveLedger[0]?.id,
                  label: res.result?.effectiveLedger[0]?.ledgerName,
                },
                partyLedger: {
                  value: res.result?.partyLedger[0]?.id,
                  label: res.result?.partyLedger[0]?.ledgerName,
                },
                purchaseOrderRef: {
                  value: orderId,
                  label: res.result?.number,
                },
                date: dayjs(
                  dayjs(res.result.date).format("DD/MM/YYYY"),
                  "DD/MM/YYYY"
                ),
                dueDate: dayjs(res.result?.date).add(
                  party && party?.creditPeriod > 0
                    ? convertToDays(party?.creditPeriod!, TimeUnits.Day)
                    : convertToDays(currentClient?.duration!, TimeUnits.Day),
                  "d"
                ),
              });
              handleAllTheTotalValues();
            } else;
          })
          .catch((err: any) => {
            // setLoading(false);
            openNotification("error", err.message);
          });
        // setLoading(false);
      }
    };

    if (customerOptions.length > 0) {
      getQuotationDetails(purchaseOrderRef!, Voucher_Type.Quotation, false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quotationId, purchaseOrderRef, customerOptions]);

  console.log("Selected estimate id: ", quotationId);

  useEffect(() => {
    if (partyIsGstRegisteredTrigger) {
      const ItemList = form.getFieldValue(["items"]);
      if (ItemList?.length > 0 && ItemList[0]?.id) {
        ItemList?.map((x: any, index: number) => {
          // const currentIndexData = ItemList[index];

          const netAmount = Utils.getNumber(x?.amount?.price * x?.amount?.qty);
          const discountRupee = percentCal(netAmount, x?.amount?.discount);
          const taxRate = Utils.getNumber(x?.amount?.hideTax?.title);
          const withoutTaxAmount = Utils.getNumber(netAmount - discountRupee);
          const itemTaxAmt = Utils.getNumber(
            withoutTaxAmount * (taxRate / 100)
          );
          // itemsOption.find(x => x.id)
          if (
            partyIsGstRegistered === CompanyGSTTypes.Regular
            // ||
            // partyIsGstRegistered === CompanyGSTTypes.Composition
          ) {
            form.setFieldValue(["items", index], {
              ...x,
              amount: {
                ...x?.amount,
                // tax:
                itcEligibilityType: ITCEligibility_Type.Available,
                tax: {
                  title: x?.amount?.hideTax?.title,
                  value: x?.amount?.hideTax?.value,
                  label: x?.amount?.hideTax?.label,
                },
                itemTaxAmt: itemTaxAmt,
                totalAmount: withoutTaxAmount + itemTaxAmt,
              },
            });
          } else {
            form.setFieldValue(["items", index], {
              ...x,
              amount: {
                ...x?.amount,
                itemTaxAmt: 0,
                itcEligibilityType: null,
                tax: null,
                hideTax:
                  currentClient?.gstType === CompanyGSTTypes.Regular ||
                  updateTimeData.isGSTVoucher ||
                  splitPathInVchType === Voucher_Type.PurchaseOrder
                    ? {
                        value: x?.amount?.tax?.value,
                        label: x?.amount?.tax?.label,
                        title: x?.amount?.tax?.title,
                      }
                    : null,
                totalAmount: amountWithoutTax(x, x?.amount?.discount ?? 0),
              },
            });
          }
        });
        handleAllTheTotalValues();
        // console.log("checkinvoicedat", ItemList);
      }

      const freightInsLedgers = form.getFieldValue("freightInsLedgers");
      if (freightInsLedgers?.length > 0 && freightInsLedgers[0]?.id) {
        freightInsLedgers?.map((x: any, index: number) => {
          // const currentLedgerIndexData = freightInsLedgers[index];

          const gstrate = Utils.getNumber(x?.hideTax?.title);
          const gstamount = percentCal(Utils.getNumber(x?.amount), gstrate);
          const ledgertotalamout = Utils.getNumber(x?.amount) + gstamount;

          if (
            partyIsGstRegistered === CompanyGSTTypes.Regular
            // ||
            // partyIsGstRegistered === CompanyGSTTypes.Composition
          ) {
            form.setFieldValue(["freightInsLedgers", index], {
              ...x,
              itcEligibilityType: ITCEligibility_Type.Available,
              gstRate: x?.hideTax && {
                title: x?.hideTax?.title,
                value: x?.hideTax?.value,
                label: x?.hideTax?.label,
              },
              gstAmount: gstamount,
              totalAmount: ledgertotalamout,
            });
          } else {
            form.setFieldValue(["freightInsLedgers", index], {
              ...x,
              itcEligibilityType: null,
              hideTax:
                currentClient?.gstType === CompanyGSTTypes.Regular ||
                updateTimeData.isGSTVoucher ||
                splitPathInVchType === Voucher_Type.PurchaseOrder
                  ? {
                      value: x.gstRate?.value,
                      label: x.gstRate?.label,
                      title: x.gstRate?.title,
                    }
                  : null,
              // gstRate: null,
              gstAmount: 0,
              totalAmount: x?.amount,
            });
          }
        });
        handleFreightAndInsLedgerTotal();
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partyIsGstRegisteredTrigger]);

  // Sales Invoice party chage - Not overseas to overseas & overseas to not Overseas
  useEffect(() => {
    if (partyIsGstRegisteredSalesInvoiceTrigger) {
      const ItemList = form.getFieldValue(["items"]);
      const party = form.getFieldValue("partyLedger");

      // let findCutomerDetails;

      const findCutomerDetails = customerOptions.find(
        (Ledgerlist: any) => Ledgerlist?.id === party?.value
      );
      // const findGstRate = gstOption?.find((x) => x.id === 3);
      if (ItemList?.length > 0) {
        ItemList?.map((x: any, index: number) => {
          const findItem = itemsOption.find((itm) => itm?.id === x?.id);
          // const currentIndexData = ItemList[index];

          const netAmount = Utils.getNumber(x?.amount?.price * x?.amount?.qty);
          const discountRupee = percentCal(netAmount, x?.amount?.discount);
          const taxRate = Utils.getNumber(x?.amount?.hideTax?.title);
          const withoutTaxAmount = Utils.getNumber(netAmount - discountRupee);
          const itemTaxAmt =
            partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
            partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ
              ? 0
              : Utils.getNumber(withoutTaxAmount * (taxRate / 100));

          // gst rate calculate like not LUT
          if (
            // underLUT === false ||
            findCutomerDetails?.gstType === CompanyGSTTypes.Unregistered ||
            findCutomerDetails?.gstType === CompanyGSTTypes.Regular ||
            findCutomerDetails?.gstType === CompanyGSTTypes.Composition ||
            findCutomerDetails?.gstType === CompanyGSTTypes.Consumer ||
            findCutomerDetails?.gstType ===
              CompanyGSTTypes.DeemedExportImport ||
            findCutomerDetails?.gstType === undefined ||
            findCutomerDetails?.gstType === null
          ) {
            form.setFieldValue(["items", index], {
              ...x,
              amount: {
                ...x?.amount,
                // tax:
                itcEligibilityType: ITCEligibility_Type.Available,
                tax: {
                  title: findItem?.taxRate?.rate,
                  value: findItem?.taxRate?.id,
                  label: findItem?.taxRate?.name,
                },
                itemTaxAmt:
                  partyIsGstRegisteredSalesInvoice ===
                    CompanyGSTTypes.Overseas ||
                  partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ
                    ? 0
                    : itemTaxAmt,
                totalAmount: withoutTaxAmount + itemTaxAmt,
              },
            });
          }
          // gst rate not calculate like under LUT
          else {
            form.setFieldValue(["items", index], {
              ...x,
              amount: {
                ...x?.amount,
                itemTaxAmt: 0,
                itcEligibilityType: null,
                tax: {
                  title: findItem?.taxRate?.rate,
                  value: findItem?.taxRate?.id,
                  label: findItem?.taxRate?.name,
                },
                hideTax:
                  currentClient?.gstType === CompanyGSTTypes.Regular ||
                  updateTimeData.isGSTVoucher ||
                  splitPathInVchType === Voucher_Type.PurchaseOrder
                    ? {
                        value: x?.amount?.tax?.value,
                        label: x?.amount?.tax?.label,
                        title: x?.amount?.tax?.title,
                      }
                    : null,
                totalAmount: amountWithoutTax(x, x?.amount?.discount ?? 0),
              },
            });
          }
        });
        handleAllTheTotalValues();
        // console.log("checkinvoicedat", ItemList);
      }

      const freightInsLedgers = form.getFieldValue("freightInsLedgers");
      if (freightInsLedgers?.length > 0 && freightInsLedgers[0]?.id) {
        freightInsLedgers?.map((x: any, index: number) => {
          // const currentLedgerIndexData = freightInsLedgers[index];

          const gstrate = Utils.getNumber(x?.hideTax?.title);
          const gstamount = percentCal(Utils.getNumber(x?.amount), gstrate);
          const ledgerTotalGstAmount = Utils.getNumber(x?.amount) + gstamount;

          if (
            // underLUT === false ||
            findCutomerDetails?.gstType === CompanyGSTTypes.Unregistered ||
            findCutomerDetails?.gstType === CompanyGSTTypes.Regular ||
            findCutomerDetails?.gstType === CompanyGSTTypes.Composition ||
            findCutomerDetails?.gstType === CompanyGSTTypes.Consumer ||
            findCutomerDetails?.gstType ===
              CompanyGSTTypes.DeemedExportImport ||
            findCutomerDetails?.gstType === undefined ||
            findCutomerDetails?.gstType === null
          ) {
            form.setFieldValue(["freightInsLedgers", index], {
              ...x,
              itcEligibilityType: ITCEligibility_Type.Available,
              gstRate:
                splitPathInVchType === Voucher_Type.PurchaseOrder
                  ? x?.hideTax && {
                      title: x?.hideTax?.title,
                      value: x?.hideTax?.value,
                      label: x?.hideTax?.label,
                    }
                  : x?.gstRate && {
                      value: x.gstRate?.value,
                      label: x.gstRate?.label,
                      title: x.gstRate?.title,
                    },
              gstAmount: gstamount,
              totalAmount: ledgerTotalGstAmount,
            });
          } else {
            form.setFieldValue(["freightInsLedgers", index], {
              ...x,
              itcEligibilityType: null,
              hideTax:
                currentClient?.gstType === CompanyGSTTypes.Regular ||
                updateTimeData.isGSTVoucher ||
                splitPathInVchType === Voucher_Type.PurchaseOrder
                  ? x.gstRate && {
                      value: x.gstRate?.value,
                      label: x.gstRate?.label,
                      title: x.gstRate?.title,
                    }
                  : null,
              gstRate:
                splitPathInVchType === Voucher_Type.PurchaseOrder
                  ? x?.hideTax && {
                      title: x?.hideTax?.title,
                      value: x?.hideTax?.value,
                      label: x?.hideTax?.label,
                    }
                  : x?.gstRate && {
                      value: x.gstRate?.value,
                      label: x.gstRate?.label,
                      title: x.gstRate?.title,
                    },
              gstAmount: 0,
              totalAmount: x?.amount,
            });
          }
        });
        handleFreightAndInsLedgerTotal();
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    partyIsGstRegisteredSalesInvoice,
    partyIsGstRegisteredSalesInvoiceTrigger,
    underLUT,
  ]);

  //------ Get a Include Other Expenses(Direct Income) Ledger
  useEffect(() => {
    LedgerService.getLedgersByGroupName(
      currentClient?.id!,
      splitPathInVchType === Voucher_Type.PurchaseOrder
        ? SearchLedgerByGroupsTypes.DirectExpenses
        : SearchLedgerByGroupsTypes.SellingAndDistributionExpenses
    )
      .then((res: any) => {
        // console.log(res, "indirExpLedgers");
        if (res) {
          setFreightAndInsuranceOptions(res);
        }
      })
      .catch((ex: any) => {
        console.error(ex);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id, splitPathInVchType]);

  useEffect(() => {
    if (getVoucherTitle) {
      setSettingControl({
        title: getVoucherTitle?.title!,
        templateId: getVoucherTitle?.id!,
        titleToBePrint:
          splitPathInVchType === Voucher_Type.PurchaseOrder
            ? getVoucherTitle?.settings?.billSettings?.titleToBePrint
            : getVoucherTitle?.settings?.invoiceSettings?.titleToBePrint,
        showShippingAddress:
          getVoucherTitle?.settings?.orderSettings?.showShippingAddress,
        showPriceHistory:
          getVoucherTitle?.settings?.orderSettings?.showPriceHistory,
        showOtherCharges:
          getVoucherTitle?.settings?.orderSettings?.showOtherCharges,
        discountPolicy:
          getVoucherTitle?.settings?.orderSettings?.discountPolicy,
        showItemDescription:
          getVoucherTitle?.settings?.orderSettings?.showItemDescription,
        autoRoundOff: getVoucherTitle?.settings?.orderSettings?.autoRoundOff,
        roundOffType: getVoucherTitle?.settings?.orderSettings?.roundOffType,
        showFreightType:
          getVoucherTitle?.settings?.orderSettings?.showFreightType,
        showRCM: getVoucherTitle?.settings?.orderSettings?.showRCM!,
        manualNumbering:
          getVoucherTitle?.settings?.orderSettings?.manualNumbering!,

        showTcs: getVoucherTitle?.settings?.orderSettings?.showTcs!,
        showTds: getVoucherTitle?.settings?.orderSettings?.showTds!,
        defaultNature: getVoucherTitle?.settings?.orderSettings?.defaultNature!,
      });
      // !id &&
      //   setIsCustomNumber(
      //     getVoucherTitle?.settings?.orderSettings?.manualNumbering
      //   );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [splitPathInVchType, location]);

  //To get Item's price history data
  const handlePriceHistoryData = async (itemId: string) => {
    setShowPriceHistoryLoading(true);
    await VoucherServices.getPriceHistoryByItemId(
      currentClient?.id!,
      splitPathInVchType,
      itemId,
      true
    ).then((res: any) => {
      setShowPriceHistoryData(
        id ? res.result?.filter((res: any) => res.voucherId !== id) : res.result
      );
    });
    setShowPriceHistoryLoading(false);
  };

  // -------- Add Order Post API ---------
  const saveOrder = async (
    isSaveAndNew?: boolean,
    isDraft: boolean = false
  ) => {
    setLoading(true);
    try {
      if (
        Utils.getNumber(footerTotal.amount) +
          Utils.getNumber(footerLedger.ledgerTotalAmount) +
          roundOffAmount >
        0
      ) {
        const val = isDraft
          ? form.getFieldsValue()
          : await form.validateFields();

        if (!isDraft) {
          isSaveAndNew ? setSaveNewLoading(true) : setSaveButtonLoading(true);
        }

        const freightInsLedgers = val?.freightInsLedgers?.map((exp: any) => {
          return {
            ...exp,
            id: exp.id?.value,
            gstRate: {
              id: exp?.gstRate?.value,
              rate: exp?.gstRate?.title,
              name: exp?.gstRate?.label,
            },
          };
        });

        const partyLedger = new Array({
          id: val?.partyLedger?.value,
          PartyOrTax: Party_Tax.party,
          amount:
            Utils.getNumber(footerTotal.amount) +
            Utils.getNumber(footerLedger.ledgerTotalAmount) +
            roundOffAmount -
            (voucherNature === Voucher_Nature.RCM
              ? footerTotal?.gst + footerLedger.ledgerGstAmount
              : 0) -
            totalTds +
            totalTcs,
          transactionId:
            transactionId.partyId === "" ? null : transactionId.partyId,
        });

        const effectiveLedger = new Array({
          id: val?.effectiveLedger?.value,
          PartyOrTax: Party_Tax.other,
          amount: Utils.getNumber(
            Utils.getNumber(footerTotal.taxableAmount) - footerTotal.discount
          ),
          transactionId:
            transactionId.partyId === "" ? null : transactionId.partyId,
        });

        const items = val?.items?.map((itm: any) => {
          return {
            ...itm,
            amount: {
              ...itm?.amount,
              unit: {
                id: itm.amount?.unit?.value,
                name: itm.amount?.unit?.label,
                unitType: itm?.amount?.unit?.unitType,
              },
              grossAmount:
                Utils.getNumber(itm?.amount?.price) * itm?.amount?.qty,
              tax: {
                id: itm?.amount?.tax?.value,
                rate: itm?.amount?.tax?.title,
                name: itm?.amount?.tax?.label,
              },
            },
          };
        });

        console.log("itemsdd", val);

        let givenDate;
        if (quotationId && dayjs(val.date).isSame(dayjs(editDate), "day")) {
          givenDate = editDate;
        } else {
          givenDate = new Date(val.date);
          const currentTime = new Date();

          // Set the time part of givenDate to match currentTime
          givenDate?.setHours(
            currentTime.getHours(),
            currentTime.getMinutes(),
            currentTime.getSeconds(),
            currentTime.getMilliseconds()
          );
        }
        const tdsRatePredentage =
          partyPanCard === PanCardType.HUF
            ? val?.tdsDetail?.title?.rates?.indHUFRate ?? val?.tdsDetail?.title
            : partyPanCard === PanCardType.Other
            ? val?.tdsDetail?.title?.rates?.otherRate ?? val?.tdsDetail?.title
            : val?.tdsDetail?.title?.rates?.ifPANNotRate ??
              val?.tdsDetail?.title;

        const invoice = {
          ...val,
          voucherTitle: {
            id: selectCustomizationTemplete.templateId,
            name: selectCustomizationTemplete.title,
          },
          currency: {
            id: val?.currency?.value,
            name: val?.currency?.label,
          },
          underLUT: underLUT,
          isCustomNumber: settingControl?.manualNumbering,
          items: items,
          billingAddress: {
            ...val?.billingAddress,
            type: val?.billingAddress?.type?.title,
            addressName: val?.billingAddress?.type?.value,
          },
          shippingAddress: {
            ...val?.shippingAddress,
            type: val?.shippingAddress?.type?.title,
            addressName: val?.shippingAddress?.type?.value,
          },
          tcsApplicable:
            tdsOrTcs && totalTcs > 0 && isPartTDSOrTDS.tcs ? true : false,
          tcsDetail:
            tdsOrTcs && totalTcs > 0 && isPartTDSOrTDS.tcs
              ? {
                  id: val?.tcsDetail?.value,
                  name: val?.tcsDetail?.label,
                  rate: val?.tcsDetail?.title,
                  value: totalTcs,
                }
              : null,
          tdsApplicable:
            tdsOrTcs === 0 && totalTds > 0 && isPartTDSOrTDS.tds ? true : false,
          tdsDetail:
            tdsOrTcs === 0 && totalTds > 0 && isPartTDSOrTDS.tds
              ? {
                  id: val?.tdsDetail?.value,
                  name: val?.tdsDetail?.label,
                  rate: tdsRatePredentage,
                  value: totalTds,
                  transactionType: tdsPostDetail.transactionType,
                  form: tdsPostDetail.formNo,
                }
              : null,
          nature: voucherNature,
          isShippingAddressSame: isSameBillingAddress,
          isGSTVoucher:
            currentClient?.gstType === CompanyGSTTypes.Regular ||
            updateTimeData.isGSTVoucher ||
            splitPathInVchType === Voucher_Type.PurchaseOrder,
          showItemDescription:
            settingControl.showItemDescription ||
            updateTimeData.showItemDescription,
          draftId: draftId,
          termsNConditions: termsAndConditionField,
          date: dayjs(givenDate).toISOString(),
          supplierInvoiceDate: val?.supplierInvoiceDate
            ? dayjs(val?.supplierInvoiceDate).toISOString()
            : null,
          freightInsLedgers,
          partyLedger,
          effectiveLedger,
          isStateSame: isStateSame,
          billState: currentCustomerState,
          deleteUploadId: deleteUploadId,
          purchaseOrderRef: {
            id: val?.purchaseOrderRef?.value,
            date: purchaseOrderDate && dayjs(purchaseOrderDate).toISOString(),
          },
          // dueDate: dayjs(val?.dueDate).toString(),
          // despatchDetail: invoiceDespatchDetails,
          // exportDetail: invoiceExportDetails,
          // shippingAddress: val?.shippingAddress.type
          //   ? val.shippingAddress
          //   : { address: val?.shippingAddress?.address },
          amountSummary: {
            tCSRate: val?.tcsDetail?.title,
            tCSAmt: totalTcs,
            tDSRate: tdsRatePredentage,
            tDSAmt: totalTds,
            totalQty: Utils.getNumber(footerTotal?.qty),
            taxableAmount: Utils.getNumber(
              Utils.getNumber(footerTotal?.taxableAmount) -
                footerTotal?.discount
            ), // befor gst
            totalDis: Utils.getNumber(footerTotal?.discount),
            freightAmount: 0,
            cessAmount: 0,
            igstAmt:
              !isStateSame ||
              partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ ||
              partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas
                ? footerTotal?.gst + footerLedger.ledgerGstAmount
                : 0,
            cgstAmt:
              isStateSame &&
              partyIsGstRegisteredSalesInvoice !== CompanyGSTTypes.SEZ &&
              partyIsGstRegisteredSalesInvoice !== CompanyGSTTypes.Overseas
                ? (footerTotal?.gst + footerLedger.ledgerGstAmount) / 2
                : 0,
            sgstAmt:
              isStateSame &&
              partyIsGstRegisteredSalesInvoice !== CompanyGSTTypes.SEZ &&
              partyIsGstRegisteredSalesInvoice !== CompanyGSTTypes.Overseas
                ? (footerTotal?.gst + footerLedger.ledgerGstAmount) / 2
                : 0,
            roundOff: {
              roundOffApplicable: val?.roundoffCheckbox,
              roundOffAmount: roundOffAmount ?? 0,
            },
            totalInvoiceAmount:
              Utils.getNumber(footerTotal.amount) +
              Utils.getNumber(footerLedger.ledgerTotalAmount) +
              (roundOffAmount ?? 0),
            receivedAmount: 0,
            voucherAmountWithoutTCS:
              Utils.getNumber(footerTotal.amount) +
              Utils.getNumber(footerLedger.ledgerTotalAmount) -
              balance,
          },
        };

        if (footerTotal.discount <= footerTotal.taxableAmount) {
          if (
            Utils.getNumber(footerTotal.amount) +
              Utils.getNumber(footerLedger.ledgerTotalAmount) >
            0
          ) {
            setOpenModel({
              type: "addInvoiceReferenceModel",
              param: {
                open: true,
              },
            });
            setCurrentInvoiceDetails(invoice);
            const res = isDraft
              ? await DraftService.postVoucherDraft(
                  currentClient?.id!,
                  splitPathInVchType,
                  invoice,
                  draftId
                )
              : await QuotationServices.postQuotation(
                  currentClient?.id!,
                  splitPathInVchType,
                  invoice,
                  id
                );
            if (res?.status) {
              if (isDraft) {
                openNotification(
                  "success",
                  `${
                    splitPathInVchType === Voucher_Type.PInvoice
                      ? "Proforma Invoice"
                      : splitPathInVchType === Voucher_Type.SalesOrder
                      ? "Sales Order"
                      : splitPathInVchType === Voucher_Type.Quotation
                      ? "Estimate"
                      : "Purhcase Order"
                  } draft ${res.result?.name} ${
                    draftId ? "updated successfully." : "added successfully."
                  }`
                );
                navigate(-1);
              } else {
                openNotification(
                  "success",
                  `${
                    splitPathInVchType === Voucher_Type.PInvoice
                      ? "Proforma Invoice"
                      : splitPathInVchType === Voucher_Type.SalesOrder
                      ? "Sales Order"
                      : splitPathInVchType === Voucher_Type.Quotation
                      ? "Estimate"
                      : "Purhcase Order"
                  } ${res.result?.name} ${
                    id ? "updated successfully." : "added successfully."
                  }`
                );

                setFooterTotal({
                  qty: 0,
                  unitPrice: 0,
                  taxableAmount: 0,
                  discount: 0,
                  gst: 0,
                  amount: 0,
                });
                // form.resetFields();
                // setInvoiceTotal(0.0);

                setItemLength(0);
                setSaveButtonLoading(false);
                navigate(-1);
              }
            } else if (res?.message) {
              setSaveButtonLoading(false);
              openNotification("error", res?.message);
            }

            // .catch((ex) => openNotification("error", ex));
            setSaveButtonLoading(false);
            setSaveNewLoading(false);
            // isSaveAndNew && seInitialRender(!initialRender);
          } else {
            setSaveNewLoading(false);
            openNotification("error", "Order price must be grated than 0");
            setSaveButtonLoading(false);
          }
        } else {
          openNotification("error", "discount should be less than Order price");
          setSaveButtonLoading(false);
        }
      } else {
        openNotification(
          "error",
          `${
            splitPathInVchType === Voucher_Type.PInvoice
              ? "Proforma Invoice"
              : splitPathInVchType === Voucher_Type.SalesOrder
              ? "Sales Order "
              : splitPathInVchType === Voucher_Type.Quotation
              ? "Estimate"
              : "Purchase Order "
          } amount must be greater than zero`
        );
      }
    } catch (error) {
      setSaveButtonLoading(false);
      console.log("Validation failed:", error);
    } finally {
      setLoading(false);
    }
  };

  EntryLevelKeys({
    save: () => saveOrder(),
    cancel: () => navigate(-1),
  });
  const handleRowClick = (index: number) => {
    setClickedIndex(index);
  };

  const filterSerial = serial?.filter((itm) => itm !== undefined);
  useEffect(() => {
    const mergedSerialData = [
      ...(serialNoData || []),
      ...(forAddSerialData || []),
    ];
    console.log("forAddSerialData", forAddSerialData);
    console.log("serialNoData", serialNoData);

    if (mergedSerialData?.length && clickedIndex !== null) {
      const validItems = mergedSerialData?.filter(
        (itm: any) => itm !== undefined
      );
      const currentValues = form.getFieldValue("items") || [];
      if (!currentValues[clickedIndex]) {
        currentValues[clickedIndex] = { amount: {} };
      }
      currentValues[clickedIndex].amount.qty = validItems?.length;
      currentValues[clickedIndex].serialItem = validItems;
      form.setFieldsValue({ items: currentValues });
      setSerialNoData([]);
      setSelectedBatchData([]);
      setBatchData([]);
      setSerial(currentValues[clickedIndex].serialItem);
      setForAddSerialData([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerSerialData]);

  //-------- All Item List-----------
  useEffect(() => {
    setItmLedDropDownLoading(true);
    setLoading(true);
    ItemsService.searchItem(
      currentClient?.id!,
      searchItem,
      splitPathInVchType === Voucher_Type.PurchaseOrder
        ? CAPItemTypes.Purchase
        : CAPItemTypes.Sales
    ).then((res) => {
      if (res) {
        setItemsOption(res);
        setItmLedDropDownLoading(false);
        if (!quotationId) {
          setLoading(false);
        }
      } else {
        setItmLedDropDownLoading(false);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id, searchItem, loadItemAPI]);

  //------- Add new item ------
  useEffect(() => {
    console.log("newItem", newItem);
    if (
      newItem?.isSaved &&
      (splitPathInVchType !== Voucher_Type.PurchaseOrder
        ? newItem?.data?.salesItem?.isActive
        : newItem?.data?.purchaseItem?.isActive)
    ) {
      // Set the new item's data into the form field
      const newItemFields = {
        name: newItem?.data?.name,
        isService: newItem?.data?.isService,
        isTaxable: newItem?.data?.isTaxable,
        id: newItem?.data?.id,
        description:
          splitPathInVchType !== Voucher_Type.PurchaseOrder
            ? newItem?.data?.salesItem?.description
            : newItem?.data?.purchaseItem?.description,
        itcEligibilityType:
          splitPathInVchType === Voucher_Type.PurchaseOrder
            ? ITCEligibility_Type.Available
            : null,
        amount: {
          qty: 1,
          unit: {
            value: newItem?.data?.unit?.id,
            label: newItem?.data?.unit?.shortName,
            unitType: newItem?.data?.unit?.unitType,
          },
          discount:
            settingControl.discountPolicy ===
              Discount_Policy.TradenCashDiscount ||
            settingControl.discountPolicy ===
              Discount_Policy.OnlyTradeDiscount ||
            updateTimeData.tradeDiscount
              ? newItem?.data?.salesItem?.discountSalesType ===
                DiscountSalesType.Percentage
                ? newItem?.data?.salesItem?.discountSalesPrice
                : (newItem?.data?.salesItem?.discountSalesPrice /
                    (newItem?.data?.salesItem?.isTaxable
                      ? (newItem?.data?.salesItem?.price /
                          (100 + newItem?.data?.salesItem?.taxRate.rate)) *
                        100
                      : newItem?.data?.salesItem?.price)) *
                  100
              : 0,

          price: newItem.data?.isTaxable
            ? splitPathInVchType !== Voucher_Type.PurchaseOrder
              ? (newItem.data?.salesItem?.price /
                  (100 + newItem.data?.taxRate.rate)) *
                100
              : (newItem.data?.purchaseItem?.price /
                  (100 + newItem.data?.taxRate.rate)) *
                100
            : splitPathInVchType !== Voucher_Type.PurchaseOrder
            ? newItem.data?.salesItem?.price
            : newItem.data?.purchaseItem?.price,
          tax:
            splitPathInVchType === Voucher_Type.PurchaseOrder
              ? (partyIsGstRegistered === CompanyGSTTypes.Regular ||
                  updateTimeData.isGSTVoucher) && {
                  title: newItem.data?.taxRate?.rate,
                  label: newItem.data?.taxRate?.name,
                  value: newItem.data?.taxRate?.id,
                }
              : currentClient?.gstType === CompanyGSTTypes.Regular ||
                updateTimeData.isGSTVoucher
              ? {
                  title: newItem.data?.taxRate?.rate,
                  label: newItem.data?.taxRate?.name,
                  value: newItem.data?.taxRate?.id,
                }
              : null,
          hideTax: {
            title: newItem.data?.taxRate?.rate,
            label: newItem.data?.taxRate?.name,
            value: newItem.data?.taxRate?.id,
          },
        },
      };

      // Update the current item at index itemFields.index
      if (!newItem.isEdited) setItemLength(itemFields.index + 1);
      form.setFieldValue(["items", itemFields.index], newItemFields);

      // If the current item index is at the end, add a new item with initial values
      if (itemFields?.field?.length === itemFields?.index + 1) {
        form.setFieldValue(["items", itemFields.index + 1], {
          amount: { price: 0.0, qty: 0, totalAmount: 0 },
        });
      }
      // Prepare the new item data to be added to itemsOption
      // console.log("newItem", newItem);

      const newItemData = {
        barCode: newItem?.data?.barCode,
        batchItem: newItem?.data?.batchItem,
        description:
          splitPathInVchType !== Voucher_Type.PurchaseOrder
            ? newItem?.data?.salesItem?.description
            : newItem?.data?.purchaseItem?.description,
        discountSalesPrice: newItem?.data?.salesItem?.discountSalesPrice ?? 0,
        discountSalesType: newItem?.data?.salesItem?.discountSalesType ?? 0,
        hsnCode: newItem?.data?.hsnCode,
        id: newItem.data?.id,
        isService: newItem.data?.isService,
        isTaxable: newItem.data?.isTaxable,
        itemStatus: newItem?.data?.itemStatus,
        name: newItem.data?.name,
        price:
          splitPathInVchType !== Voucher_Type.PurchaseOrder
            ? newItem.data?.salesItem?.price
            : newItem.data?.purchaseItem?.price,
        quantity: 1,
        sacCode: newItem?.data?.sacCode,
        serialItem: newItem?.data?.serialItem,
        taxRate: {
          rate: newItem.data?.taxRate?.rate,
          name: newItem.data?.taxRate?.name,
          id: newItem.data?.taxRate?.id,
        },
        trackingType: newItem?.data?.trackingType,
        unit: {
          id: newItem.data?.unit?.id,
          shortName: newItem.data?.unit?.shortName,
          unitType: newItem.data.unit?.unitType,
        },
        voucherRefs: newItem?.data?.voucherRefs,
        wholesaleDetails: newItem?.data?.wholesaleDetails,
      };

      console.log("newItemData", newItemData);
      // Add the new item data to itemsOption
      if (newItem.isEdited) {
        setItemsOption((itemsOption) =>
          updateListWithNewValue(itemsOption, newItemData, false)
        );
      } else setItemsOption((itemsOption) => [newItemData, ...itemsOption]);

      // Call the function to handle the total values
      handleItemsNetAmmount(itemFields.index);
      const isPurchasePage = location.pathname.split("/")[4] === "purchase";

      if (isPurchasePage) {
        const trackingType = newItem?.data?.trackingType;
        let type = "";
        if (trackingType === 2) {
          type = "serialNo";
        } else if (trackingType === 1) {
          type = "batchItem";
        }

        if (type) {
          setOpenModel({
            type,
            param: {
              open: true,
            },
          });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newItem.data, newItem.isSaved]);

  const handleDeleteRowButton = () => {
    handleItemsNetAmmount(0);
    setConfirmation(false);
  };

  useEffect(() => {
    // update invoice time Customer address set
    if (id && selectedParty && onlyEditTimeCustomerOptions) {
      CustomerSelect(selectedParty, onlyEditTimeCustomerOptions);
      setOnlyEditTimeCustomerOptions(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerOptions, selectedParty]);

  // onChange in address type
  const customerAddSelect: any = (
    typeOfAddressName: string,
    typeOfAddress: TypeOfAddress,
    addressEnum: AddressEnum,
    addressTotal: any[]
  ) => {
    console.log(
      "customerAddress",
      customerAddress,
      typeOfAddressName,
      typeOfAddress,
      addressTotal,
      addressTotal.length > 0
    );

    let findAddress: any;
    if (addressTotal?.length > 0) {
      findAddress = addressTotal?.find(
        (type: any) => type?.addressName === typeOfAddressName
      );
    } else if (customerAddress?.length > 0) {
      findAddress = customerAddress?.find(
        (type: any) => type?.addressName === typeOfAddressName
      );
      console.log("Hello findAddress", findAddress);
    }

    if (findAddress?.address) {
      // console.log("findAddress.....", findAddress);
      // const objectofaddress1: any[] = [];
      const countryLength = findAddress?.address?.country?.length === 2;
      var country: any;
      if (countryLength) {
        country = allCountriesStates?.find(
          (x) => x.iso2 === findAddress?.address?.country
        );
        console.log("partyGstType", country);
      }
      let objectofaddress1: string = "";
      Object.keys(findAddress?.address).forEach((key: any) => {
        // console.log("key...........", key);
        switch (key) {
          case "building":
            if (findAddress?.address[key])
              objectofaddress1 += findAddress?.address[key] + ", ";
            break;
          case "street":
            if (findAddress?.address[key])
              objectofaddress1 += findAddress?.address[key] + ", " + "\n";
            else if (findAddress?.address[key] === "building")
              objectofaddress1 += "\n";
            break;
          case "landmark":
            if (findAddress?.address[key])
              objectofaddress1 += findAddress?.address[key] + ", ";
            break;
          case "city":
            if (findAddress?.address[key])
              objectofaddress1 += findAddress?.address[key] + ", " + "\n";
            else if (findAddress?.address[key] === "landmark")
              objectofaddress1 += "\n";
            break;
          case "district":
            if (findAddress?.address[key])
              objectofaddress1 += findAddress?.address[key] + ", ";
            break;
          case "pincode":
            if (findAddress?.address[key])
              objectofaddress1 += findAddress?.address[key] + ", " + "\n";
            else if (findAddress?.address[key] === "district")
              objectofaddress1 += "\n";
            break;
          case "overseasState":
            if (countryLength && country?.states?.length > 0) {
              const matchedState = country?.states?.find(
                (x: any) => x.id === findAddress?.address?.overseasState
              );
              objectofaddress1 += matchedState?.name + ", ";
            }
            break;
          case "state":
            if (!countryLength && findAddress?.address[key]) {
              objectofaddress1 +=
                getIndianStates(findAddress?.address[key]) + ", ";
            }

            if (splitPathInVchType === Voucher_Type.PurchaseOrder) {
              if (findAddress?.address[key]) {
                setCurrentCustomerState(findAddress?.address[key]);
              } else {
                setCurrentCustomerState(currentClient?.state!);
              }
            } else {
              setPurchasePartyState(findAddress?.address[key]);
              if (addressEnum === AddressEnum.BillingAddress) {
                form.setFieldValue(
                  "supplyState",
                  findAddress?.address[key] !== 0
                    ? findAddress?.address[key]
                    : undefined
                );
                form.validateFields(["supplyState"]);
              }
            }
            break;
          case "country":
            if (findAddress?.address[key])
              objectofaddress1 += findAddress?.address[key];
            break;
          default:
            if (findAddress?.address[key])
              objectofaddress1 += findAddress?.address[key] + ", ";
        }
      });

      if (addressEnum === AddressEnum.BillingAddress) {
        form.setFieldValue(["billingAddress", "address"], objectofaddress1);
        form.setFieldValue(["billingAddress", "type"], {
          value: typeOfAddressName,
          label: typeOfAddressName,
          title: typeOfAddress,
        });
        if (objectofaddress1) {
          form.validateFields([["billingAddress", "address"]]);
        }
        if (isSameBillingAddress) {
          form.setFieldValue(["shippingAddress", "address"], objectofaddress1);
          form.setFieldValue(["shippingAddress", "type"], {
            value: typeOfAddressName,
            label: typeOfAddressName,
            title: typeOfAddress,
          });
        }
      } else {
        form.setFieldValue(["shippingAddress", "address"], objectofaddress1);
        form.setFieldValue(["shippingAddress", "type"], {
          value: typeOfAddressName,
          label: typeOfAddressName,
          title: typeOfAddress,
        });
      }
    } else {
      if (addressEnum === AddressEnum.BillingAddress) {
        form.setFieldValue(["billingAddress", "address"], "");
        form.setFieldValue(["billingAddress", "type"], {
          value: typeOfAddressName,
          label: typeOfAddressName,
          title: typeOfAddress,
        });
        if (isSameBillingAddress) {
          form.setFieldValue(["shippingAddress", "address"], "");
          form.setFieldValue(["shippingAddress", "type"], {
            value: typeOfAddressName,
            label: typeOfAddressName,
            title: typeOfAddress,
          });
        }
      } else {
        form.setFieldValue(["shippingAddress", "address"], "");
        form.setFieldValue(["shippingAddress", "type"], {
          value: typeOfAddressName,
          label: typeOfAddressName,
          title: typeOfAddress,
        });
      }
      if (splitPathInVchType === Voucher_Type.PurchaseOrder) {
        setCurrentCustomerState(-1);
      }
    }
  };

  console.log("itemId", itemId);
  const itemFilterOptions = itemsOption.filter((option) => {
    const labelMatches = option?.name
      ?.toLowerCase()
      ?.includes(itemSearch?.toLowerCase());

    const aMatches = option?.barCode
      ?.toLowerCase()
      ?.includes(itemSearch?.toLowerCase());
    return labelMatches || aMatches; // Include if either filter matches
  });

  // select in Items
  const itemSelect: any = async (value: string, index: number) => {
    setItemLength(index + 1);
    const selectedItem = itemsOption?.find((Item: any) => Item?.id === value);
    const IsService = selectedItem.isService;
    if (selectedItem) {
      form.setFieldValue(["items", index], {
        name: selectedItem?.name,
        isService: IsService,
        isTaxable: selectedItem?.isTaxable,
        id: selectedItem?.id,
        description: selectedItem?.description,
        hsnsac: selectedItem?.hsnCode ?? selectedItem?.sacCode,
        trackingType: selectedItem?.trackingType,
        // itcEligibilityType:
        //   splitPathInVchType === Voucher_Type.PurchaseOrder
        //     ? ITCEligibility_Type.Available
        //     : null,
        amount: {
          // discount: form.getFieldValue("discount"),
          qty:
            selectedItem?.trackingType === Item_Nature.Batch ||
            selectedItem?.trackingType === Item_Nature.Serial
              ? 0
              : selectedItem?.quantity,
          unit: {
            value: selectedItem?.unit?.id,
            label: selectedItem?.unit?.shortName,
            // shortName: selectedItem?.unit?.name,
            unitType: selectedItem?.unit?.unitType,
          },
          price: selectedItem?.isTaxable
            ? (selectedItem?.price / (100 + selectedItem?.taxRate?.rate)) * 100
            : selectedItem?.price,
          discount:
            settingControl.discountPolicy ===
              Discount_Policy.TradenCashDiscount ||
            settingControl.discountPolicy ===
              Discount_Policy.OnlyTradeDiscount ||
            updateTimeData.tradeDiscount
              ? selectedItem?.discountSalesType === DiscountSalesType.Percentage
                ? selectedItem?.discountSalesPrice
                : (selectedItem?.discountSalesPrice /
                    (selectedItem?.isTaxable
                      ? (selectedItem?.price /
                          (100 + selectedItem?.taxRate.rate)) *
                        100
                      : selectedItem?.price)) *
                  100
              : 0,
          // discountRupee:
          //   selectedItem.discountSalesType === DiscountSalesType.Amount
          //     ? selectedItem.discountSalesPrice
          //     : 0,
          hideTax:
            currentClient?.gstType === CompanyGSTTypes.Regular ||
            updateTimeData.isGSTVoucher ||
            splitPathInVchType === Voucher_Type.PurchaseOrder
              ? {
                  value: selectedItem?.taxRate?.id,
                  label: selectedItem?.taxRate?.name,
                  title: selectedItem?.taxRate?.rate,
                }
              : null,
          tax:
            splitPathInVchType === Voucher_Type.PurchaseOrder
              ? (partyIsGstRegistered === CompanyGSTTypes.Regular ||
                  updateTimeData.isGSTVoucher) && {
                  value: selectedItem?.taxRate?.id,
                  label: selectedItem?.taxRate?.name,
                  title: selectedItem?.taxRate?.rate,
                }
              : currentClient?.gstType === CompanyGSTTypes.Regular ||
                updateTimeData.isGSTVoucher
              ? {
                  value: selectedItem?.taxRate?.id,
                  label: selectedItem?.taxRate?.name,
                  title: selectedItem?.taxRate?.rate,
                }
              : null,
        },
      });
      handleItemsNetAmmount(index);
      setItemSearch("");
      setBarCodeSearch("");
    }

    const items = form.getFieldValue("items");
    const currentItems = items.filter((itm: any) => itm?.id !== undefined);

    if (value) {
      const data = itemsOption?.map((o: any) => {
        if (currentItems.some((item: any) => item?.id === o.id)) {
          return {
            ...o,
            disabled: true,
          };
        } else {
          return {
            ...o,
            disabled: false,
          };
        }
      });
      // console.log("data", data);
      setItemsOption(data);
    }
  };

  const handleAllTheTotalValues = (
    isTcsTds?: number,
    panType?: PanCardType
  ) => {
    const ItemList = form.getFieldValue(["items"]);

    // console.log("ItemList", ItemList);
    //------- Total Row Calculations -------
    const Total = ItemList.reduce(
      (
        acc: {
          TotalQty: number;
          TotalUnitPrice: number;
          ItemSubTotal: number;
          TotalDiscount: number;
          Totalgst: number;
          TotalAmount: number;
        },
        curr: any
      ) => {
        acc.TotalQty += qty(curr);
        acc.TotalUnitPrice += price(curr);
        acc.ItemSubTotal += price(curr) * qty(curr);
        acc.TotalDiscount += amountInNumber(curr, "discountRupee");
        acc.Totalgst +=
          (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
            partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
          !underLUT
            ? Utils.getNumber(
                (curr?.amount?.price *
                  curr?.amount?.qty *
                  curr?.amount?.tax?.title) /
                  100
              )
            : amountInNumber(curr, "itemTaxAmt");
        acc.TotalAmount += amountInNumber(curr, "totalAmount");
        return acc;
      },
      {
        TotalQty: 0,
        TotalUnitPrice: 0,
        ItemSubTotal: 0,
        TotalDiscount: 0,
        Totalgst: 0,
        TotalAmount: 0,
      }
    );

    setFooterTotal({
      qty: Total.TotalQty,
      unitPrice: Total.TotalUnitPrice,
      taxableAmount: Total.ItemSubTotal,
      discount: Total.TotalDiscount,
      gst: Total.Totalgst,
      amount: Total.TotalAmount,
    });

    const totalSumIncludedGst =
      Total.TotalAmount + footerLedger.ledgerTotalAmount;
    const totalSumExcludedGst =
      Total.ItemSubTotal + footerLedger.ledgerAmount - Total.TotalDiscount;

    // TDS or TCS
    let totTcs = 0;
    let totTds = 0;
    if (isTcsTds ?? tdsOrTcs) {
      //----- Calculate TCS amount -----
      const tcsRate = form.getFieldValue("tcsDetail");

      totTcs = percentCal(totalSumIncludedGst, tcsRate?.title);
      setTotalTcs(totTcs);
      setTotalTds(0);
      setTcsTdsPercentage(tcsRate?.title);
    } else {
      //----- Calculate TDS amount -----
      const tdsRate = form.getFieldValue("tdsDetail");
      const type = panType ?? partyPanCard;

      const tdsPredentage =
        type === PanCardType.HUF
          ? tdsRate?.title?.rates?.indHUFRate ?? tdsRate?.title
          : type === PanCardType.Other
          ? tdsRate?.title?.rates?.otherRate ?? tdsRate?.title
          : tdsRate?.title?.rates?.ifPANNotRate ?? tdsRate?.title;

      setTcsTdsPercentage(tdsPredentage);
      // totTds = percentCal(totalSumExcludedGst, tdsPredentage);

      // // console.log("Tds Rate", tdsPredentage, totTds);
      // setTotalTds(totTds);
      setTotalTcs(0);
    }

    // roundOff
    const totalAmount =
      voucherNature === Voucher_Nature.RCM ||
      partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
      partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ
        ? Total.ItemSubTotal +
          footerLedger.ledgerAmount -
          Total.TotalDiscount +
          totTcs
        : //  -
          // totTds
          Total.TotalAmount + footerLedger.ledgerTotalAmount + totTcs;
    // -
    // totTds;

    const roundOffAmount = handleRoundoff(
      totalAmount,
      form.getFieldValue("roundoffCheckbox"),
      settingControl.roundOffType
    );

    form.setFieldValue("roundOff", roundOffAmount);
    setRoundoffAmount(roundOffAmount);
  };

  // on change in items files amount chnage
  const handleItemsNetAmmount = (index: number) => {
    // console.log(index);
    const ItemList = form.getFieldValue(["items"]);
    const currentIndexData = ItemList[index];
    setBatchItmId(ItemList[0]?.id);
    if (currentIndexData) {
      form.setFieldValue(["items", index], {
        ...currentIndexData,
        amount: {
          ...currentIndexData.amount,
          discountRupee: discountRupee(currentIndexData),
          itemTaxAmt:
            (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
              partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
            // underLUT &&
            (splitPathInVchType === Voucher_Type.SalesOrder ||
              splitPathInVchType === Voucher_Type.PInvoice ||
              splitPathInVchType === Voucher_Type.Quotation)
              ? 0
              : itemTaxAmt(currentIndexData),
          totalAmount:
            (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
              partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
            // underLUT &&
            (splitPathInVchType === Voucher_Type.SalesOrder ||
              splitPathInVchType === Voucher_Type.PInvoice ||
              splitPathInVchType === Voucher_Type.Quotation)
              ? amountWithoutTax(
                  currentIndexData,
                  currentIndexData?.amount?.discount ?? 0
                )
              : amountWithTax(currentIndexData),
          hideTax:
            currentClient?.gstType === CompanyGSTTypes.Regular ||
            updateTimeData.isGSTVoucher ||
            splitPathInVchType === Voucher_Type.PurchaseOrder
              ? null
              : {
                  value:
                    currentIndexData.amount?.tax?.value ??
                    currentIndexData.amount?.hideTax?.value,
                  label:
                    currentIndexData.amount?.tax?.label ??
                    currentIndexData.amount?.hideTax?.label,
                  title:
                    currentIndexData.amount?.tax?.title ??
                    currentIndexData.amount?.hideTax?.title,
                },
        },
      });
    }
    handleAllTheTotalValues();
    // addTotalTaxAmountChange(currentIndexData);
  };

  const handleItemsAllDiscount = (discountPercentage: number) => {
    const ItemList = form.getFieldValue(["items"]);
    if (ItemList?.length > 0) {
      ItemList?.map((x: any, index: number) => {
        // ItemList;
        const currentIndexData = ItemList[index];

        form.setFieldValue(["items", index], {
          ...currentIndexData,
          amount: {
            ...currentIndexData.amount,
            discount: discountPercentage ?? 0,
            discountRupee: discountRupee(
              currentIndexData,
              discountPercentage ?? 0
            ),
            itemTaxAmt:
              (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
                partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
              // underLUT &&
              (splitPathInVchType === Voucher_Type.SalesOrder ||
                splitPathInVchType === Voucher_Type.PInvoice ||
                splitPathInVchType === Voucher_Type.Quotation)
                ? 0
                : itemTaxAmt(currentIndexData, discountPercentage ?? 0),
            totalAmount:
              (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
                partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
              // underLUT &&
              (splitPathInVchType === Voucher_Type.SalesOrder ||
                splitPathInVchType === Voucher_Type.PInvoice ||
                splitPathInVchType === Voucher_Type.Quotation)
                ? amountWithoutTax(currentIndexData, discountPercentage ?? 0)
                : amountWithTax(currentIndexData, discountPercentage ?? 0),
          },
        });
      });
    }
    handleAllTheTotalValues();
  };

  const onDiscountAmountChange = (index: number) => {
    const ItemList = form.getFieldValue(["items"]);
    const currentIndexData = ItemList[index];

    if (currentIndexData) {
      // Calculate the new values based on the discount change
      const newDiscountAmount = percentToRs(
        amountInNumber(currentIndexData, "discountRupee"),
        netAmount(currentIndexData)
      );

      const newTaxRs = percentCal(
        netAmount(currentIndexData) -
          amountInNumber(currentIndexData, "discountRupee"),
        taxRate(currentIndexData)
      );

      const newTotalAmount =
        netAmount(currentIndexData) -
        amountInNumber(currentIndexData, "discountRupee") +
        newTaxRs;

      // Update the form field with the new calculated values
      form.setFieldValue(["items", index], {
        ...currentIndexData,
        amount: {
          ...currentIndexData.amount,
          discount: Utils.getNumber(newDiscountAmount),
          itemTaxAmt: Utils.getNumber(newTaxRs),
          totalAmount: Utils.getNumber(newTotalAmount),
        },
      });

      // Call the function to handle the total values if needed
      handleAllTheTotalValues();
    }
  };

  const onItemsTotalAmountChange = async (index: number) => {
    console.log("index...........", index);

    const ItemList = form.getFieldValue(["items"]);
    const currentIndexData = ItemList[index];

    // Calculate the denominator for various calculations
    const denominator =
      100 -
      discount(currentIndexData) +
      percentCal(100 - discount(currentIndexData), taxRate(currentIndexData));

    // Calculate the price based on the given formula
    const calculatedPrice =
      (amountInNumber(currentIndexData, "totalAmount") * 100) /
      (denominator * qty(currentIndexData));

    // Calculate the discountRupee based on the given formula
    const calculatedDiscountRupee =
      (amountInNumber(currentIndexData, "totalAmount") *
        discount(currentIndexData)) /
      denominator;

    // Calculate the itemTaxAmt based on the given formula
    const calculatedTaxRs =
      (amountInNumber(currentIndexData, "totalAmount") *
        percentCal(
          100 - discount(currentIndexData),
          taxRate(currentIndexData)
        )) /
      denominator;

    if (denominator > 0 && currentIndexData?.amount?.qty > 0) {
      // Update the form field values with the calculated values
      form.setFieldValue(["items", index], {
        ...currentIndexData,
        amount: {
          ...currentIndexData?.amount,
          price: Utils.getNumber(calculatedPrice),
          discountRupee: Utils.getNumber(calculatedDiscountRupee),
          itemTaxAmt: Utils.getNumber(calculatedTaxRs),
        },
      });
    } else {
      // Denominator is zero or negative, set all fields to 0
      form.setFieldValue(["items", index], {
        ...currentIndexData,
        amount: {
          ...currentIndexData?.amount,
          price: 0,
          discountRupee: 0,
          itemTaxAmt: 0,
          totalAmount: 0,
        },
      });
    }
    handleAllTheTotalValues();
  };

  // Freight And InsLedger total in fotter
  const handleFreightAndInsLedgerTotal = () => {
    const LedgerAllList = form.getFieldValue(["freightInsLedgers"]);

    //----- Total Row Calculations---------
    const AmountLedger = LedgerAllList.reduce((acc: number, curr: any) => {
      return (acc += Utils.getNumber(curr?.amount));
    }, 0);

    const Total = LedgerAllList.reduce(
      (
        acc: {
          amount: number;
          gstAmount: number;
          totalAmount: number;
        },
        curr: any
      ) => {
        acc.amount += Utils.getNumber(curr?.amount);
        acc.gstAmount +=
          (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
            partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
          !underLUT
            ? Utils.getNumber((curr?.amount * curr?.gstRate?.title) / 100)
            : Utils.getNumber(curr?.gstAmount);
        acc.totalAmount += Utils.getNumber(curr?.totalAmount);
        return acc;
      },
      {
        amount: 0,
        gstAmount: 0,
        totalAmount: 0,
      }
    );

    setFooterLedger({
      ledgerAmount: Total.amount,
      ledgerGstAmount: Total.gstAmount,
      ledgerTotalAmount: Total.totalAmount,
    });

    // ----- Calculate items total unit Price -----
    const TotalLedgerAmount = LedgerAllList.reduce((acc: number, curr: any) => {
      return (acc += amountInNumber(curr, "totalAmount"));
    }, 0);
    setLedgerAmount(TotalLedgerAmount);

    const totalSum = footerTotal.amount + Total.totalAmount;
    let cashDiscountAmount: number = 0.0;

    // TCS or TDS
    let totTcs = 0;
    let totTds = 0;
    if (tdsOrTcs) {
      //----- Calculate TCS amount -----
      const tcsRate = form.getFieldValue("tcsDetail");

      totTcs = percentCal(totalSum, tcsRate?.title);
      console.log("Tcs Rate", tcsRate, footerTotal.amount, totTcs);

      setTotalTcs(totTcs);
    }
    // else {
    //   //----- Calculate TDS amount -----
    //   const tdsRate = form.getFieldValue("tdsDetail");

    //   totTds = percentCal(totalSum, tdsRate?.title);
    //   console.log("Tds Rate", tdsRate, totTds);
    //   setTotalTds(totTds);
    // }

    // roundOff
    const totalAmount =
      voucherNature === Voucher_Nature.RCM ||
      partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
      partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ
        ? footerTotal.taxableAmount +
          Total.ledgerAmount -
          footerTotal.discount -
          cashDiscountAmount +
          totTcs
        : // -totTds
          footerTotal.amount + Total.totalAmount - cashDiscountAmount + totTcs;
    const roundOffAmount = handleRoundoff(
      totalAmount,
      form.getFieldValue("roundoffCheckbox"),
      settingControl.roundOffType
    );

    form.setFieldValue("roundOff", roundOffAmount);
    setRoundoffAmount(roundOffAmount);
  };

  console.log(
    "Various Values: ",
    selectedParty,
    id,
    draftId,
    quotationId,
    isPartyCompany
  );

  // on chnage in Freight And InsLedger unit price & gst
  const handleLedgerNetAmount = (index: number) => {
    const Ledgerlist = form.getFieldValue(["freightInsLedgers"]);
    const currentLedgerIndexData = Ledgerlist[index];
    console.log(
      "currentLedgerIndexData",
      currentLedgerIndexData,
      Utils.getFormattedNumber(gstamount(currentLedgerIndexData)),
      ledgertotalamout(currentLedgerIndexData)
    );
    if (currentLedgerIndexData) {
      form.setFieldValue(["freightInsLedgers", index], {
        ...currentLedgerIndexData,
        gstAmount:
          (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
            partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
          // underLUT &&
          (splitPathInVchType === Voucher_Type.SalesOrder ||
            splitPathInVchType === Voucher_Type.PInvoice ||
            splitPathInVchType === Voucher_Type.Quotation)
            ? 0
            : gstamount(currentLedgerIndexData),
        // totalAmount: Utils.getFormattedNumber(currentLedgerIndexData?.amount),
        totalAmount:
          (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
            partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
          // underLUT &&
          (splitPathInVchType === Voucher_Type.SalesOrder ||
            splitPathInVchType === Voucher_Type.PInvoice ||
            splitPathInVchType === Voucher_Type.Quotation)
            ? Utils.getNumber(currentLedgerIndexData?.amount)
            : ledgertotalamout(currentLedgerIndexData),
      });
      handleFreightAndInsLedgerTotal();
    }
    Ledgerlist?.length === 0 && setShowFreightInsurance(false);
  };

  const onLedgerTotalAmountChange = async (index: number) => {
    const LedgerList = form.getFieldValue(["freightInsLedgers"]);
    const currentIndexData = LedgerList[index];
    // console.log(currentIndexData);

    //Calculate the denominator for various calculations
    const denominators =
      (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
        partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
      underLUT &&
      (splitPathInVchType === Voucher_Type.SalesOrder ||
        splitPathInVchType === Voucher_Type.PInvoice ||
        splitPathInVchType === Voucher_Type.Quotation)
        ? 0
        : gstrate(currentIndexData);
    const ledgernetAmount =
      (Utils.getNumber(currentIndexData.totalAmount) / (100 + denominators)) *
      100;

    const gstAmount =
      Utils.getNumber(currentIndexData.totalAmount) - ledgernetAmount;

    if (ledgernetAmount > 0) {
      form.setFieldValue(["freightInsLedgers", index], {
        ...currentIndexData,
        amount: ledgernetAmount,
        gstAmount: gstAmount,
        // totalAmount: Utils.getFormattedNumber(
        //   ledgertotalamout(currentIndexData)
        // ),
      });
    } else {
      // ledgernetAmount is zero or negative, set all fields to 0
      form.setFieldValue(["freightInsLedgers", index], {
        ...currentIndexData,
        amount: ledgernetAmount,
        gstAmount: gstAmount,
      });
    }
    handleFreightAndInsLedgerTotal();
  };

  // Include Other Expenses (Indirect Income expenses) select
  const freightInsLedgersSelect: any = async (value: any, index: number) => {
    // console.log("value11.............", value, index);
    const currentSelectLedger = freightAndInsuranceOptions.find(
      (x: any) => x.id === value
    );

    console.log("currentSelectLedger.............", currentSelectLedger);
    if (currentSelectLedger) {
      const currentData = form.getFieldValue(["freightInsLedgers", index]);

      const currentValues = {
        id: {
          value: currentSelectLedger?.id,
          label: currentSelectLedger.ledgerName,
        },
        amount: currentData?.amount,
        gstRate:
          currentSelectLedger?.gstRate?.name &&
          (splitPathInVchType === Voucher_Type.PurchaseOrder
            ? (partyIsGstRegistered === CompanyGSTTypes.Regular ||
                updateTimeData.isGSTVoucher) && {
                value: currentSelectLedger?.gstRate?.id,
                label: currentSelectLedger?.gstRate?.name,
                title: currentSelectLedger?.gstRate?.rate,
              }
            : currentClient?.gstType === CompanyGSTTypes.Regular ||
              updateTimeData.isGSTVoucher
            ? {
                value: currentSelectLedger?.gstRate?.id,
                label: currentSelectLedger?.gstRate?.name,
                title: currentSelectLedger?.gstRate?.rate,
              }
            : null),
        hideTax: currentSelectLedger?.gstRate?.name && {
          value: currentSelectLedger?.gstRate?.id,
          label: currentSelectLedger?.gstRate?.name,
          title: currentSelectLedger?.gstRate?.rate,
        },
        gstAmount:
          (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
            partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
          // underLUT &&
          (splitPathInVchType === Voucher_Type.SalesOrder ||
            splitPathInVchType === Voucher_Type.PInvoice ||
            splitPathInVchType === Voucher_Type.Quotation)
            ? 0
            : gstamount(currentData),
        totalAmount:
          (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
            partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
          // underLUT &&
          (splitPathInVchType === Voucher_Type.SalesOrder ||
            splitPathInVchType === Voucher_Type.PInvoice ||
            splitPathInVchType === Voucher_Type.Quotation)
            ? Utils.getNumber(currentData?.amount)
            : ledgertotalamout(currentData),
        // itcEligibilityType:
        //   splitPathInVchType === Voucher_Type.PurchaseOrder
        //     ? ITCEligibility_Type.Available
        //     : null,
      };
      form.setFieldValue(["freightInsLedgers", index], currentValues);
    }
    setLedgerLength(index + 1);
    handleFreightAndInsLedgerTotal();
    setSelectedOtherExpenses((prevState) => {
      const updatedSelectedOptions = [...prevState];
      updatedSelectedOptions[index] = value;
      return updatedSelectedOptions;
    });
    // console.log("currentSelectLedger", currentSelectLedger);
  };

  useEffect(() => {
    const findVoucharType = companySettings?.setting?.vouchersSettings?.find(
      (x: vouchersSettings) => x?.id === selectCustomizationTemplete.templateId
    );
    const voucherData = findVoucharType?.settings?.orderSettings;

    setSettingControl({
      ...voucherData,
      title: findVoucharType?.title,
      titleToBePrint: findVoucharType?.settings?.orderSettings?.titleToBePrint,
      templateId: findVoucharType?.id,
      showContactDetail: voucherData?.showContactDetail!,
      discountPolicy: voucherData?.discountPolicy!,
      manualNumbering: voucherData?.manualNumbering,
      showReceipt: voucherData?.showReceipt!,
      showPriceHistory: voucherData?.showPriceHistory!,
      showOtherCharges: voucherData?.showOtherCharges!,
      showShippingAddress: voucherData?.showShippingAddress!,
      showItemDescription: voucherData?.showItemDescription!,
      autoRoundOff: voucherData?.autoRoundOff!,
      roundOffType: voucherData?.roundOffType!,
      showDispatchDetail: voucherData?.showDispatchDetail!,
      showFreightType: voucherData?.showFreightType!,
      showRCM: voucherData?.showRCM!,
      // showTcsTds: settingControl?.showTcsTds!,
    });
    // !id && setIsCustomNumber(voucherData?.manualNumbering);
    !id && setVoucherNature(voucherData?.defaultNature);
    // setTermsAndConditionField({
    //   templateId:
    //     splitPathInVchType === Voucher_Type.SalesVoucher
    //       ? voucherData?.tnCTemplateId
    //       : voucherData?.tnCTemplateId,
    //   tnCText:
    //     splitPathInVchType === Voucher_Type.SalesVoucher
    //       ? voucherData?.termsnConditions
    //       : voucherData?.termsnConditions,
    // });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectCustomizationTemplete]);
  const [addLedgerResponse, setAddLedgerResponse] = useState<any>(null);
  //adding new data in customerOptions, effectiveLedger, freightAndInsuranceOptions
  useEffect(() => {
    if (addLedgerResponse?.id) {
      console.log("addLedgerResponse", addLedgerResponse);
      let newSupplierData = Utils.getNewlyAddedLedgerData(addLedgerResponse);
      if (apiCallField === "addParty") {
        setPurchaseOrderRef("");
        // form.setFieldValue("purchaseOrderRef", "");
        // form.setFieldValue("effectiveLedger", "");
        //  footerTotal.unitPrice === 0  &&
        //  setFooterTotal({
        //    qty: 0,
        //    unitPrice: 0,
        //    taxableAmount: 0,
        //    discount: 0,
        //    gst: 0,
        //    amount: 0,
        //  });
        //  form.setFieldsValue({
        //    items: [{},{ amount: { price: 0.0, qty: 0, grossAmount: 0 } }],
        //  });
        if (addLedgerResponse.isEdited) {
          setCustomerOptions((pre: any) =>
            updateListWithNewValue(pre, addLedgerResponse, false)
          );
        } else {
          setCustomerOptions((pre: any) => {
            const newData = [...pre, newSupplierData];
            return newData;
          });
        }
      } else if (apiCallField === "salesLedger") {
        setEffectiveLedger((pre: ILedgerSearchByGroupNameResponse[]) => {
          const newData = [...pre, newSupplierData];
          return newData;
        });
      } else if (apiCallField === "newExpenses") {
        setFreightAndInsuranceOptions(
          (pre: ILedgerSearchByGroupNameResponse[]) => {
            const newData = [...pre, newSupplierData];
            return newData;
          }
        );
      }
    }
  }, [addLedgerResponse]);

  //------- Set partner Data After Adding ledger ------
  useEffect(() => {
    //debugger
    if (addLedgerResponse) {
      if (apiCallField === "addParty") {
        form.setFieldValue("partyLedger", {
          key: addLedgerResponse?.id,
          value: addLedgerResponse?.id,
          label: addLedgerResponse?.ledgerName,
        });
        setSelectedParty(addLedgerResponse?.id);
        // if their is a value in purchaseOrderRef then set the items form to default state
        if (form.getFieldValue("purchaseOrderRef")) {
          form.setFieldValue("items", [
            [
              {
                amount: { price: 0.0, qty: 0, totalAmount: 0 },
              },
            ],
          ]);
        }
        CustomerSelect(addLedgerResponse?.id, false, true);
      } else if (apiCallField === "salesLedger") {
        form.setFieldValue("effectiveLedger", {
          key: addLedgerResponse?.id,
          value: addLedgerResponse?.id,
          label: addLedgerResponse?.ledgerName,
        });
      } else if (apiCallField === "newExpenses") {
        const newItem = {
          id: addLedgerResponse.id,
          description: addLedgerResponse.description,
          amount: 0.0,
          gstRate: addLedgerResponse?.gstRate?.id,
          gstAmount: 0.0,
          totalAmount: 0.0,
        };
        form.setFieldValue(
          ["freightInsLedgers", ledgerItemFields.index],
          newItem
        );
        if (ledgerItemFields?.field === ledgerItemFields?.index + 1) {
          form.setFieldValue(
            ["freightInsLedgers", ledgerItemFields.index + 1],
            {}
          );
        }
        setAddLedgerResponse(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    customerOptions,
    effectiveLedger,
    freightAndInsuranceOptions,
    addLedgerResponse,
  ]);

  //------- Set other expense Data After Adding ledger ------
  // useEffect(() => {
  //   try {
  //     if (addLedgerResponse) {
  //       const exists = freightAndInsuranceOptions.some(
  //         (option: any) => option.id === addLedgerResponse.id
  //       );
  //       if (exists) {
  //         let freightInsLedgers = [
  //           ...(form.getFieldValue("freightInsLedgers") || []),
  //         ];
  //         freightInsLedgers.pop();
  //         freightInsLedgers.push({
  //           gstRate: 0,
  //           gstAmount: 0,
  //           totalAmount: 0,
  //           amount: 0,
  //           id: {
  //             label: addLedgerResponse?.ledgerName,
  //             value: addLedgerResponse.id,
  //             key: addLedgerResponse.id,
  //           },
  //         });
  //         freightInsLedgers.push({
  //           gstRate: 0,
  //           gstAmount: 0,
  //           totalAmount: 0,
  //           amount: 0,
  //           id: {
  //             label: "",
  //             value: "",
  //             key: "",
  //           },
  //         });
  //         const index = freightInsLedgers.findIndex(
  //           (ledgerArray) => ledgerArray?.id?.value === addLedgerResponse.id
  //         );
  //         form.setFieldValue("freightInsLedgers", freightInsLedgers);
  //         freightInsLedgersSelect(addLedgerResponse.id, index);
  //       }
  //       setAddLedgerResponse(null);
  //     }
  //   } catch (error) {
  //     console.log("error", error);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [freightAndInsuranceOptions]);

  const CustomerSelect: any = async (
    value: string,
    onlyFirstEdit: boolean = false,
    newParty: boolean = false
  ) => {
    form.setFieldValue("purchaseOrderRef", "");
    // if (newParty) {
    //   form.setFieldValue("effectiveLedger", "");
    //   setOrderListOptions([]);
    // }
    console.log("customerAddress CustomerSelect", value, onlyFirstEdit);
    if (value) {
      let findCutomerDetails = customerOptions.find(
        (Ledgerlist: any) => Ledgerlist?.id === value
      );
      // console.log("findCutomerDetails", findCutomerDetails);
      if (!onlyFirstEdit) {
        if (
          splitPathInVchType === Voucher_Type.SalesOrder ||
          splitPathInVchType === Voucher_Type.PInvoice ||
          splitPathInVchType === Voucher_Type.Quotation
        ) {
          if (findCutomerDetails?.addresses) {
            customerAddSelect(
              findCutomerDetails?.addresses[0]?.addressName,
              findCutomerDetails?.addresses[0]?.type,
              AddressEnum.BillingAddress,
              findCutomerDetails?.addresses
            );
          } else if (
            findCutomerDetails?.partyType === PartyType.IndividualPerson
          ) {
            form.setFieldValue(["billingAddress", "address"], "");
            // form.setFieldValue(["billingAddress", "type"], {});
            form.setFieldValue(
              "supplyState",
              findCutomerDetails?.state !== 0
                ? findCutomerDetails?.state
                : currentCustomerState
            );
          } else {
            form.setFieldValue(["billingAddress", "address"], "");
            form.setFieldValue(["billingAddress", "type"], {});
            form.setFieldValue(
              "supplyState",
              findCutomerDetails?.state !== 0
                ? findCutomerDetails?.state
                : currentCustomerState
            );
          }
        } else {
          setPurchasePartyState(findCutomerDetails?.state);
          // customerAddSelect(
          //   customerAddress[0]?.addressName,
          //   customerAddress[0]?.type,
          //   AddressEnum.BillingAddress,
          //   customerAddress
          // );

          form.setFieldValue(
            "supplyState",
            findCutomerDetails?.state !== 0
              ? findCutomerDetails?.state
              : undefined
          );
          form.validateFields(["supplyState"]);
        }
      }
      const gstType = partyIsGstType(
        splitPathInVchType,
        findCutomerDetails?.gstType,
        partyIsGstRegistered,
        partyIsGstRegisteredSalesInvoice
      );
      switch (findCutomerDetails?.gstType) {
        case CompanyGSTTypes.DeemedExportImport:
          setVoucherNature(Voucher_Nature.DeemedExport);
          break;
        case CompanyGSTTypes.Overseas:
          setVoucherNature(Voucher_Nature.ImportExport);
          break;
        case CompanyGSTTypes.SEZ:
          setVoucherNature(Voucher_Nature.SEZ);
          break;
        default:
          voucherNature !== Voucher_Nature.RCM &&
            setVoucherNature(Voucher_Nature.Regular);
          break;
      }

      if (
        splitPathInVchType === Voucher_Type.SalesOrder ||
        splitPathInVchType === Voucher_Type.PInvoice ||
        splitPathInVchType === Voucher_Type.Quotation
      ) {
        setCustomerAddress(findCutomerDetails?.addresses);
        setPartyIsGstRegisteredSalesInvoice(findCutomerDetails?.gstType);
      }
      setEditParty({ id: value });
      setIsPartyCompany(findCutomerDetails?.partyType);
      setSelectedParty(value);

      if (gstType) {
        if (splitPathInVchType === Voucher_Type.PurchaseOrder) {
          setPartyIsGstRegistered(gstType);
          setPartyIsGstRegisteredTrigger((x) => x + 1);
        } else {
          setPartyIsGstRegisteredSalesInvoiceTrigger((x) => x + 1);
        }
      }
      if (
        (splitPathInVchType === Voucher_Type.SalesOrder ||
          splitPathInVchType === Voucher_Type.PInvoice) &&
        !newParty
      ) {
        setOrderDropDownLoading(true);
        //  get api order(sales & purchase order) number list
        await QuotationServices.getOrderNumber(
          currentClient?.id!,
          splitPathInVchType,
          value
        )
          .then((res: any) => {
            if (res) {
              setOrderListOptions(res?.result);
              setOrderDropDownLoading(false);
              // console.log("res.result QuotationServices......", res);
            } else {
              console.error(res?.error);
              setOrderDropDownLoading(false);
            }
          })
          .catch((err: any) => console.error(err?.message));
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  };

  //------- Set sales ledger Data After Adding ledger ------
  // useEffect(() => {
  //   if (addLedgerResponse) {
  //     const exists = effectiveLedger.some(
  //       (option) => option.id === addLedgerResponse.id
  //     );
  //     if (exists) {
  //       form.setFieldValue("effectiveLedger", {
  //         ...form.getFieldValue("effectiveLedger"),
  //         key: addLedgerResponse?.id,
  //         value: addLedgerResponse?.id,
  //         label: addLedgerResponse?.ledgerName,
  //       });
  //       CustomerSelect(addLedgerResponse.id);
  //       setSelectedParty(addLedgerResponse?.id);
  //     }
  //     setAddLedgerResponse(null);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [effectiveLedger]);

  useEffect(() => {
    const getLists = async () => {
      try {
        const [tdsRes, tcsRes] = await Promise.all([
          TdsTcsServices.getTDSList(
            currentClient?.id!,
            0,
            0,
            "",
            LedgerStatus.active
          ),
          TdsTcsServices.getTCSList(
            currentClient?.id!,
            0,
            0,
            "",
            LedgerStatus.active
          ),
        ]);

        setTdsList(tdsRes && tdsRes?.length > 0 ? tdsRes : []);
        setTcsList(tcsRes?.length > 0 ? tcsRes : []);
      } catch (ex: any) {
        console.error(ex?.message);
        setTdsList([]);
        setTcsList([]);
      }
    };

    getLists();
  }, []);
  // tdsListTrigger, tcsListTrigger;

  // get currency list
  useEffect(() => {
    const getCurrencyList = async (
      clientId: string,
      start: number,
      length: number
    ) => {
      await CurrencyServices.getCurrencyList(clientId, start, length)
        .then((res: any) => {
          if (res.result?.items?.length > 0) {
            let data = res.result.items?.map((v: any, i: any) => {
              return {
                label: v?.country?.name,
                value: v?.id,
              };
            });

            setCurrencyList(data);
            // setLoading(false);
          }
        })
        .catch((ex: any) => {
          console.error(ex.message);
          // setLoading(false);
          setCurrencyList([]);
        });
    };

    if (currentClient?.id) {
      getCurrencyList(currentClient?.id, 0, 0);
    }
  }, [currentClient?.id, partyIsGstRegistered]);

  const permissionPartyAdd =
    splitPathInVchType === Voucher_Type.PurchaseOrder
      ? findUserOnlyOnePremission(
          "Master.Ledger.Suppliers.Add",
          clientSpecificRole(),
          currentClient?.id
        )
      : findUserOnlyOnePremission(
          "Master.Ledger.Customer.Add",
          clientSpecificRole(),
          currentClient?.id
        );

  const permissionBillLedgerAdd =
    splitPathInVchType === Voucher_Type.PurchaseOrder
      ? findUserOnlyOnePremission(
          "Master.Ledger.Purchase.Add",
          clientSpecificRole(),
          currentClient?.id
        )
      : findUserOnlyOnePremission(
          "Master.Ledger.Sales.Add",
          clientSpecificRole(),
          currentClient?.id
        );

  const permissionItemAdd = findUserOnlyOnePremission(
    "Master.Item.Add",
    clientSpecificRole(),
    currentClient?.id
  );

  const permissionExpensesAdd = findUserOnlyOnePremission(
    "Master.Ledger.Expenses.Add",
    clientSpecificRole(),
    currentClient?.id
  );

  return (
    <div>
      <Spin spinning={loading} indicator={<LoadingOutlined />}>
        <Layout>
          <Header
            style={{
              background: "#fff",
              top: 0,
              width: "101.5%",
              margin: "0px -14px",
              zIndex: 999,
              height: "45px",
              lineHeight: "45px",
              padding: "0px 24px",
            }}
          >
            <Row
              justify="space-between"
              // style={{ backgroundColor: "whitesmoke", padding: 0 }}
            >
              <Col className="fs-20 fw-200 themeColor ">
                <span style={{ color: themeData.themeData?.themeColor }}>
                  {settingControl.title}
                </span>

                <Dropdown
                  //overlay={itemsabc}
                  menu={{
                    items:
                      splitPathInVchType === Voucher_Type.PurchaseOrder
                        ? PurchaseDropdownItems()
                        : SalesDropdownItems(),
                    selectable: true,
                    defaultSelectedKeys: [
                      splitPathInVchType === Voucher_Type.PInvoice
                        ? "5"
                        : splitPathInVchType === Voucher_Type.SalesOrder
                        ? "4"
                        : splitPathInVchType === Voucher_Type.Quotation
                        ? "3"
                        : "-1",
                    ],
                  }}
                  trigger={["click"]}
                  autoFocus={true}
                >
                  <Typography.Link>
                    <Space>
                      <DownOutlined />
                    </Space>
                  </Typography.Link>
                </Dropdown>
              </Col>
              <Col>
                <Space>
                  <Select
                    // disabled={isLocked}
                    style={{ width: "180px", marginRight: "6px" }}
                    options={findVoucharCustomizationTemplete(
                      splitPathInVchType === Voucher_Type.SalesOrder
                        ? SettingsSections.SOrder
                        : splitPathInVchType === Voucher_Type.PInvoice
                        ? SettingsSections.PInvoice
                        : splitPathInVchType === Voucher_Type.Quotation
                        ? SettingsSections.Quotation
                        : SettingsSections.POrder,
                      companySettings?.setting?.vouchersSettings
                    )}
                    value={selectCustomizationTemplete?.templateId.toString()}
                    onChange={(e: string) => {
                      let selVoucherTemplate =
                        companySettings?.setting?.vouchersSettings?.find(
                          (vchTemp: vouchersSettings) =>
                            vchTemp.id === Utils.getNumber(e)
                        );
                      setSelectCustomizationTemplete({
                        title:
                          selVoucherTemplate?.settings?.orderSettings
                            ?.titleToBePrint,
                        templateId: selVoucherTemplate?.id!,
                      });
                      // setDefaultEffectedAccount(e);
                    }}
                  />

                  {
                    // splitPathInVchType === Voucher_Type.PurchaseVoucher &&
                    <>
                      <Select
                        style={{ width: "200px", marginRight: "10px" }}
                        disabled={
                          settingControl.defaultNature !==
                            Voucher_Nature.Regular ||
                          voucherNature === Voucher_Nature.DeemedExport ||
                          voucherNature === Voucher_Nature.ImportExport ||
                          voucherNature === Voucher_Nature.SEZ
                        }
                        options={
                          settingControl.defaultNature !==
                            Voucher_Nature.Regular &&
                          voucherNature === settingControl.defaultNature
                            ? voucherNatureOptions.filter(
                                (vNature: any) =>
                                  vNature.value === settingControl.defaultNature
                              )
                            : (settingControl.showRCM ||
                                updateTimeData.showRCM) &&
                              voucherNature !== Voucher_Nature.DeemedExport &&
                              voucherNature !== Voucher_Nature.ImportExport &&
                              voucherNature !== Voucher_Nature.SEZ
                            ? voucherNatureOptions.filter(
                                (vNature: any) =>
                                  vNature.value !==
                                    Voucher_Nature.DeemedExport &&
                                  vNature.value !==
                                    Voucher_Nature.ImportExport &&
                                  vNature.value !== Voucher_Nature.SEZ
                              )
                            : voucherNatureOptions.filter(
                                (vNature: any) =>
                                  vNature.value === voucherNature
                              )
                        }
                        defaultValue={Voucher_Nature.Regular}
                        value={voucherNature}
                        onChange={(e: Voucher_Nature) => {
                          // console.log(e);
                          setVoucherNature(e);
                          const roundOffAmount = handleRoundoff(
                            e === Voucher_Nature.RCM
                              ? footerTotal.taxableAmount +
                                  footerLedger.ledgerAmount -
                                  footerTotal.discount
                              : footerTotal.amount +
                                  footerLedger.ledgerTotalAmount,
                            form.getFieldValue("roundoffCheckbox"),
                            settingControl.roundOffType
                          );

                          form.setFieldValue("roundOff", roundOffAmount);
                          setRoundoffAmount(roundOffAmount);
                        }}
                      />
                    </>
                    //
                  }
                </Space>
              </Col>
            </Row>
          </Header>

          <Content>
            <div
              style={{
                maxHeight: "80vh",
                overflowY: "scroll",
                overflowX: "hidden",
                padding: "10px",
              }}
            >
              <Form
                form={form}
                autoComplete="off"
                name="salesInvoice"
                requiredMark={true}
                labelAlign="left"
                labelCol={{ lg: 8, xs: 24, sm: 7 }}
                wrapperCol={{ lg: 15, xs: 24, sm: 16 }}
                initialValues={{
                  supplyState: currentCustomerState,
                  roundoffCheckbox: settingControl.autoRoundOff,
                  tcsRate: 0,
                  tdsRate: 0,
                  showFreightInsLedgers: showFreightInsurance,
                  underLUT: false,
                  items: [
                    {
                      amount: { price: 0.0, qty: 0, totalAmount: 0 },
                    },
                  ],
                  freightInsLedgers: [
                    {
                      // gstRate: 0,
                      gstAmount: 0,
                      totalAmount: 0,
                      // amount: 0,
                    },
                  ],
                }}
              >
                <Row
                  justify={"space-between"}
                  style={{ width: "101.3%", overflowY: "scroll" }}
                >
                  <Col xxl={8} xl={8} lg={12} sm={24}>
                    <Form.Item
                      name="partyLedger"
                      className="mb-3"
                      label={
                        <>
                          <Col>
                            <span>Party</span>
                          </Col>
                          {selectedParty && (
                            <Col
                              className="fw-500"
                              style={{ marginLeft: "20px", marginTop: "3px" }}
                            >
                              <div
                                style={{
                                  textAlign: "end",
                                  paddingRight: "17px",
                                }}
                              >
                                <Tooltip title="View Party">
                                  <EyeOutlined
                                    onClick={() => {
                                      setEditParty({ id: selectedParty });
                                      setOpenModel({
                                        type: "addLedger",
                                        param: {
                                          open: true,
                                          ledgerByGroupsType:
                                            SearchLedgerByGroupsTypes.PartiesOnly,
                                          showName: "Party",
                                        },
                                      });
                                      setApiCallField("addParty");
                                    }}
                                  />
                                </Tooltip>
                              </div>
                            </Col>
                          )}
                        </>
                      }
                      // className="m-0 selectPlaceholder selectedItem errormsg"
                      rules={[{ required: true, message: "Select a party" }]}
                    >
                      <Select
                        ref={inputRef}
                        loading={partyDropDownLoading}
                        showSearch
                        allowClear
                        labelInValue
                        optionFilterProp="children"
                        placeholder="Party's name"
                        filterOption={(input, option) =>
                          (option?.label?.toString() ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        className="selectedItem"
                        disabled={quotationId ? true : false}
                        autoFocus={true}
                        onChange={(e: any) => {
                          const party = customerOptions.find(
                            (x: any) => x.id === e?.value
                          );
                          form.setFieldValue("purchaseOrderRef", "");
                          if (!e) {
                            setSelectedParty("");
                            setPurchaseOrderRef(null);
                            setPartyIsGstRegisteredSalesInvoiceTrigger(
                              (x) => x + 1
                            );
                            setPartyIsGstRegisteredSalesInvoice(
                              CompanyGSTTypes.Regular
                            );
                          }
                          let PanType: PanCardType;
                          if (party?.pan) {
                            if (
                              party?.pan?.split("")[3]?.toUpperCase() === "H" ||
                              party?.pan?.split("")[3]?.toUpperCase() === "P"
                            ) {
                              PanType = PanCardType.HUF;
                            } else {
                              PanType = PanCardType.Other;
                            }
                          } else {
                            PanType = PanCardType.notAvailable;
                          }
                          setPartyPanCard(PanType);

                          if (form.getFieldValue("tdsDetail")?.value) {
                            handleAllTheTotalValues(tdsOrTcs, PanType);
                          }

                          form.setFieldValue(
                            ["shippingAddress", "address"],
                            ""
                          );
                          form.setFieldValue(["shippingAddress", "type"], "");
                          setIsPartTDSOrTDS({
                            tds: party?.tdsDeductible,
                            tcs: party?.ledgerTCSApplicability,
                          });
                          setTdsOrTcs(party?.ledgerTCSApplicability ? 1 : 0);

                          // Party Wise Tcs & Tds condition
                          if (party?.ledgerTCSApplicability) {
                            setTotalTcs(totalTcs);
                            setTcsTdsPercentage(tcsTdsPercentage);

                            form.setFieldValue(
                              "tcsDetail",
                              form.getFieldValue("tcsDetail")
                            );
                            setTotalTds(0);
                            handleAllTheTotalValues();
                          } else if (party?.tdsDeductible) {
                            // &&
                            // settingControl?.showTcsTds
                            setTotalTcs(0);
                            setTotalTds(totalTds);
                            setTcsTdsPercentage(tcsTdsPercentage);
                            // setTdsPostDetail({
                            //   formNo: tdsSelect.form,
                            //   transactionType: tdsSelect.transactionType,
                            // });
                            form.setFieldValue(
                              "tdsDetail",
                              form.getFieldValue("tdsDetail")
                            );
                            handleAllTheTotalValues();
                          } else {
                            setTotalTds(0);
                            setTotalTcs(0);
                            // form.setFieldValue("tdsDetail", {});
                            // setTcsTdsPercentage(0);
                          }
                          CustomerSelect(e?.value);
                        }}
                        options={customerOptions?.map((value: any) => ({
                          value: value?.id,
                          label: value?.ledgerName.concat(
                            value?.aliasName
                              ? `${" (" + value?.aliasName + ")"}`
                              : ""
                          ),
                        }))}
                        dropdownRender={(customerOptions) => (
                          <>
                            {customerOptions}
                            {permissionPartyAdd && (
                              <>
                                <Divider style={{ margin: "5px 0px" }} />
                                <Button
                                  style={{ width: "100%" }}
                                  icon={<PlusOutlined />}
                                  type="link"
                                  onClick={() => {
                                    setEditParty({ id: "" });
                                    setOpenModel({
                                      type: "addLedger",
                                      param: {
                                        open: true,
                                        defaultGroup:
                                          splitPathInVchType ===
                                          Voucher_Type.PurchaseOrder
                                            ? {
                                                id: "6603afe599242bad67d446d3",
                                                ledgerName:
                                                  "Trade Payables - Sundry Creditors",
                                                parent:
                                                  "65af9df71a48db26effbb5a3",
                                              }
                                            : {
                                                id: "6603afaa99242bad67d446cd",
                                                ledgerName:
                                                  "Trade Receivables - Sundry Debtors",
                                                parent:
                                                  "65af9ce61a48db26effbb598",
                                              },
                                        ledgerByGroupsType:
                                          splitPathInVchType ===
                                          Voucher_Type.PurchaseOrder
                                            ? SearchLedgerByGroupsTypes.CreditorsOnly
                                            : SearchLedgerByGroupsTypes.DebtorsOnly,
                                        showName:
                                          splitPathInVchType ===
                                          Voucher_Type.PurchaseOrder
                                            ? "Supplier"
                                            : "Customer",
                                        type: "addParty",
                                      },
                                    });
                                    setApiCallField("addParty");
                                  }}
                                >
                                  {splitPathInVchType ===
                                  Voucher_Type.PurchaseOrder
                                    ? "New Supplier"
                                    : "New Customer"}
                                </Button>
                              </>
                            )}
                          </>
                        )}
                      />
                    </Form.Item>

                    {(selectedParty || id || draftId || quotationId) &&
                      // || proformaId
                      (!isPartyCompany ? (
                        <>
                          {" "}
                          <Form.Item
                            name={["billingAddress", "address"]}
                            className="mb-3"
                            label="Billing Address"
                            // rules={[
                            //   {
                            //     required: true,
                            //     message: "Billing address is required",
                            //   },
                            // ]}
                            style={{ paddingTop: "4px" }}
                          >
                            <TextArea
                              placeholder="Billing address"
                              autoSize={{ minRows: 2, maxRows: 6 }}
                              onBlur={() => {
                                if (isSameBillingAddress) {
                                  form.setFieldValue(
                                    ["shippingAddress", "type"],
                                    form.getFieldValue([
                                      "billingAddress",
                                      "type",
                                    ])
                                  );

                                  form.setFieldValue(
                                    ["shippingAddress", "address"],
                                    form.getFieldValue([
                                      "billingAddress",
                                      "address",
                                    ])
                                  );
                                }
                              }}
                              // style={{ borderTop: "none" }}
                            />
                          </Form.Item>
                          {/* Shipping Address TextArea */}
                          {(settingControl.showShippingAddress ||
                            updateTimeData.shippingAddress) && (
                            <Form.Item
                              name={["shippingAddress", "address"]}
                              label={
                                <>
                                  <span>Shipping Address</span>
                                  <Tooltip title="Same as Billing address">
                                    <span style={{ paddingLeft: "10px" }}>
                                      <Checkbox
                                        checked={isSameBillingAddress}
                                        onChange={(e) => {
                                          setIsSameBillingAddress(
                                            e.target.checked
                                          );
                                          if (e.target.checked) {
                                            form.setFieldValue(
                                              ["shippingAddress", "type"],
                                              form.getFieldValue([
                                                "billingAddress",
                                                "type",
                                              ])
                                            );

                                            form.setFieldValue(
                                              ["shippingAddress", "address"],
                                              form.getFieldValue([
                                                "billingAddress",
                                                "address",
                                              ])
                                            );
                                          }
                                        }}
                                      />
                                    </span>
                                  </Tooltip>
                                  {/* </Form.Item> */}
                                </>
                              }
                              className="mb-3"
                              // style={{ paddingTop: "4px" }}
                            >
                              <TextArea
                                autoSize={{ minRows: 2, maxRows: 6 }}
                                placeholder="Shipping address"
                                disabled={isSameBillingAddress && true}
                              />
                            </Form.Item>
                          )}
                        </>
                      ) : (
                        <>
                          <Form.Item
                            name={["billingAddress", "type"]}
                            className="inputBoxMb"
                            label="Billing Address Name"
                            // rules={[
                            //   {
                            //     required: true,
                            //     message: "Address type is required",
                            //   },
                            // ]}
                          >
                            <Select
                              showSearch
                              allowClear
                              optionFilterProp="children"
                              placeholder="Select type"
                              filterOption={false}
                              className="selectedItem"
                              labelInValue
                              options={customerAddress?.map(
                                (x: any, index: number) => ({
                                  value: x?.addressName,
                                  label: x?.addressName,
                                  title: x?.type,
                                  key: index,
                                })
                              )}
                              onChange={(e: any) =>
                                customerAddSelect(
                                  e.value,
                                  e.title,
                                  AddressEnum.BillingAddress,
                                  []
                                )
                              }
                            />
                          </Form.Item>
                          <Form.Item
                            name={["billingAddress", "address"]}
                            className="inputBoxMb"
                            label="Address"
                            // rules={[
                            //   {
                            //     required: true,
                            //     message: "Billing address is required",
                            //   },
                            // ]}
                            style={{ paddingTop: "4px" }}
                          >
                            <TextArea
                              placeholder="Billing address"
                              rows={3}
                              autoSize={{ minRows: 2, maxRows: 6 }}
                              onBlur={() => {
                                if (isSameBillingAddress) {
                                  form.setFieldValue(
                                    ["shippingAddress", "type"],
                                    form.getFieldValue([
                                      "billingAddress",
                                      "type",
                                    ])
                                  );

                                  form.setFieldValue(
                                    ["shippingAddress", "address"],
                                    form.getFieldValue([
                                      "billingAddress",
                                      "address",
                                    ])
                                  );
                                }
                              }}
                              // style={{ borderTop: "none" }}
                            />
                          </Form.Item>

                          {/* Shipping Address TextArea */}
                          {(settingControl.showShippingAddress ||
                            updateTimeData.shippingAddress) && (
                            <>
                              <Row>
                                <Col span={8}>
                                  <span>Shipping Address</span>
                                </Col>
                                <Col
                                  span={16}
                                  style={{ justifyContent: "end" }}
                                >
                                  <Tooltip title="Same as Billing address">
                                    <span>
                                      <Checkbox
                                        checked={isSameBillingAddress}
                                        onChange={(e) => {
                                          setIsSameBillingAddress(
                                            e.target.checked
                                          );
                                          if (e.target.checked) {
                                            form.setFieldValue(
                                              ["shippingAddress", "type"],
                                              form.getFieldValue([
                                                "billingAddress",
                                                "type",
                                              ])
                                            );

                                            form.setFieldValue(
                                              ["shippingAddress", "address"],
                                              form.getFieldValue([
                                                "billingAddress",
                                                "address",
                                              ])
                                            );
                                          }
                                        }}
                                      />
                                    </span>
                                  </Tooltip>
                                </Col>
                              </Row>
                              <Form.Item
                                name={["shippingAddress", "type"]}
                                className="inputBoxMb"
                                label="Address Name"
                                // rules={[
                                //   {
                                //     required: true,
                                //     message: "Address type is required",
                                //   },
                                // ]}
                              >
                                <Select
                                  disabled={isSameBillingAddress && true}
                                  showSearch
                                  allowClear
                                  optionFilterProp="children"
                                  placeholder="Select type"
                                  filterOption={false}
                                  className="selectedItem"
                                  labelInValue
                                  options={customerAddress?.map(
                                    (x: any, index: number) => ({
                                      value: x?.addressName,
                                      label: x?.addressName,
                                      title: x?.type,
                                      key: index,
                                    })
                                  )}
                                  onChange={(e: any) =>
                                    customerAddSelect(
                                      e.value,
                                      e.title,
                                      AddressEnum.ShippingAddress,
                                      []
                                    )
                                  }
                                />
                              </Form.Item>
                              <Form.Item
                                label="Address"
                                name={["shippingAddress", "address"]}
                                className="inputBoxMb"
                                style={{ paddingTop: "4px" }}
                              >
                                <TextArea
                                  autoSize={{ minRows: 2, maxRows: 6 }}
                                  placeholder="Shipping address"
                                  disabled={isSameBillingAddress && true}
                                />
                              </Form.Item>
                            </>
                          )}
                        </>
                      ))}
                  </Col>

                  <Col xxl={8} xl={8} lg={12} sm={24}>
                    <Form.Item
                      name="number"
                      label={
                        <>
                          <span>
                            {splitPathInVchType === Voucher_Type.PInvoice
                              ? "Proforma Inv. No."
                              : splitPathInVchType === Voucher_Type.SalesOrder
                              ? "Sales Order No."
                              : splitPathInVchType === Voucher_Type.Quotation
                              ? "Estimate No."
                              : "Purchase Order No."}
                          </span>
                        </>
                      }
                      style={{ width: "100%" }}
                      className="mb-3"
                      rules={[
                        {
                          required: true,
                          message: "Please enter order No.",
                        },
                      ]}
                    >
                      {voucherNumberLoader ? (
                        <Skeleton.Input
                          active={true}
                          size="default"
                          style={{ width: "100%" }}
                          className="responsive-skeleton-input"
                        />
                      ) : (
                        <Input
                          disabled={!settingControl.manualNumbering}
                          placeholder={
                            splitPathInVchType === Voucher_Type.PInvoice
                              ? "Invoice No."
                              : "Order No."
                          }
                          style={{
                            backgroundColor: settingControl.manualNumbering
                              ? ""
                              : `${themeData.themeData?.themeColor}40`,
                          }}
                        />
                      )}
                    </Form.Item>
                    {splitPathInVchType === Voucher_Type.PurchaseOrder && (
                      <>
                        <Form.Item
                          label="Order Ref. No."
                          name="supplierInvoiceRef"
                          className="mb-3"
                        >
                          <Input />
                        </Form.Item>

                        <Form.Item
                          name="supplierInvoiceDate"
                          label="Order Ref. Date"
                          className="mb-3"
                        >
                          <DatePicker
                            format="DD/MM/YYYY"
                            style={{ width: "100%" }}
                            allowClear={true}
                            disabledDate={(current: any) =>
                              current <
                                dayjs(currentClient?.financialYearBegin) ||
                              current >=
                                dayjs(currentClient?.financialYearBegin).add(
                                  2,
                                  "year"
                                )
                            }
                          />
                        </Form.Item>
                      </>
                    )}
                    <Form.Item
                      name="effectiveLedger"
                      className="mb-3"
                      label={
                        <>
                          <span>
                            {splitPathInVchType === Voucher_Type.PurchaseOrder
                              ? "Purchase Ledger"
                              : "Sales Ledger"}
                          </span>
                        </>
                      }
                      rules={[
                        {
                          required: true,
                          message: `Please select ledger`,
                        },
                      ]}
                    >
                      <Select
                        loading={salesLedDropDownLoading}
                        labelInValue
                        showSearch
                        allowClear={false}
                        placeholder="Select ledger"
                        placement="bottomLeft"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label?.toString() ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={effectiveLedger?.map((x: any) => ({
                          value: x?.id,
                          label: x?.ledgerName.concat(
                            x?.aliasName ? `${" (" + x?.aliasName + ")"}` : ""
                          ),
                        }))}
                        dropdownRender={(customerOptions) => (
                          <>
                            {customerOptions}
                            {permissionBillLedgerAdd && (
                              <>
                                <Divider style={{ margin: "5px 0px" }} />
                                <Button
                                  style={{ width: "100%" }}
                                  icon={<PlusOutlined />}
                                  type="link"
                                  onClick={() => {
                                    setEditParty({ id: "" });
                                    setOpenModel({
                                      type: "addLedger",
                                      param: {
                                        open: true,
                                        defaultGroup:
                                          splitPathInVchType ===
                                          Voucher_Type.PurchaseOrder
                                            ? {
                                                id: "6603b13f99242bad67d446ed",
                                                ledgerName:
                                                  "Domestic Purchases",
                                                parent:
                                                  "65af9b7d1a48db26effbb58e",
                                              }
                                            : {
                                                id: "6603b14799242bad67d446ee",
                                                ledgerName: "Domestic Sales",
                                                parent:
                                                  "65af9be21a48db26effbb591",
                                              },
                                        ledgerByGroupsType:
                                          splitPathInVchType ===
                                          Voucher_Type.PurchaseOrder
                                            ? SearchLedgerByGroupsTypes.Purchase
                                            : SearchLedgerByGroupsTypes.Sales,
                                        showName:
                                          splitPathInVchType ===
                                          Voucher_Type.PurchaseOrder
                                            ? "Purchase"
                                            : "Sale",
                                      },
                                    });
                                    setApiCallField("salesLedger");
                                  }}
                                >
                                  New Ledger
                                </Button>
                              </>
                            )}
                          </>
                        )}
                      />
                    </Form.Item>
                    {(((splitPathInVchType === Voucher_Type.SalesOrder ||
                      splitPathInVchType === Voucher_Type.PInvoice ||
                      splitPathInVchType === Voucher_Type.Quotation) &&
                      partyIsGstRegisteredSalesInvoice !==
                        CompanyGSTTypes.Overseas) ||
                      (splitPathInVchType === Voucher_Type.PurchaseOrder &&
                        partyIsGstRegistered !== CompanyGSTTypes.Overseas)) && (
                      <Form.Item
                        label={
                          <>
                            <span>
                              {splitPathInVchType === Voucher_Type.PurchaseOrder
                                ? "Origin of Supply"
                                : "Place of Supply"}
                            </span>
                          </>
                        }
                        name="supplyState"
                        className="mb-3"
                        rules={[
                          {
                            required: true,
                            message:
                              splitPathInVchType === Voucher_Type.PurchaseOrder
                                ? "Origin of supply is required"
                                : "Place of supply is required",
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          allowClear={false}
                          placeholder="Select State"
                          placement="bottomLeft"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          onSelect={(val) => setPurchasePartyState(val)}
                          options={Object.entries(stateOptions)?.map(
                            ([key, x]: any) => ({
                              value: x?.id,
                              label: x?.name,
                            })
                          )}
                        />
                      </Form.Item>
                    )}
                    {/* // Reference of party's order */}
                    {selectedParty &&
                      (splitPathInVchType === Voucher_Type.SalesOrder ||
                        splitPathInVchType === Voucher_Type.PInvoice) && (
                        <Form.Item
                          name="purchaseOrderRef"
                          className="mb-3"
                          label={
                            <>
                              <span>
                                {splitPathInVchType === Voucher_Type.SalesOrder
                                  ? "Estimate No."
                                  : "Order No."}
                              </span>
                            </>
                          }
                        >
                          <Select
                            disabled={quotationId ? true : false}
                            loading={orderDropDownLoading}
                            showSearch
                            allowClear
                            placeholder="Select "
                            placement="bottomLeft"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            onChange={(e: any) => {
                              if (e === undefined || e === null) {
                                setPurchaseOrderRef(e);
                                setPurchaseOrderRefTrigger(0);
                                form.setFieldValue("items", [
                                  {
                                    amount: {
                                      price: 0.0,
                                      qty: 0,
                                      totalAmount: 0,
                                    },
                                  },
                                ]);
                                form.setFieldValue("freightInsLedgers", [
                                  {
                                    // gstRate: 0,
                                    gstAmount: 0,
                                    totalAmount: 0,
                                    amount: 0,
                                  },
                                ]);
                                setFooterTotal({
                                  qty: 0,
                                  unitPrice: 0,
                                  taxableAmount: 0,
                                  discount: 0,
                                  gst: 0,
                                  amount: 0,
                                });
                                setFooterLedger({
                                  ledgerAmount: 0,
                                  ledgerGstAmount: 0,
                                  ledgerTotalAmount: 0,
                                });
                              } else {
                                setPurchaseOrderRef(e);
                                setPurchaseOrderRefTrigger((x) => x + 1);
                              }
                            }}
                            options={orderListOptions?.map((x: any) => ({
                              value: x?.voucherId,
                              label: x?.voucherNumber,
                            }))}
                          />
                        </Form.Item>
                      )}
                  </Col>

                  <Col xxl={8} xl={8} lg={12} sm={24}>
                    <Form.Item name="date" className="m-0" label="Date">
                      <DatePicker
                        format="DD/MM/YYYY"
                        disabledDate={(current: any) =>
                          purchaseOrderDate
                            ? current < dayjs(purchaseOrderDate).startOf("day")
                            : current <
                                dayjs(currentClient?.financialYearBegin) ||
                              current >=
                                dayjs(currentClient?.financialYearBegin).add(
                                  2,
                                  "year"
                                )
                        }
                        style={{ width: "100%" }}
                        allowClear={false}
                        onChange={(val) => {
                          if (dueOn) {
                            let dueDate = dayjs(val, "DD/MM/YYYY").add(
                              dueOn,
                              "day"
                            );
                            form.setFieldValue("dueDate", dueDate);
                          }
                          setDateFiled(dayjs(val).toISOString());
                        }}
                      />
                    </Form.Item>
                    {(partyIsGstRegistered === CompanyGSTTypes.Overseas ||
                      partyIsGstRegisteredSalesInvoice ===
                        CompanyGSTTypes.Overseas ||
                      partyIsGstRegistered === CompanyGSTTypes.SEZ ||
                      partyIsGstRegisteredSalesInvoice ===
                        CompanyGSTTypes.SEZ) && (
                      <>
                        <Form.Item
                          name="underLUT"
                          className="mb-3"
                          label="Under LUT"
                          valuePropName="checked"
                        >
                          <Checkbox
                            value={underLUT}
                            onChange={(e) => setUnderLUT(e.target.checked)}
                          />
                        </Form.Item>

                        <Form.Item
                          name="currency"
                          className="mb-3"
                          label="Currency"
                        >
                          <Select
                            allowClear
                            showSearch
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            options={currencyList}
                            onChange={(value, option) => {
                              form.setFieldsValue({
                                currency: {
                                  value: option.value,
                                  label: option.label,
                                },
                              });
                            }}
                          />
                        </Form.Item>

                        <Form.Item
                          name="conversionRate"
                          className="mb-3"
                          label="Conversion rate"
                        >
                          <InputNumber
                            controls={false}
                            precision={2}
                            style={{ width: "100%" }}
                            onFocus={(e) => {
                              handleInputFocus(e, form);
                            }}
                            onKeyPress={handleDecimalValues}
                          />
                        </Form.Item>
                      </>
                    )}
                    {(settingControl.showFreightType ||
                      updateTimeData.showFreightType) && (
                      <Form.Item
                        name="freightType"
                        label="Freight Type"
                        className="mb-3 errormsg"
                      >
                        <Select
                          // disabled={salesOrderId ? true : false}
                          showSearch
                          placeholder="Select freight"
                          allowClear
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          options={FreightTypeOptions}
                        />
                      </Form.Item>
                    )}
                  </Col>
                </Row>

                {/* Item Table */}
                <div
                  // className="tableWrapper"
                  style={{ overflowY: "auto" }}
                >
                  <Row
                    style={{
                      marginTop: "15px",
                      width: "100%",
                      backgroundColor: "white",
                      padding: "3px 5px",
                      fontSize: "15px",
                      fontWeight: "bolder",
                      borderRadius: "8px",
                    }}
                  >
                    <Col style={{ alignContent: "center" }} span={12}>
                      <span>Item Detail</span>
                    </Col>

                    {(settingControl.discountPolicy ===
                      Discount_Policy.TradenCashDiscount ||
                      settingControl.discountPolicy ===
                        Discount_Policy.OnlyTradeDiscount ||
                      updateTimeData.tradeDiscount) && (
                      <Col span={12}>
                        <Row gutter={6} justify={"end"}>
                          <Col style={{ paddingTop: "4px" }}>
                            <span>Discount (%)</span>
                          </Col>

                          <Col>
                            <Form.Item
                              className="discountInput inputBoxMb"
                              // name={["amount", "dics"]}
                              name="discount"
                            >
                              <InputNumber
                                placeholder="0.0"
                                controls={false}
                                min={0.0}
                                max={100}
                                precision={2}
                                style={{
                                  width: "160px",
                                  // margin: "0px 30px 0px 10px",
                                  // width: 60,
                                }}
                                onChange={(e: any) => {
                                  // console.log(e);
                                  handleItemsAllDiscount(e);
                                }}
                                onFocus={(e) => {
                                  handleInputFocus(e, form);
                                }}
                                onKeyPress={handleDecimalValues}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                    )}
                  </Row>
                  <table
                    // dashedBorderTop
                    className="AddPageTabelDesign "
                    style={{ fontSize: windowWidth <= 1024 ? "10.3px" : "" }}
                  >
                    <thead>
                      <tr>
                        <th
                          colSpan={2}
                          rowSpan={2}
                          style={{ fontWeight: "500", width: "5%" }}
                        >
                          S.No.
                        </th>
                        <th
                          rowSpan={2}
                          style={{
                            fontWeight: "500",
                            width: "30%",
                            // maxWidth: "14%",
                            borderLeft: "1px solid rgb(240, 245, 255)",
                          }}
                        >
                          <Row
                            justify={"space-between"}
                            style={{ padding: "0px 5px" }}
                          >
                            <Col span={12} style={{ textAlign: "start" }}>
                              <span>Item(s)</span>
                            </Col>
                            {itemSetting?.isBarcode && (
                              <Col span={12} style={{ textAlign: "end" }}>
                                <Checkbox
                                  onChange={(e) =>
                                    SetIsBarCodeSearch(e?.target?.checked)
                                  }
                                >
                                  <Tooltip title={"Search by Bar Code"}>
                                    <BarcodeOutlined
                                      style={{
                                        fontSize: "20px",
                                        marginTop: "4px",
                                      }}
                                    />
                                  </Tooltip>{" "}
                                </Checkbox>
                              </Col>
                            )}
                          </Row>
                        </th>
                        {/* <th
                    rowSpan={2}
                    style={{
                      fontWeight: "500",
                      // width: windowWidth <= 1024 ? "22%" : "",
                      width: "22%",
                    }}
                  >
                    Description
                  </th> */}
                        {/* <th rowSpan={2} style={{ fontWeight: "500", width: "10%" }}>
                    Account
                  </th> */}
                        {itemSetting?.batchTracking ||
                          (itemSetting?.serialTracking && (
                            <th rowSpan={3} style={{ width: "3%" }}>
                              Type
                            </th>
                          ))}
                        <th
                          rowSpan={2}
                          style={{ fontWeight: "500", width: "7%" }}
                        >
                          Qty
                        </th>
                        {/* <th rowSpan={2} style={{ fontWeight: "500", width: "6%" }}>
                    Unit
                  </th> */}
                        <th
                          rowSpan={3}
                          style={{ fontWeight: "500", width: "9%" }}
                        >
                          Unit Price
                        </th>
                        {(settingControl.discountPolicy ===
                          Discount_Policy.TradenCashDiscount ||
                          settingControl.discountPolicy ===
                            Discount_Policy.OnlyTradeDiscount ||
                          updateTimeData.tradeDiscount) && (
                          <th
                            colSpan={2}
                            style={{ fontWeight: "500", width: "15%" }}
                          >
                            Discount
                          </th>
                        )}
                        {(currentClient?.gstType === CompanyGSTTypes.Regular ||
                          updateTimeData.isGSTVoucher ||
                          splitPathInVchType ===
                            Voucher_Type.PurchaseOrder) && (
                          <th
                            colSpan={2}
                            style={{ fontWeight: "500", width: "15%" }}
                          >
                            GST
                          </th>
                        )}
                        <th
                          colSpan={2}
                          rowSpan={2}
                          style={{ fontWeight: "500", width: "14%" }}
                        >
                          Gross Amount
                        </th>
                      </tr>
                      <tr>
                        {(settingControl.discountPolicy ===
                          Discount_Policy.TradenCashDiscount ||
                          settingControl.discountPolicy ===
                            Discount_Policy.OnlyTradeDiscount ||
                          updateTimeData.tradeDiscount) && (
                          <>
                            <th style={{ fontWeight: "500", width: "5%" }}>
                              %
                            </th>
                            <th style={{ fontWeight: "500", width: "5%" }}>
                              ₹
                            </th>
                          </>
                        )}
                        {(currentClient?.gstType === CompanyGSTTypes.Regular ||
                          updateTimeData.isGSTVoucher ||
                          splitPathInVchType ===
                            Voucher_Type.PurchaseOrder) && (
                          <>
                            <th style={{ fontWeight: "500", width: "6%" }}>
                              %
                            </th>
                            <th style={{ fontWeight: "500", width: "6%" }}>
                              ₹
                            </th>
                          </>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      <Form.List
                        name="items"
                        initialValue={[
                          {
                            amount: { price: 0.0, qty: 0, totalAmount: 0 },
                          },
                        ]}
                      >
                        {(fields, { add, remove, move }) => {
                          return (
                            <>
                              {confirmation && (
                                <ConfirmationModal
                                  open={confirmation}
                                  text={`Do you really want to delete this item "${form.getFieldValue(
                                    ["items", deleteItemList, "name"]
                                  )}" ?`}
                                  // text="Do you really want to delete this row?"
                                  onNo={() => setConfirmation(false)}
                                  onYes={() => {
                                    remove(deleteItemList);
                                    handleDeleteRowButton();
                                    setItemLength(fields.length - 2);
                                  }}
                                />
                              )}
                              {fields.map(
                                ({ key, name, ...restField }, index) => {
                                  return (
                                    <tr key={key}>
                                      <td>
                                        {fields.length !== index + 1 && (
                                          <div>{index + 1}.</div>
                                        )}
                                      </td>
                                      <td
                                        align="center"
                                        style={{
                                          verticalAlign: "top",
                                        }}
                                      >
                                        {fields.length !== index + 1 &&
                                          form?.getFieldValue(["items", name])
                                            ?.id && (
                                            <Form.Item
                                              name={[name, "isService"]}
                                              className="m-0"
                                              {...restField}
                                              wrapperCol={{ span: 25 }}
                                            >
                                              {form.getFieldValue([
                                                "items",
                                                index,
                                                "isService",
                                              ]) ? (
                                                <Tooltip
                                                  title="Service"
                                                  placement="left"
                                                  color="#1d39c4"
                                                >
                                                  <Avatar
                                                    style={{
                                                      cursor: "pointer",
                                                      verticalAlign: "middle",
                                                      color: "#1d39c4",
                                                      backgroundColor:
                                                        "#f0f5ff",
                                                      borderColor: "#adc6ff",
                                                      fontWeight: "bold",
                                                    }}
                                                    size="small"
                                                  >
                                                    S
                                                  </Avatar>
                                                </Tooltip>
                                              ) : (
                                                <Tooltip
                                                  title="Goods"
                                                  placement="left"
                                                  color="#389e0d"
                                                >
                                                  <Avatar
                                                    style={{
                                                      cursor: "pointer",
                                                      verticalAlign: "middle",
                                                      color: "#389e0d",
                                                      backgroundColor:
                                                        "#f6ffed",
                                                      borderColor: "#b7eb8f",
                                                      fontWeight: "bold",
                                                    }}
                                                    size="small"
                                                  >
                                                    G
                                                  </Avatar>
                                                </Tooltip>
                                              )}
                                            </Form.Item>
                                          )}
                                        {fields.length !== index + 1 &&
                                          form?.getFieldValue(["items", name])
                                            ?.id && (
                                            <>
                                              <Form.Item
                                                name={[name, "isTaxable"]}
                                                className="m-0"
                                                {...restField}
                                                wrapperCol={{
                                                  xl: 25,
                                                }}
                                              >
                                                {form.getFieldValue([
                                                  "items",
                                                  index,
                                                  "isTaxable",
                                                ]) ? (
                                                  <Tooltip
                                                    title="Inclusive Tax"
                                                    color="#08979C"
                                                  >
                                                    <Avatar
                                                      style={{
                                                        cursor: "pointer",
                                                        verticalAlign: "middle",
                                                        color: "#08979C",
                                                        backgroundColor:
                                                          "#E6FFFB",
                                                        borderColor:
                                                          "rgb(127 231 235)",
                                                        fontWeight: "bold",
                                                      }}
                                                      size="small"
                                                    >
                                                      IT
                                                    </Avatar>
                                                  </Tooltip>
                                                ) : (
                                                  <Tooltip
                                                    title="Exclusive Tax"
                                                    color="#531DAB"
                                                  >
                                                    <Avatar
                                                      style={{
                                                        cursor: "pointer",
                                                        textAlign: "center",
                                                        color: "#531DAB",
                                                        backgroundColor:
                                                          "#F9F0FF",
                                                        borderColor:
                                                          "rgb(193 166 239)",
                                                        fontWeight: "bold",
                                                      }}
                                                      size="small"
                                                    >
                                                      ET
                                                    </Avatar>
                                                  </Tooltip>
                                                  // </Row>
                                                )}
                                              </Form.Item>
                                            </>
                                          )}
                                      </td>
                                      {/* Item(s) */}
                                      <td style={{ verticalAlign: "top" }}>
                                        <Form.Item
                                          name={[name, "id"]}
                                          className="m-0"
                                          {...restField}
                                          wrapperCol={{ span: 25 }}
                                          rules={[
                                            {
                                              required:
                                                name === fields.length - 1 &&
                                                fields.length !== 1
                                                  ? false
                                                  : true,
                                              message: "Please select item!",
                                            },
                                          ]}
                                        >
                                          <Select
                                            onSelect={(selectedValue: any) => {
                                              const selectedItem =
                                                itemsOption?.find(
                                                  (itm: any) =>
                                                    itm?.id === selectedValue
                                                );
                                              setCheckedType(selectedItem);
                                              setIndex(index);
                                              setBatchItmId(selectedItem?.id);
                                              setItmData(
                                                selectedItem?.serialItem
                                                  ?.length > 0
                                                  ? selectedItem?.serialItem
                                                  : selectedItem?.batchItem
                                              );

                                              splitPathInVchType ===
                                              Voucher_Type.PurchaseOrder
                                                ? setOpenModel({
                                                    type:
                                                      selectedItem?.trackingType ===
                                                      Item_Nature.Serial
                                                        ? "serialNo"
                                                        : selectedItem?.trackingType ===
                                                          Item_Nature.Batch
                                                        ? "batchItem"
                                                        : "",
                                                    param: {
                                                      open: true,
                                                    },
                                                  })
                                                : setOpenModel({
                                                    type:
                                                      selectedItem?.serialItem
                                                        ?.length > 0
                                                        ? "serialNo"
                                                        : selectedItem
                                                            ?.batchItem
                                                            ?.length > 0
                                                        ? "batchItem"
                                                        : "",
                                                    param: {
                                                      open: true,
                                                    },
                                                  });
                                            }}
                                            variant="filled"
                                            className="variantFilledSelect"
                                            loading={itmLedDropDownLoading}
                                            // allowClear={
                                            //   fields.length !== index + 1 && true
                                            // }
                                            // clearIcon={<span>{<EyeOutlined />}</span>}
                                            // onClear={() => remove(name)}
                                            // setConfirmation(true);
                                            showSearch
                                            placeholder="Search for item"
                                            optionFilterProp="children"
                                            filterOption={false}
                                            popupMatchSelectWidth={false}
                                            disabled={
                                              quotationId ? true : false
                                            }
                                            listItemHeight={1}
                                            style={{
                                              minWidth: "100%",
                                              maxWidth: "240px",
                                              backgroundColor: "#FFFFFF",
                                            }}
                                            dropdownStyle={{ width: "250px" }}
                                            placement="bottomRight"
                                            notFoundContent={
                                              <Empty
                                                image={
                                                  Empty.PRESENTED_IMAGE_SIMPLE
                                                }
                                                description={
                                                  <span>
                                                    Sales item not found.
                                                  </span>
                                                }
                                              />
                                            }
                                            // prefixCls={<EyeOutlined />}
                                            onSearch={(value) => {
                                              if (isBarCodeSearch) {
                                                setBarCodeSearch(value);
                                              } else {
                                                setItemSearch(value);
                                              }
                                            }}
                                            onClick={() => {
                                              const getData =
                                                form?.getFieldValue([
                                                  "items",
                                                  name,
                                                ]);
                                              if (
                                                getData?.batchItem ||
                                                (getData?.serialItem &&
                                                  getData?.id === batchItmId) ||
                                                getData?.batchItem?.[0]
                                                  ?.trackingType ===
                                                  Item_Nature.Batch ||
                                                getData?.trackingType ===
                                                  Item_Nature?.Serial
                                              ) {
                                                setBatchItmId(getData?.id);
                                                setSelectedBatchData(getData);
                                              }

                                              const sNo =
                                                getData?.serialItem?.map(
                                                  (itm: any) => itm.serialNumber
                                                ) || [];

                                              const updatedAllSerial =
                                                filterSerial.filter(
                                                  (serialItem: any) =>
                                                    !sNo.includes(
                                                      serialItem.serialNumber
                                                    )
                                                );

                                              setSerial(updatedAllSerial);

                                              setAlReadySelectedData([]);
                                              setNewItem({
                                                data: {},
                                                isSaved: false,
                                                isEdited: false,
                                              });
                                              handleRowClick(index);
                                            }}
                                            onChange={(value: any) => {
                                              if (fields.length === index + 1)
                                                add();
                                              itemSelect(value, index);
                                              setRefreshDeleteBatch(
                                                (x: boolean) => !x
                                              );
                                            }}
                                            optionRender={(itm) => (
                                              <div>
                                                <Row justify={"space-between"}>
                                                  <Col>
                                                    <p
                                                      style={{
                                                        fontWeight: "bold",
                                                        color: "dimgray",
                                                      }}
                                                    >
                                                      {itm?.label}
                                                    </p>
                                                  </Col>
                                                </Row>
                                                <div>
                                                  {itm.data?.hsnCode && (
                                                    <span>
                                                      <span
                                                        style={{
                                                          fontWeight: "500",
                                                          color: "dimgray",
                                                        }}
                                                      >
                                                        HSN Code -
                                                      </span>
                                                      {itm.data.hsnCode}
                                                    </span>
                                                  )}
                                                  {itm.data?.sacCode && (
                                                    <span
                                                      style={{
                                                        paddingLeft: "5px",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          fontWeight: "500",
                                                          color: "dimgray",
                                                        }}
                                                      >
                                                        SAC Code -
                                                      </span>
                                                      {itm.data?.sacCode}
                                                    </span>
                                                  )}
                                                  {itm.data?.description && (
                                                    <span
                                                      style={{
                                                        paddingLeft: "5px",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          fontWeight: "500",
                                                          color: "dimgray",
                                                        }}
                                                      >
                                                        Des. -
                                                      </span>
                                                      {itm.data?.description}
                                                    </span>
                                                  )}
                                                </div>
                                              </div>
                                            )}
                                            options={itemFilterOptions?.map(
                                              (itm: any, index: number) => ({
                                                value: itm?.id,
                                                id: itm?.id,
                                                // disabled:
                                                // itm.itemStatus ===
                                                // ItemStatus.Inactive
                                                //   ? true
                                                //   : false,
                                                hsnCode: itm?.hsnCode,
                                                sacCode: itm?.sacCode,
                                                description: itm?.description,
                                                label: itm?.name,
                                              })
                                            )}
                                            dropdownRender={(itemsOption) => (
                                              <>
                                                {itemsOption}
                                                {permissionItemAdd && (
                                                  <>
                                                    <Divider
                                                      style={{
                                                        margin: "5px 0px",
                                                      }}
                                                    />
                                                    <Button
                                                      style={{ width: "100%" }}
                                                      icon={<PlusOutlined />}
                                                      type="link"
                                                      onClick={() => {
                                                        setItemId(undefined);
                                                        setOpenModel({
                                                          type: "addItem",
                                                          param: {
                                                            open: true,
                                                          },
                                                        });
                                                        setNewItem({
                                                          data: {},
                                                          isSaved: false,
                                                          isEdited: false,
                                                        });
                                                        setItemFields({
                                                          field: fields,
                                                          index: index,
                                                        });
                                                      }}
                                                    >
                                                      New Item
                                                    </Button>
                                                  </>
                                                )}
                                              </>
                                            )}
                                          />
                                        </Form.Item>
                                        {(settingControl.showItemDescription ||
                                          updateTimeData.showItemDescription) && (
                                          <div
                                            style={{
                                              width: "100%",
                                              justifyContent: "space-between",
                                              display: "flex",
                                            }}
                                          >
                                            <div
                                              style={{
                                                width: "100%",
                                              }}
                                              // span={22}
                                            >
                                              <Form.Item
                                                className="m-0"
                                                {...restField}
                                                name={[name, "description"]}
                                                wrapperCol={{
                                                  xl: 25,
                                                }}
                                              >
                                                <Input
                                                  variant="filled"
                                                  disabled={
                                                    fields.length === index + 1
                                                  }
                                                  style={{
                                                    fontSize: "12px",
                                                    // width: "100%",
                                                  }}
                                                  placeholder="Description"
                                                  bordered={false}
                                                />
                                              </Form.Item>
                                            </div>

                                            <div
                                              style={{
                                                textAlign: "center",
                                              }}
                                            >
                                              <Button
                                                style={{
                                                  backgroundColor:
                                                    fields.length === index + 1
                                                      ? `${themeData.themeData?.themeColor}40`
                                                      : "#ececec",
                                                  border: "none",
                                                  padding: "14px 6px 13px 6px",
                                                  marginLeft: "1px",
                                                  marginTop: "2px",
                                                }}
                                                onClick={() => {
                                                  const getData =
                                                    form?.getFieldValue([
                                                      "items",
                                                      name,
                                                    ]);
                                                  console.log(
                                                    "getData",
                                                    getData
                                                  );
                                                  setItemId(getData?.id);
                                                  setOpenModel({
                                                    type: "addItem",
                                                    param: {
                                                      open: getData?.id
                                                        ? true
                                                        : false,
                                                    },
                                                  });
                                                  setItemFields({
                                                    field: fields,
                                                    index: index,
                                                  });
                                                }}
                                                disabled={
                                                  fields.length === index + 1
                                                }
                                                size="small"
                                              >
                                                <EditOutlined
                                                  style={{
                                                    fontSize: "13px",
                                                    cursor: "pointer",
                                                  }}
                                                />
                                              </Button>
                                            </div>
                                          </div>
                                        )}
                                      </td>
                                      {/* Item Tags */}
                                      {itemSetting?.batchTracking ||
                                        (itemSetting?.serialTracking && (
                                          <td align="center">
                                            {form.getFieldValue([
                                              "items",
                                              index,
                                            ])?.serialItem?.length > 0 ||
                                            form.getFieldValue(["items", index])
                                              ?.trackingType ===
                                              Item_Nature?.Serial ? (
                                              <Tooltip
                                                title="Serial Item"
                                                placement="top"
                                              >
                                                <Tag
                                                  style={{
                                                    cursor: "pointer",
                                                    margin: "m-0",
                                                  }}
                                                  onClick={() => {
                                                    setRefreshDeleteBatch(
                                                      (x: boolean) => !x
                                                    );
                                                    handleRowClick(index);
                                                    setIndex(index);
                                                    const getData =
                                                      form?.getFieldValue([
                                                        "items",
                                                        name,
                                                      ]);
                                                    console.log(
                                                      "getDatas",
                                                      getData
                                                    );
                                                    setBatchItmId(getData?.id);
                                                    if (
                                                      (getData?.batchItem &&
                                                        getData?.id ===
                                                          batchItmId) ||
                                                      (getData?.serialItem &&
                                                        getData?.id ===
                                                          batchItmId) ||
                                                      getData?.batchItem?.[0]
                                                        ?.trackingType ===
                                                        Item_Nature.Batch ||
                                                      getData?.trackingType ===
                                                        Item_Nature.Serial
                                                    ) {
                                                      setSelectedBatchData(
                                                        getData
                                                      );
                                                    }
                                                    setOpenModel({
                                                      type: "serialNo",
                                                      param: {
                                                        open: true,
                                                      },
                                                    });
                                                  }}
                                                >
                                                  S
                                                </Tag>
                                              </Tooltip>
                                            ) : form.getFieldValue([
                                                "items",
                                                name,
                                              ])?.batchItem?.length > 0 ||
                                              form.getFieldValue([
                                                "items",
                                                index,
                                              ])?.trackingType ===
                                                Item_Nature?.Batch ? (
                                              <Tooltip
                                                title="Batch Item"
                                                placement="top"
                                              >
                                                <Tag
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() => {
                                                    setRefreshDeleteBatch(
                                                      (x: boolean) => !x
                                                    );
                                                    handleRowClick(index);
                                                    setIndex(index);
                                                    const getData =
                                                      form?.getFieldValue([
                                                        "items",
                                                        name,
                                                      ]);
                                                    console.log(
                                                      "getDatas",
                                                      getData
                                                    );
                                                    setBatchItmId(getData?.id);
                                                    if (
                                                      getData?.batchItem ||
                                                      (getData?.serialItem &&
                                                        getData?.id ===
                                                          batchItmId) ||
                                                      getData?.batchItem?.[0]
                                                        ?.trackingType ===
                                                        Item_Nature.Batch ||
                                                      getData?.trackingType ===
                                                        Item_Nature.Serial
                                                    ) {
                                                      setSelectedBatchData(
                                                        getData
                                                      );
                                                    }
                                                    setOpenModel({
                                                      type: "batchItem",
                                                      param: {
                                                        open: true,
                                                      },
                                                    });
                                                  }}
                                                >
                                                  B
                                                </Tag>
                                              </Tooltip>
                                            ) : form?.getFieldValue([
                                                "items",
                                                name,
                                              ])?.id ? (
                                              <Tooltip
                                                title="Normal Item"
                                                placement="top"
                                                // color="#531DAB"
                                              >
                                                <Tag
                                                  style={{
                                                    margin: "m-0",
                                                  }}
                                                >
                                                  N
                                                </Tag>
                                              </Tooltip>
                                            ) : (
                                              <></>
                                            )}
                                          </td>
                                        ))}
                                      {/* Qty */}
                                      <td>
                                        <Form.Item
                                          className="m-0"
                                          {...restField}
                                          name={[name, "amount", "qty"]}
                                          initialValue={0.0}
                                          wrapperCol={{ span: 25 }}
                                        >
                                          <InputNumber
                                            variant="filled"
                                            min={0}
                                            step={1}
                                            precision={
                                              form.getFieldValue([
                                                "items",
                                                index,
                                              ])?.amount?.unit?.unitType ===
                                                3 ||
                                              form.getFieldValue([
                                                "items",
                                                index,
                                              ])?.amount?.unit?.unitType == null
                                                ? 0
                                                : 3
                                            }
                                            disabled={
                                              fields.length === index + 1 ||
                                              form.getFieldValue([
                                                "items",
                                                index,
                                              ])?.batchItem?.length ||
                                              form.getFieldValue([
                                                "items",
                                                index,
                                              ])?.serialItem?.length ||
                                              form.getFieldValue([
                                                "items",
                                                index,
                                              ])?.trackingType ===
                                                Item_Nature.Batch ||
                                              form.getFieldValue([
                                                "items",
                                                index,
                                              ])?.trackingType ===
                                                Item_Nature.Serial
                                            }
                                            style={{
                                              width: "100%",
                                              backgroundColor:
                                                fields.length === index + 1 ||
                                                form.getFieldValue([
                                                  "items",
                                                  index,
                                                ])?.batchItem?.length ||
                                                form.getFieldValue([
                                                  "items",
                                                  index,
                                                ])?.serialItem?.length ||
                                                form.getFieldValue([
                                                  "items",
                                                  index,
                                                ])?.trackingType ===
                                                  Item_Nature.Batch ||
                                                form.getFieldValue([
                                                  "items",
                                                  index,
                                                ])?.trackingType ===
                                                  Item_Nature.Serial
                                                  ? `${themeData.themeData?.themeColor}40`
                                                  : "#FFFFFF",
                                            }}
                                            controls={false}
                                            className="inputNumberTextEnd"
                                            onChange={() =>
                                              handleItemsNetAmmount(index)
                                            }
                                            onFocus={(e) => {
                                              handleInputFocus(e, form);
                                            }}
                                            onKeyPress={handleDecimalValues}
                                          />
                                        </Form.Item>

                                        <Form.Item
                                          name={[name, "amount", "unit"]}
                                          className="m-0"
                                          {...restField}
                                          wrapperCol={{ span: 25 }}
                                        >
                                          <Select
                                            bordered={false}
                                            // variant="filled"
                                            disabled
                                            labelInValue
                                            showSearch
                                            popupMatchSelectWidth={false}
                                            // dropdownStyle={{ width: "250px" }}
                                            // style={{ width: "140px" }}
                                            style={{
                                              minWidth: "100%",
                                              maxWidth: "240px",
                                              backgroundColor: `${themeData.themeData?.themeColor}40`,
                                            }}
                                            placement="bottomRight"
                                          />
                                        </Form.Item>
                                      </td>
                                      {/* Unit Price */}
                                      <td
                                        style={{
                                          verticalAlign: "Top",
                                          overflow: "unset",
                                        }}
                                      >
                                        <Form.Item
                                          className="m-0"
                                          {...restField}
                                          name={[name, "amount", "price"]}
                                          initialValue={0.0}
                                          wrapperCol={{ span: 25 }}
                                        >
                                          <InputNumber
                                            bordered={false}
                                            variant="filled"
                                            disabled={
                                              // salesOrderId ||
                                              // purchaseOrderId ||
                                              quotationId ||
                                              form.getFieldValue([
                                                "items",
                                                index,
                                              ])?.batchItem?.length ||
                                              form.getFieldValue([
                                                "items",
                                                index,
                                              ])?.serialItem?.length ||
                                              form.getFieldValue([
                                                "items",
                                                index,
                                              ])?.trackingType ===
                                                Item_Nature.Batch ||
                                              form.getFieldValue([
                                                "items",
                                                index,
                                              ])?.trackingType ===
                                                Item_Nature.Serial
                                                ? true
                                                : fields.length === index + 1
                                            }
                                            min={0}
                                            step={0.01}
                                            precision={2}
                                            style={{
                                              width: "100%",
                                              backgroundColor:
                                                fields.length === index + 1 ||
                                                // salesOrderId ||
                                                // purchaseOrderId ||
                                                quotationId ||
                                                form.getFieldValue([
                                                  "items",
                                                  index,
                                                ])?.batchItem?.length ||
                                                form.getFieldValue([
                                                  "items",
                                                  index,
                                                ])?.serialItem?.length ||
                                                form.getFieldValue([
                                                  "items",
                                                  index,
                                                ])?.trackingType ===
                                                  Item_Nature.Batch ||
                                                form.getFieldValue([
                                                  "items",
                                                  index,
                                                ])?.trackingType ===
                                                  Item_Nature.Serial
                                                  ? `${themeData.themeData?.themeColor}40`
                                                  : "#FFFFFF",
                                            }}
                                            controls={false}
                                            className="inputNumberTextEnd"
                                            onKeyPress={handleDecimalValues}
                                            onChange={() =>
                                              handleItemsNetAmmount(index)
                                            }
                                            onFocus={(e) => {
                                              var getData = form.getFieldValue([
                                                "items",
                                                index,
                                              ]);
                                              handleInputFocus(e, form);
                                              setShowPriceHistory(
                                                (prev: any) => {
                                                  let newValues = [...prev];
                                                  newValues[index] = true;
                                                  return newValues;
                                                }
                                              );
                                              handlePriceHistoryData(
                                                getData?.id
                                              );
                                            }}
                                            onBlur={(e) => {
                                              setShowPriceHistory(
                                                (prev: any) => {
                                                  let newValues = [...prev];
                                                  newValues[index] = false;
                                                  return newValues;
                                                }
                                              );
                                              setShowPriceHistoryData(null);
                                            }}
                                          />
                                        </Form.Item>
                                        {showPriceHistory[index] &&
                                          settingControl?.showPriceHistory &&
                                          splitPathInVchType ===
                                            Voucher_Type.PurchaseOrder && (
                                            <ShowPriceHistoryDataView
                                              data={showPriceHistoryData ?? []}
                                              themeColor={`${themeData.themeData?.themeColor}40`}
                                              loading={showPriceHistoryLoading}
                                            ></ShowPriceHistoryDataView>
                                          )}
                                      </td>
                                      {/* Discount */}
                                      {(settingControl.discountPolicy ===
                                        Discount_Policy.TradenCashDiscount ||
                                        settingControl.discountPolicy ===
                                          Discount_Policy.OnlyTradeDiscount ||
                                        updateTimeData.tradeDiscount) && (
                                        <>
                                          <td style={{ verticalAlign: "Top" }}>
                                            <Form.Item
                                              className="m-0"
                                              {...restField}
                                              name={[
                                                name,
                                                "amount",
                                                "discount",
                                              ]}
                                              wrapperCol={{ span: 25 }}
                                            >
                                              <InputNumber
                                                variant="filled"
                                                bordered={false}
                                                precision={2}
                                                disabled={
                                                  fields.length === index + 1
                                                }
                                                className="inputNumberTextEnd"
                                                style={{
                                                  width: "100%",
                                                  backgroundColor:
                                                    fields.length === index + 1
                                                      ? `${themeData.themeData?.themeColor}40`
                                                      : "#FFFFFF",
                                                }}
                                                controls={false}
                                                min={0}
                                                max={100}
                                                onKeyPress={handleDecimalValues}
                                                onChange={() =>
                                                  handleItemsNetAmmount(index)
                                                }
                                                onFocus={(e) => {
                                                  handleInputFocus(e, form);
                                                }}
                                              />
                                            </Form.Item>
                                          </td>
                                          <td style={{ verticalAlign: "Top" }}>
                                            <Form.Item
                                              className="m-0"
                                              {...restField}
                                              name={[
                                                name,
                                                "amount",
                                                "discountRupee",
                                              ]}
                                              initialValue={0}
                                              wrapperCol={{ span: 25 }}
                                            >
                                              <InputNumber
                                                variant="filled"
                                                bordered={false}
                                                precision={2}
                                                disabled={
                                                  fields.length === index + 1
                                                }
                                                min={0}
                                                step={0.01}
                                                style={{
                                                  width: "100%",
                                                  backgroundColor:
                                                    fields.length === index + 1
                                                      ? `${themeData.themeData?.themeColor}40`
                                                      : "#FFFFFF",
                                                }}
                                                controls={false}
                                                className="inputNumberTextEnd"
                                                max={returnNetAmount(
                                                  index,
                                                  form.getFieldValue(["items"])
                                                )}
                                                onKeyPress={handleDecimalValues}
                                                onChange={() => {
                                                  onDiscountAmountChange(index);
                                                }}
                                                onFocus={(e) => {
                                                  handleInputFocus(e, form);
                                                }}
                                              />
                                            </Form.Item>
                                          </td>
                                        </>
                                      )}
                                      {/* GST */}
                                      {(((splitPathInVchType ===
                                        Voucher_Type.SalesOrder ||
                                        splitPathInVchType ===
                                          Voucher_Type.PurchaseOrder ||
                                        splitPathInVchType ===
                                          Voucher_Type.PInvoice ||
                                        splitPathInVchType ===
                                          Voucher_Type.Quotation) &&
                                        (currentClient?.gstType ===
                                          CompanyGSTTypes.Regular ||
                                          updateTimeData.isGSTVoucher)) ||
                                        (splitPathInVchType ===
                                          Voucher_Type.PurchaseOrder &&
                                          partyIsGstRegistered ===
                                            CompanyGSTTypes.Regular)) && (
                                        <>
                                          <td style={{ verticalAlign: "Top" }}>
                                            <Form.Item
                                              name={[name, "amount", "tax"]}
                                              className="m-0"
                                              {...restField}
                                              wrapperCol={{ span: 25 }}
                                            >
                                              <Select
                                                // variant="filled"
                                                bordered={false}
                                                labelInValue
                                                placeholder="GST %"
                                                disabled={
                                                  fields.length === index + 1 ||
                                                  splitPathInVchType ===
                                                    Voucher_Type.SalesOrder ||
                                                  splitPathInVchType ===
                                                    Voucher_Type.PInvoice ||
                                                  splitPathInVchType ===
                                                    Voucher_Type.Quotation
                                                }
                                                popupMatchSelectWidth={false}
                                                style={{
                                                  minWidth: "100%",
                                                  maxWidth: "100px",
                                                  backgroundColor:
                                                    fields.length === index + 1
                                                      ? `${themeData.themeData?.themeColor}40`
                                                      : "#FFFFFF",
                                                }}
                                                placement="bottomRight"
                                                onChange={() => {
                                                  handleItemsNetAmmount(index);
                                                }}
                                                options={gstOption?.map(
                                                  (gst: any) => ({
                                                    value: gst.id,
                                                    title: gst.rate,
                                                    label: gst.name,
                                                  })
                                                )}
                                              />
                                            </Form.Item>
                                            {/* {splitPathInVchType ===
                                              Voucher_Type.PurchaseOrder && (
                                              <Form.Item
                                                name={[
                                                  name,
                                                  "itcEligibilityType",
                                                ]}
                                                className="m-0"
                                                {...restField}
                                                wrapperCol={{
                                                  xl: 25,
                                                }}
                                              >
                                                <Select
                                                  bordered={false}
                                                  // variant="filled"
                                                  popupMatchSelectWidth={false}
                                                  disabled={
                                                    fields.length === index + 1
                                                  }
                                                  style={{
                                                    minWidth: "100%",
                                                    maxWidth: "100px",
                                                    // backgroundColor:
                                                    //   "#FFFFFF",
                                                  }}
                                                  placement="bottomRight"
                                                  options={
                                                    ITCEligibilityTypeOptions
                                                  }
                                                />
                                              </Form.Item>
                                            )} */}
                                          </td>

                                          <td style={{ verticalAlign: "Top" }}>
                                            <Tooltip
                                              title={form.getFieldValue([
                                                "items",
                                                index,
                                                "amount",
                                                "itemTaxAmt",
                                              ])}
                                              placement="top"
                                            >
                                              <Form.Item
                                                className="m-0"
                                                {...restField}
                                                name={[
                                                  name,
                                                  "amount",
                                                  "itemTaxAmt",
                                                ]}
                                                wrapperCol={{ span: 25 }}
                                              >
                                                <InputNumber
                                                  variant="filled"
                                                  disabled
                                                  style={{
                                                    width: "100%",
                                                    backgroundColor: `${themeData.themeData?.themeColor}40`,
                                                  }}
                                                  // step={0.01}
                                                  // controls={false}
                                                  className="inputNumberTextEnd"
                                                  formatter={(value: any) =>
                                                    value
                                                      ? Utils.getFormattedNumber(
                                                          value
                                                        )
                                                      : "0.00"
                                                  }
                                                />
                                              </Form.Item>
                                            </Tooltip>
                                          </td>
                                        </>
                                      )}
                                      {/* Gross Amount Total Amount */}
                                      <td style={{ verticalAlign: "Top" }}>
                                        <Form.Item
                                          className="m-0"
                                          {...restField}
                                          name={[name, "amount", "totalAmount"]}
                                          initialValue={0}
                                          wrapperCol={{ span: 25 }}
                                        >
                                          <InputNumber
                                            variant="filled" // min={0}
                                            bordered={false}
                                            step={0.01}
                                            precision={2}
                                            disabled={
                                              // salesOrderId ||
                                              // purchaseOrderId ||
                                              quotationId
                                                ? true
                                                : fields.length === index + 1
                                            }
                                            style={{
                                              width: "100%",
                                              backgroundColor:
                                                fields.length === index + 1 ||
                                                // salesOrderId ||
                                                // purchaseOrderId ||
                                                quotationId
                                                  ? `${themeData.themeData?.themeColor}40`
                                                  : "#FFFFFF",
                                            }}
                                            controls={false}
                                            className="inputNumberTextEnd"
                                            onKeyPress={handleDecimalValues}
                                            onChange={(value) => {
                                              onItemsTotalAmountChange(index);
                                            }}
                                            onFocus={(e) => {
                                              handleInputFocus(e, form);
                                            }}
                                          />
                                        </Form.Item>
                                      </td>
                                      {/* Delete */}
                                      <td
                                        style={{
                                          width: 25,
                                          verticalAlign: "Top",
                                        }}
                                      >
                                        {fields.length !== index + 1 && (
                                          <img
                                            className="cursor mx-1"
                                            onClick={() => {
                                              setConfirmation(true);
                                              const getData =
                                                form?.getFieldValue([
                                                  "items",
                                                  name,
                                                ]);
                                              const sNo =
                                                getData?.serialItem?.map(
                                                  (itm: any) => itm.serialNumber
                                                ) || [];
                                              const updatedAllSerial =
                                                filterSerial.filter(
                                                  (serialItem: any) =>
                                                    !sNo.includes(
                                                      serialItem.serialNumber
                                                    )
                                                );
                                              setSerial(updatedAllSerial);
                                              const bNo =
                                                getData?.batchItem?.map(
                                                  (itm: any) => itm.batchNumber
                                                ) || [];

                                              const addedBatch =
                                                addBatches?.filter(
                                                  (batchItm: any) =>
                                                    !bNo.includes(
                                                      batchItm?.batchNumber
                                                    )
                                                );
                                              setAddBatches(addedBatch);
                                              setDeleteItemList(name);
                                            }}
                                            src={deleteImg}
                                            alt="Delete"
                                          />
                                        )}
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                            </>
                          );
                        }}
                      </Form.List>
                      {/* Other Expenses  */}
                      <tr>
                        <td colSpan={3}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div>
                              {(settingControl.showOtherCharges ||
                                updateTimeData.friInsuranceOtherCharge) && (
                                <Button
                                  icon={<PlusOutlined />}
                                  size="small"
                                  style={{ backgroundColor: "ButtonFace" }}
                                  onClick={() => {
                                    setShowFreightInsurance(true);
                                    setSelectedOtherExpenses([]);
                                    setFooterLedger({
                                      ledgerAmount: 0,
                                      ledgerGstAmount: 0,
                                      ledgerTotalAmount: 0,
                                    });

                                    form.setFieldValue(
                                      ["freightInsLedgers"],
                                      [
                                        {
                                          // gstRate: 0,
                                          gstAmount: 0,
                                          totalAmount: 0,
                                          amount: 0,
                                        },
                                      ]
                                    );
                                  }}
                                  disabled={showFreightInsurance}
                                >
                                  Other Expenses
                                </Button>
                              )}
                            </div>
                            <div style={{ fontWeight: "bold" }}>Sub Total</div>
                          </div>
                        </td>
                        {itemSetting?.batchTracking ||
                          (itemSetting?.serialTracking && <td></td>)}

                        <td
                          colSpan={1}
                          className="textEnd pe-14"
                          style={{ fontWeight: "bold" }}
                        >
                          {Utils.getFormattedNumber(footerTotal.qty)}
                        </td>
                        <td></td>
                        {(settingControl.discountPolicy ===
                          Discount_Policy.TradenCashDiscount ||
                          settingControl.discountPolicy ===
                            Discount_Policy.OnlyTradeDiscount ||
                          updateTimeData.tradeDiscount) && (
                          <>
                            <td></td>
                            <td
                              className="textEnd pe-12"
                              style={{ fontWeight: "bold" }}
                            >
                              {" "}
                              {Utils.getFormattedNumber(footerTotal.discount)}
                            </td>
                          </>
                        )}
                        <td></td>
                        {(((splitPathInVchType === Voucher_Type.SalesOrder ||
                          splitPathInVchType === Voucher_Type.PInvoice ||
                          splitPathInVchType === Voucher_Type.Quotation) &&
                          (currentClient?.gstType === CompanyGSTTypes.Regular ||
                            updateTimeData.isGSTVoucher)) ||
                          (splitPathInVchType === Voucher_Type.PurchaseOrder &&
                            partyIsGstRegistered ===
                              CompanyGSTTypes.Regular)) && (
                          <>
                            <td
                              className="textEnd pe-14"
                              style={{ fontWeight: "bold" }}
                            >
                              {" "}
                              {Utils.getFormattedNumber(
                                voucherNature !== Voucher_Nature.ImportExport &&
                                  voucherNature !== Voucher_Nature.SEZ
                                  ? footerTotal.gst
                                  : 0
                              )}
                            </td>
                            <td
                              className="textEnd pe-14"
                              style={{ fontWeight: "bold" }}
                            >
                              {" "}
                              {Utils.getFormattedNumber(footerTotal.amount)}
                            </td>
                          </>
                        )}
                        <td></td>
                      </tr>

                      {/* Show Include Other Expenses */}
                      {showFreightInsurance && (
                        <>
                          {/* <table className="AddPageTabelDesignExpenses"> */}
                          <Form.List name="freightInsLedgers">
                            {(fields, { add, remove, move }) => {
                              return (
                                <>
                                  {ledgerconfirmation && (
                                    <ConfirmationModal
                                      open={ledgerconfirmation}
                                      text={
                                        "Do you really want to delete this item"
                                      }
                                      onNo={() => setLedgerConfirmation(false)}
                                      onYes={() => {
                                        setLedgerConfirmation(false);
                                        setLedgerLength(fields.length - 2);
                                        setSelectedOtherExpenses((prev) => {
                                          const newDisabledInputs = [...prev];
                                          newDisabledInputs.splice(
                                            deleteItemList,
                                            1
                                          );
                                          return newDisabledInputs;
                                        });
                                        fields.length === 0 &&
                                          setShowFreightInsurance(false);
                                        remove(deleteLedgerList);
                                        setRefreshDeleteBatch(
                                          (x: boolean) => !x
                                        );
                                        handleLedgerNetAmount(0);
                                      }}
                                    />
                                  )}
                                  {/* Other Expenses ledgers */}
                                  {fields.map(
                                    ({ key, name, ...restField }, index) => {
                                      return (
                                        <tr key={key}>
                                          <td
                                            style={{
                                              verticalAlign: "top",
                                              textAlign: "center",
                                            }}
                                          >
                                            {index + 1}
                                          </td>
                                          <td></td>
                                          <td>
                                            <Form.Item
                                              name={[name, "id"]}
                                              className="m-0"
                                              {...restField}
                                              wrapperCol={{ xl: 25 }}
                                            >
                                              <Select
                                                variant="filled"
                                                className="variantFilledSelect"
                                                labelInValue
                                                placeholder="Search for other expenses"
                                                showSearch
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                  (
                                                    option?.label?.toString() ??
                                                    ""
                                                  )
                                                    .toLowerCase()
                                                    .includes(
                                                      input.toLowerCase()
                                                    )
                                                }
                                                onChange={(e: any) => {
                                                  if (
                                                    fields.length ===
                                                    index + 1
                                                  )
                                                    add();
                                                  freightInsLedgersSelect(
                                                    e?.value,
                                                    index
                                                  );
                                                }}
                                                options={freightAndInsuranceOptions
                                                  ?.filter(
                                                    (option: any) =>
                                                      !selectedOtherExpenses.includes(
                                                        option.id
                                                      )
                                                  )
                                                  ?.map((value: any) => ({
                                                    value: value?.id,
                                                    label:
                                                      value?.ledgerName.concat(
                                                        value?.aliasName
                                                          ? `${
                                                              " (" +
                                                              value?.aliasName +
                                                              ")"
                                                            }`
                                                          : ""
                                                      ),
                                                  }))}
                                                style={{
                                                  width: "100%",
                                                  minWidth: "100%",
                                                  maxWidth: "240px",
                                                  backgroundColor: "#FFFFFF",
                                                }}
                                                dropdownRender={(
                                                  customerOptions
                                                ) => (
                                                  <>
                                                    {customerOptions}
                                                    {permissionExpensesAdd && (
                                                      <>
                                                        <Divider
                                                          style={{
                                                            margin: "5px 0px",
                                                          }}
                                                        />
                                                        <Button
                                                          style={{
                                                            width: "100%",
                                                          }}
                                                          icon={
                                                            <PlusOutlined />
                                                          }
                                                          type="link"
                                                          onClick={() => {
                                                            setEditParty({
                                                              id: "",
                                                            });
                                                            setOpenModel({
                                                              type: "addLedger",
                                                              param: {
                                                                open: true,
                                                                ledgerByGroupsType:
                                                                  splitPathInVchType ===
                                                                  Voucher_Type.PurchaseOrder
                                                                    ? SearchLedgerByGroupsTypes.DirectExpenses
                                                                    : SearchLedgerByGroupsTypes.SellingAndDistributionExpenses,
                                                                showName:
                                                                  "Expense",
                                                              },
                                                            });
                                                            setEditParty({
                                                              id: "",
                                                            });
                                                            setApiCallField(
                                                              "newExpenses"
                                                            );
                                                            setLedgerItemFields(
                                                              {
                                                                field:
                                                                  fields.length,
                                                                index: index,
                                                              }
                                                            );
                                                          }}
                                                        >
                                                          New Ledger
                                                        </Button>
                                                      </>
                                                    )}
                                                  </>
                                                )}
                                              />
                                            </Form.Item>
                                            {(settingControl.showItemDescription ||
                                              updateTimeData.showItemDescription) && (
                                              <Form.Item
                                                className="m-0"
                                                {...restField}
                                                name={[name, "description"]}
                                                wrapperCol={{
                                                  xl: 25,
                                                }}
                                              >
                                                <Input
                                                  variant="filled"
                                                  disabled={
                                                    fields.length === index + 1
                                                  }
                                                  style={{
                                                    fontSize: "12px",
                                                  }}
                                                  placeholder="Description"
                                                  bordered={false}
                                                />
                                              </Form.Item>
                                            )}
                                          </td>
                                          {itemSetting?.batchTracking ||
                                            (itemSetting?.serialTracking && (
                                              <td></td>
                                            ))}
                                          <td></td>
                                          {/* Unit Price */}
                                          <td
                                            style={{
                                              verticalAlign: "top",
                                            }}
                                          >
                                            <Form.Item
                                              name={[name, "amount"]}
                                              className="m-0"
                                              {...restField}
                                              initialValue={0.0}
                                              wrapperCol={{ span: 25 }}
                                            >
                                              <InputNumber
                                                variant="filled"
                                                bordered={false}
                                                min={0}
                                                step={0.01}
                                                precision={2}
                                                placeholder="Amount"
                                                style={{
                                                  width: "100%",
                                                  backgroundColor:
                                                    fields.length === index + 1
                                                      ? `${themeData.themeData?.themeColor}40`
                                                      : "#FFFFFF",
                                                  // marginLeft: "10px",
                                                }}
                                                disabled={
                                                  fields.length === index + 1
                                                }
                                                controls={false}
                                                className="inputNumberTextEnd"
                                                onChange={() => {
                                                  handleLedgerNetAmount(index);
                                                }}
                                                onFocus={(e) => {
                                                  handleInputFocus(e, form);
                                                }}
                                                onKeyPress={handleDecimalValues}
                                              />
                                            </Form.Item>
                                          </td>
                                          {(settingControl.discountPolicy ===
                                            Discount_Policy.TradenCashDiscount ||
                                            settingControl.discountPolicy ===
                                              Discount_Policy.OnlyTradeDiscount ||
                                            updateTimeData.tradeDiscount) && (
                                            <>
                                              <td></td>
                                              <td></td>
                                            </>
                                          )}
                                          {/* GST */}
                                          {(currentClient?.gstType ===
                                            CompanyGSTTypes.Regular ||
                                            updateTimeData.isGSTVoucher ||
                                            splitPathInVchType ===
                                              Voucher_Type.PurchaseOrder) && (
                                            <>
                                              <td
                                                style={{
                                                  verticalAlign: "top",
                                                }}
                                              >
                                                <Form.Item
                                                  name={[name, "gstRate"]}
                                                  className="m-0"
                                                  {...restField}
                                                  wrapperCol={{ span: 25 }}
                                                >
                                                  <Select
                                                    // variant="filled"
                                                    bordered={false}
                                                    // className="variantFilledSelect"
                                                    placement="bottomRight"
                                                    labelInValue
                                                    style={{
                                                      width: "100%",
                                                      backgroundColor:
                                                        fields.length ===
                                                        index + 1
                                                          ? `${themeData.themeData?.themeColor}40`
                                                          : "#FFFFFF",
                                                    }}
                                                    placeholder={"GST %"}
                                                    popupMatchSelectWidth={
                                                      false
                                                    }
                                                    onChange={() => {
                                                      if (
                                                        partyIsGstRegisteredSalesInvoice ===
                                                          CompanyGSTTypes.Overseas ||
                                                        partyIsGstRegisteredSalesInvoice ===
                                                          CompanyGSTTypes.SEZ
                                                          ? !underLUT
                                                          : true
                                                      )
                                                        handleLedgerNetAmount(
                                                          index
                                                        );
                                                    }}
                                                    disabled={
                                                      fields.length ===
                                                      index + 1
                                                    }
                                                    filterOption={(
                                                      input,
                                                      option
                                                    ) =>
                                                      (
                                                        option?.label?.toString() ??
                                                        ""
                                                      )
                                                        .toLowerCase()
                                                        .includes(
                                                          input.toLowerCase()
                                                        )
                                                    }
                                                    options={gstOption?.map(
                                                      (gst: any) => ({
                                                        value: gst?.id,
                                                        title: gst?.rate,
                                                        label: gst?.name,
                                                      })
                                                    )}
                                                  />
                                                </Form.Item>
                                                {/* {splitPathInVchType ===
                                                  Voucher_Type.PurchaseOrder && (
                                                  <Form.Item
                                                    name={[
                                                      name,
                                                      "itcEligibilityType",
                                                    ]}
                                                    className="m-0"
                                                    {...restField}
                                                    wrapperCol={{
                                                      xl: 25,
                                                    }}
                                                  >
                                                    <Select
                                                      bordered={false}
                                                      // variant="filled"
                                                      popupMatchSelectWidth={
                                                        false
                                                      }
                                                      disabled={
                                                        fields.length ===
                                                          index + 1
                                                      }
                                                      style={{
                                                        minWidth: "100%",
                                                        maxWidth: "100px",
                                                      }}
                                                      placement="bottomRight"
                                                      options={
                                                        ITCEligibilityTypeOptions
                                                      }
                                                    />
                                                  </Form.Item>
                                                )} */}
                                              </td>
                                              <td
                                                style={{
                                                  verticalAlign: "top",
                                                }}
                                              >
                                                <Form.Item
                                                  className="m-0 inputNumberTextEnd"
                                                  name={[name, "gstAmount"]}
                                                  {...restField}
                                                  wrapperCol={{ span: 25 }}
                                                >
                                                  <InputNumber
                                                    bordered={false}
                                                    variant="filled"
                                                    controls={false}
                                                    disabled
                                                    precision={2}
                                                    step={0.01}
                                                    className="variantFilledSelect"
                                                    style={{
                                                      width: "100%",
                                                      backgroundColor: `${themeData.themeData?.themeColor}40`,
                                                    }}
                                                    onChange={() => {
                                                      handleLedgerNetAmount(
                                                        index
                                                      );
                                                    }}
                                                    onFocus={(e) => {
                                                      handleInputFocus(e, form);
                                                    }}
                                                  />
                                                </Form.Item>
                                              </td>
                                            </>
                                          )}
                                          {/* Gross Amount */}
                                          <td
                                            style={{
                                              verticalAlign: "top",
                                            }}
                                          >
                                            <Form.Item
                                              name={[name, "totalAmount"]}
                                              className="m-0"
                                              {...restField}
                                              initialValue={0.0}
                                              wrapperCol={{ span: 25 }}
                                            >
                                              <InputNumber
                                                variant="filled" // disabled
                                                bordered={false}
                                                disabled={
                                                  fields.length === index + 1
                                                }
                                                style={{
                                                  width: "100%",
                                                  backgroundColor:
                                                    fields.length === index + 1
                                                      ? `${themeData.themeData?.themeColor}40`
                                                      : "#FFFFFF",
                                                }}
                                                className="inputNumberTextEnd"
                                                controls={false}
                                                step={0.01}
                                                precision={2}
                                                onChange={() => {
                                                  onLedgerTotalAmountChange(
                                                    index
                                                  );
                                                }}
                                                onFocus={(e) => {
                                                  handleInputFocus(e, form);
                                                }}
                                                onKeyPress={handleDecimalValues}
                                              />
                                            </Form.Item>
                                          </td>
                                          <td
                                            style={{
                                              verticalAlign: "top",
                                            }}
                                          >
                                            {(fields.length === 1 ||
                                              fields.length !== index + 1) && (
                                              <img
                                                className="cursor mx-1"
                                                onClick={() => {
                                                  setDeleteLedgerList(name);
                                                  setLedgerConfirmation(true);
                                                }}
                                                src={deleteImg}
                                                alt="Delete"
                                              />
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )}
                                </>
                              );
                            }}
                          </Form.List>
                          {/* Item + Other Expenses Total */}
                          <tr>
                            <td
                              colSpan={3}
                              style={{
                                fontWeight: "bold",
                                textAlign: "end",
                                padding: "0px 10px",
                              }}
                            >
                              Sub Total
                            </td>
                            {itemSetting?.batchTracking ||
                              (itemSetting?.serialTracking && <td></td>)}
                            <td></td>
                            <td
                              className="textEnd pe-14"
                              style={{ fontWeight: "bold" }}
                            >
                              {" "}
                              {Utils.getFormattedNumber(
                                footerLedger.ledgerAmount
                              )}
                            </td>
                            {/* Discount */}
                            {(settingControl.discountPolicy ===
                              Discount_Policy.TradenCashDiscount ||
                              settingControl.discountPolicy ===
                                Discount_Policy.OnlyTradeDiscount ||
                              updateTimeData.tradeDiscount) && (
                              <>
                                <td></td>
                                <td></td>
                              </>
                            )}
                            {(currentClient?.gstType ===
                              CompanyGSTTypes.Regular ||
                              updateTimeData.isGSTVoucher ||
                              splitPathInVchType ===
                                Voucher_Type.PurchaseOrder) && (
                              <>
                                <td></td>
                                <td
                                  className="textEnd pe-14"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {" "}
                                  {Utils.getFormattedNumber(
                                    voucherNature !==
                                      Voucher_Nature.ImportExport &&
                                      voucherNature !== Voucher_Nature.SEZ
                                      ? footerLedger?.ledgerGstAmount
                                      : 0
                                  )}
                                </td>
                              </>
                            )}

                            <td
                              className="textEnd pe-12"
                              style={{ fontWeight: "bold" }}
                            >
                              <span>
                                {" "}
                                {Utils.getFormattedNumber(
                                  footerLedger.ledgerTotalAmount
                                )}
                              </span>
                            </td>
                            <td></td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
                {(footerTotal.taxableAmount > 0 ||
                  footerLedger.ledgerAmount > 0 ||
                  location.state?.ledgerId ||
                  id ||
                  // cloneId ||
                  draftId ||
                  // salesOrderId ||
                  quotationId ||
                  batchData?.length ||
                  serialNoData.length ||
                  batchItmName) && (
                  <Row gutter={10} className="pt-10">
                    <Col xl={6} lg={8} md={24} xs={24}>
                      <Form.Item
                        name="narration"
                        className="m-0"
                        wrapperCol={{ span: 25 }}
                      >
                        <TextArea
                          autoSize={{ minRows: 2, maxRows: 4 }}
                          placeholder="Write narration"
                        />
                      </Form.Item>

                      <div style={{ marginTop: "10px" }}>
                        <Button
                          style={{ backgroundColor: "ButtonFace" }}
                          onClick={() => {
                            setOpenModel({
                              type: "termsAndConditionsModal",
                              param: { open: true },
                            });
                          }}
                        >
                          View and edit Terms and Conditions
                        </Button>
                      </div>
                      <Form.Item
                        name="attachments"
                        valuePropName="fileList"
                        getValueFromEvent={(e) => {
                          return e.fileList;
                        }}
                        // className="m-0"
                        style={{ paddingTop: "10px", margin: "0px" }}
                      >
                        <Upload
                          multiple
                          maxCount={2}
                          // accept={".png, .jpg, .jpeg, .pdf"}
                          // accept={".png, .jpg, .jpeg"}
                          beforeUpload={() => {
                            return false;
                          }}
                          onRemove={(e: any) => {
                            if ((id || draftId) && e?.id) {
                              setDeleteUploadId([...deleteUploadId, e?.id]);
                            }
                          }}
                          onPreview={(e: any) => {
                            console.log("preview", e);
                            if ((id || draftId) && e?.path) {
                              setPreviewImage({
                                isBaseConvert: false,
                                path: e,
                              });
                            } else if (e.type?.split("/")[0] === "image") {
                              setPreviewImage({
                                isBaseConvert: true,
                                path: e,
                              });
                            }
                          }}
                        >
                          <Button
                            icon={<UploadOutlined />}
                            style={{ backgroundColor: "ButtonFace" }}
                          >
                            Upload
                          </Button>
                        </Upload>
                      </Form.Item>
                    </Col>

                    <Col xl={10} xs={0}></Col>

                    {/* New Sales Invoice */}
                    <Col
                      xl={8}
                      lg={24}
                      md={24}
                      xs={24}
                      // style={{ paddingRight: 30 }}
                      className="pt-10"
                    >
                      <Row gutter={[0, 8]} style={{ marginTop: "5px" }}>
                        <Col lg={9} span={9}>
                          <span>Gross Total</span>
                        </Col>
                        <Col lg={15} span={15} className="textEnd">
                          <span>
                            ₹{" "}
                            {Utils.getFormattedNumber(
                              footerTotal.taxableAmount
                            )}
                          </span>
                        </Col>
                        {showFreightInsurance && (
                          <>
                            <Col lg={9} span={9}>
                              <span>Other Expenses</span>
                            </Col>
                            <Col lg={15} span={15} className="textEnd">
                              <span>
                                ₹{" "}
                                {Utils.getFormattedNumber(
                                  footerLedger.ledgerAmount
                                )}
                              </span>
                            </Col>
                          </>
                        )}
                        {footerTotal.discount > 0 && (
                          <>
                            <Col lg={9} span={9}>
                              <span>Trade Discount</span>
                            </Col>
                            <Col lg={15} span={15} className="textEnd">
                              <span>
                                - ₹{" "}
                                {Utils.getFormattedNumber(footerTotal.discount)}
                              </span>
                            </Col>
                          </>
                        )}
                        {(currentClient?.gstType === CompanyGSTTypes.Regular ||
                          updateTimeData.isGSTVoucher) && (
                          <>
                            {isStateSame &&
                            partyIsGstRegisteredSalesInvoice !==
                              CompanyGSTTypes.SEZ &&
                            partyIsGstRegisteredSalesInvoice !==
                              CompanyGSTTypes.Overseas ? (
                              <>
                                <Col lg={9} span={9}>
                                  <span>CGST</span>
                                </Col>
                                <Col lg={15} span={15} className="textEnd">
                                  <span>
                                    ₹{" "}
                                    {Utils.getFormattedNumber(
                                      (footerTotal.gst +
                                        footerLedger.ledgerGstAmount) /
                                        2
                                    )}
                                  </span>
                                </Col>
                                <Col lg={9} span={9}>
                                  <span>SGST</span>
                                </Col>
                                <Col lg={15} span={15} className="textEnd">
                                  <span>
                                    ₹{" "}
                                    {Utils.getFormattedNumber(
                                      (footerTotal.gst +
                                        footerLedger.ledgerGstAmount) /
                                        2
                                    )}
                                  </span>
                                </Col>
                              </>
                            ) : currentCustomerState ? (
                              <>
                                <Col lg={9} span={9}>
                                  <span>IGST</span>
                                </Col>
                                <Col lg={15} span={15} className="textEnd">
                                  <span>
                                    ₹{" "}
                                    {Utils.getFormattedNumber(
                                      footerTotal.gst +
                                        footerLedger.ledgerGstAmount
                                    )}
                                  </span>
                                </Col>
                              </>
                            ) : (
                              <></>
                            )}

                            {(isStateSame || currentCustomerState) &&
                              voucherNature === Voucher_Nature.RCM && (
                                <>
                                  <Col lg={12} span={11}>
                                    <span>Tax Under Reverse Charge</span>
                                  </Col>
                                  <Col lg={12} span={13} className="textEnd">
                                    <span>
                                      ₹{" "}
                                      {Utils.getFormattedNumber(
                                        footerTotal.gst +
                                          footerLedger.ledgerGstAmount
                                      )}
                                    </span>
                                  </Col>
                                </>
                              )}
                          </>
                        )}

                        <Divider className="grayBg" style={{ margin: "0px" }} />
                        <>
                          {/* <Divider className="my-0 grayBg" /> */}
                          <Col lg={9} span={9}>
                            <span>Sub Total</span>
                          </Col>
                          <Col lg={15} span={15} className="textEnd">
                            <span>
                              ₹{" "}
                              {Utils.getFormattedNumber(
                                footerTotal.taxableAmount +
                                  footerLedger.ledgerAmount +
                                  footerTotal.gst +
                                  footerLedger.ledgerGstAmount -
                                  footerTotal.discount
                              )}
                            </span>
                          </Col>
                        </>

                        {/* TCS & TDS Details */}
                        {/* {(totalTcs > 0 ||
                          totalTds > 0 ||
                          isPartTDSOrTDS.tds ||
                          isPartTDSOrTDS.tcs) && (
                          <>
                            <Col lg={17} span={15}>
                              <Row>
                                <Col lg={12} span={12}>
                                  <Radio.Group
                                    onChange={(e) => {
                                      setTotalTcs(0);
                                      setTotalTds(0);
                                      form.setFieldValue("tcsDetail", null);
                                      form.setFieldValue("tdsDetail", null);
                                      setTdsOrTcs(e.target.value);
                                      handleAllTheTotalValues(e.target.value);
                                    }}
                                    value={tdsOrTcs}
                                  >
                                    {(isPartTDSOrTDS.tds || totalTds > 0) && (
                                      <Radio value={0}>TDS</Radio>
                                    )}

                                    {(isPartTDSOrTDS.tcs || totalTcs > 0) && (
                                      <Radio value={1}>TCS</Radio>
                                    )}
                                  </Radio.Group>
                                </Col>
                                <Col lg={12} span={12}>
                                  {tdsOrTcs === 1 ? (
                                    <Row gutter={5}>
                                      <Col lg={18} span={18}>
                                        <Form.Item
                                          name="tcsDetail"
                                          className="m-0"
                                          wrapperCol={{
                                            span: 24,
                                          }}
                                        >
                                          <Select
                                            labelInValue
                                            placement="bottomRight"
                                            popupMatchSelectWidth={false}
                                            placeholder="Select Tcs"
                                            // disabled
                                            allowClear
                                            size="small"
                                            onChange={(e) => {
                                              if (e) {
                                                const tcsSelect = tcsList?.find(
                                                  (x) => x?.id === e?.value
                                                );
                                                // console.log("any", tcsSelect);
                                                form.setFieldValue(
                                                  "tcsDetail",
                                                  {
                                                    value: e?.value,
                                                    label: tcsSelect?.section,
                                                    title: tcsSelect?.rate,
                                                  }
                                                );
                                              } else {
                                                form.setFieldValue(
                                                  "tcsDetail",
                                                  null
                                                );
                                              }
                                              handleAllTheTotalValues();
                                            }}
                                            options={tcsList?.map(
                                              (value: any) => ({
                                                value: value?.id,
                                                label: (
                                                  <div>
                                                    <Col>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          color: "dimgray",
                                                        }}
                                                      >
                                                        {value?.section}
                                                      </p>
                                                    </Col>

                                                    <div>
                                                      <span>
                                                        {
                                                          value?.natureOfCollection
                                                        }
                                                      </span>
                                                    </div>
                                                  </div>
                                                ),
                                                title: value?.rate,
                                              })
                                            )}
                                            filterOption={(input, option) =>
                                              (option?.label?.toString() ?? "")
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                            }
                                          />
                                        </Form.Item>
                                      </Col>
                                      <Col
                                        lg={4}
                                        span={4}
                                        style={{ paddingTop: "2.5px" }}
                                      >
                                        {tcsTdsPercentage}%
                                      </Col>
                                    </Row>
                                  ) : tdsOrTcs === 0 ? (
                                    <Row gutter={5}>
                                      <Col lg={18} span={18}>
                                        <Form.Item
                                          name="tdsDetail"
                                          className="m-0"
                                          wrapperCol={{
                                            span: 24,
                                          }}
                                        >
                                          <Select
                                            labelInValue
                                            optionFilterProp="children"
                                            // disabled
                                            placeholder="Select Tds"
                                            placement="bottomRight"
                                            popupMatchSelectWidth={false}
                                            size="small"
                                            allowClear
                                            onChange={(e) => {
                                              if (e) {
                                                const tdsSelect = tdsList.find(
                                                  (x) => x?.id === e?.value
                                                );
                                                // console.log("any", tdsSelect, e);
                                                if (tdsSelect) {
                                                  form.setFieldValue(
                                                    "tdsDetail",
                                                    {
                                                      value: e?.value,
                                                      label: tdsSelect?.section,
                                                      title:
                                                        tdsSelect?.rateDetail,
                                                    }
                                                  );
                                                  setTdsPostDetail({
                                                    id: e?.value,
                                                    formNo: tdsSelect?.form,
                                                    transactionType:
                                                      tdsSelect?.transactionType,
                                                  });
                                                }
                                              } else {
                                                form.setFieldValue(
                                                  "tdsDetail",
                                                  null
                                                );
                                                setTdsPostDetail({
                                                  id: "",
                                                  formNo: "",
                                                  transactionType:
                                                    Transaction_Type.Domestic,
                                                });
                                              }
                                              handleAllTheTotalValues();
                                            }}
                                            options={tdsList?.map(
                                              (value: any) => ({
                                                value: value?.id,
                                                label: (
                                                  <div>
                                                    <Col>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          color: "dimgray",
                                                        }}
                                                      >
                                                        {value?.section}
                                                      </p>
                                                    </Col>

                                                    <div>
                                                      <span>
                                                        {value?.natureOfPayment}
                                                      </span>
                                                    </div>
                                                  </div>
                                                ),
                                                title:
                                                  value?.TransactionType ===
                                                  Transaction_Type.Domestic
                                                    ? value?.domesticSegment
                                                    : value?.internationalSegment,
                                              })
                                            )}
                                            filterOption={(input, option) =>
                                              (option?.label?.toString() ?? "")
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                            }
                                          />
                                        </Form.Item>
                                      </Col>
                                      <Col
                                        lg={4}
                                        span={4}
                                        style={{ paddingTop: "2.5px" }}
                                      >
                                        {tcsTdsPercentage}%
                                      </Col>
                                    </Row>
                                  ) : (
                                    <></>
                                  )}
                                </Col>
                              </Row>
                            </Col>

                            {tdsOrTcs === 1 ? (
                              <Col lg={7} span={9} className="textEnd">
                                <span>
                                  ₹ {Utils.getFormattedNumber(totalTcs)}
                                </span>
                              </Col>
                            ) : tdsOrTcs === 0 ? (
                              <Col lg={7} span={9} className="textEnd">                               
                                <InputNumber
                                  disabled={tdsPostDetail?.id ? false : true}
                                  step={0.01}
                                  precision={2}
                                  className="inputNumberTextEnd"
                                  size="small"
                                  type="number"
                                  controls={false}
                                  placeholder="0.0"
                                  value={totalTds}
                                  // onFocus={(e) => {
                                  //   handleInputFocus(e, form);
                                  // }}
                                  min={0}
                                  style={{
                                    width: "100%",
                                  }}
                                  onChange={(e: number | null) => {
                                    if (e || e === 0) {
                                      setTotalTds(e);
                                      // const roundOffAmount = handleRoundoff(
                                      //   totalPaymentIn +
                                      //     (splitPathInVchType ===
                                      //     Voucher_Type.Receipt
                                      //       ? e
                                      //       : -e),
                                      //   form.getFieldValue(
                                      //     "roundoffCheckbox"
                                      //   ),
                                      //   settingControl.roundOffType
                                      // );

                                      // form.setFieldValue(
                                      //   "roundOff",
                                      //   roundOffAmount
                                      // );
                                      // setRoundoffAmount(roundOffAmount);
                                    }
                                  }}
                                  // onKeyPress={handleDecimalValues}
                                />
                              </Col>
                            ) : (
                              <></>
                            )}
                          </>
                        )} */}

                        {(settingControl.autoRoundOff ||
                          updateTimeData.roundOff) && (
                          <>
                            <Col
                              lg={5}
                              span={5}
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <span>Round off</span>
                            </Col>

                            <Col lg={4} span={4}>
                              <Form.Item
                                valuePropName="checked"
                                name="roundoffCheckbox"
                                className="inputBoxMb"
                              >
                                <Checkbox
                                  onChange={() => {
                                    const roundOffAmount = handleRoundoff(
                                      voucherNature === Voucher_Nature.RCM
                                        ? footerTotal.taxableAmount +
                                            footerLedger.ledgerAmount +
                                            totalTcs -
                                            footerTotal.discount
                                        : footerTotal.amount +
                                            footerLedger.ledgerTotalAmount +
                                            totalTcs,
                                      form.getFieldValue("roundoffCheckbox"),
                                      settingControl.roundOffType
                                    );

                                    form.setFieldValue(
                                      "roundOff",
                                      roundOffAmount
                                    );
                                    setRoundoffAmount(roundOffAmount);
                                  }}
                                />
                              </Form.Item>
                            </Col>

                            <Col
                              lg={15}
                              span={15}
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Form.Item
                                className="discountInput inputBoxMb textEnd"
                                name="roundOff"
                                wrapperCol={{ span: "25" }}
                              >
                                <InputNumber
                                  step={0.01}
                                  precision={2}
                                  className="inputNumberTextEnd"
                                  size="small"
                                  controls={false}
                                  placeholder="0.0"
                                  max={
                                    voucherNature === Voucher_Nature.RCM
                                      ? footerTotal.taxableAmount +
                                        footerLedger.ledgerAmount +
                                        totalTcs -
                                        footerTotal.discount
                                      : footerTotal.amount +
                                        footerLedger.ledgerTotalAmount +
                                        totalTcs
                                  }
                                  min={
                                    voucherNature === Voucher_Nature.RCM
                                      ? -(
                                          footerTotal.taxableAmount +
                                          footerLedger.ledgerAmount +
                                          totalTcs -
                                          footerTotal.discount
                                        )
                                      : -(
                                          footerTotal.amount +
                                          footerLedger.ledgerTotalAmount +
                                          totalTcs
                                        )
                                  }
                                  style={{
                                    width: "100%",
                                  }}
                                  onChange={(e: any) => {
                                    setRoundoffAmount(e);
                                  }}
                                  onFocus={(e) => {
                                    handleInputFocus(e, form);
                                  }}
                                  onKeyPress={handleDecimalValues}
                                />
                              </Form.Item>
                            </Col>
                          </>
                        )}
                        {(totalTcs > 0 || totalTds > 0) && (
                          <>
                            <Col lg={6} span={6}>
                              <span>Sub Total</span>
                            </Col>

                            <Col lg={18} span={18} className="textEnd">
                              <span>
                                ₹{" "}
                                {voucherNature === Voucher_Nature.RCM
                                  ? Utils.getFormattedNumber(
                                      footerTotal.taxableAmount +
                                        footerLedger.ledgerAmount -
                                        footerTotal.discount +
                                        totalTcs -
                                        totalTds +
                                        roundOffAmount
                                    )
                                  : Utils.getFormattedNumber(
                                      footerTotal.amount +
                                        footerLedger.ledgerTotalAmount +
                                        totalTcs -
                                        totalTds +
                                        roundOffAmount
                                    )}
                              </span>
                              {/* {Utils.getFormattedNumber(cashDiscount)} */}
                            </Col>
                          </>
                        )}
                      </Row>

                      <Divider className="my-5 grayBg" />

                      <Row gutter={[12, 2]}>
                        <>
                          {/* <Row
                        gutter={8}
                        style={{ display: "flex", justifyContent: "end" }}
                      > */}

                          {/* </Row>                       */}
                        </>
                        <Col
                          lg={11}
                          span={11}
                          style={{ fontWeight: 600, fontSize: "16px" }}
                        >
                          <span>Total Amount</span>
                        </Col>
                        <Col
                          lg={13}
                          span={13}
                          className="textEnd"
                          style={{ fontWeight: 600, fontSize: "16px" }}
                        >
                          <span>
                            ₹{" "}
                            {Utils.getFormattedNumber(
                              voucherNature === Voucher_Nature.RCM
                                ? footerTotal.taxableAmount +
                                    footerLedger.ledgerAmount +
                                    totalTcs +
                                    roundOffAmount -
                                    footerTotal.discount
                                : Utils.getNumber(footerTotal.amount) +
                                    Utils.getNumber(
                                      footerLedger.ledgerTotalAmount
                                    ) +
                                    totalTcs +
                                    roundOffAmount
                            )}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                )}
              </Form>
            </div>
          </Content>
          <Footer
            style={{
              bottom: 0,
              position: "fixed",
              width: "100%",
              background: "#fff",
              marginLeft: "-14px",
              zIndex: 999,
              height: "45px",
              lineHeight: "45px",
            }}
          >
            <Row justify="center" style={{ marginLeft: "54%" }}>
              <Col className="ps-14" style={{ marginBottom: "20px" }}>
                <Tooltip
                  title={<p>ALT+C</p>}
                  placement="topLeft"
                  open={showKeys}
                >
                  <Button
                    onClick={() => {
                      if (
                        Utils.getNumber(footerTotal.amount) +
                          Utils.getNumber(footerLedger.ledgerTotalAmount) +
                          roundOffAmount >
                          0 &&
                        !id &&
                        selectedParty &&
                        form.getFieldValue("effectiveLedger")
                      ) {
                        saveOrder(false, true);
                      }
                      navigate(-1);
                    }}
                  >
                    Cancel
                  </Button>
                </Tooltip>
              </Col>
              <Col className="ps-14" style={{ paddingTop: "7px" }}>
                <Form.Item>
                  <Tooltip
                    title={<p>ALT+S</p>}
                    placement="topLeft"
                    open={showKeys}
                  >
                    <Button
                      type="primary"
                      loading={saveButtonLoading}
                      onClick={() => {
                        saveOrder(false);
                      }}
                    >
                      {id ? "Update" : "Save"}
                    </Button>
                  </Tooltip>
                </Form.Item>
              </Col>
            </Row>
          </Footer>
        </Layout>
      </Spin>

      {openModel.type === "addItem" && (
        <AddItems
          open={openModel?.param.open}
          onCancel={() => setOpenModel({ type: "", param: "" })}
          id={itemId}
          setNewItem={setNewItem}
        />
      )}
      {openModel.type === "addLedger" && (
        <AddLedger
          openDrawer={openModel?.param.open}
          id={editParty?.id}
          setOpenDrawer={() => setOpenModel({ type: "", param: "" })}
          type={openModel?.param?.ledgerByGroupsType}
          setAddLedgerResponse={setAddLedgerResponse}
          defaultGroup={openModel?.param?.defaultGroup}
          showName={openModel?.param?.showName}
        />
      )}
      {previewImage.path && (
        <DocumentPreview
          open={true}
          onCancel={() =>
            setPreviewImage({
              path: "",
              isBaseConvert: false,
              // uploadType: "",
            })
          }
          documentDetails={previewImage}
        />
      )}
      {openModel.type === "termsAndConditionsModal" && (
        <TermsAndConditionModal
          open={openModel.param.open}
          onCancel={() => setOpenModel({ type: "", param: { open: false } })}
          setTermsAndConditionField={setTermsAndConditionField}
          termsAndConditionField={termsAndConditionField}
          voucherType={splitPathInVchType}
          voucherTitleCustomization={getVoucherTitle?.id!}
        />
      )}
    </div>
  );
};
export default AddOrderEstimateProformaInvoice;
